webpackJsonp([0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	__webpack_require__(1);
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(8);
	
	__webpack_require__(9);
	
	var _videoplayerUi = __webpack_require__(10);
	
	var _videoplayerUi2 = _interopRequireDefault(_videoplayerUi);
	
	var _appComponent = __webpack_require__(23);
	
	var _appComponent2 = _interopRequireDefault(_appComponent);
	
	var _componentsComponents = __webpack_require__(27);
	
	var _componentsComponents2 = _interopRequireDefault(_componentsComponents);
	
	var _servicesServices = __webpack_require__(247);
	
	var _servicesServices2 = _interopRequireDefault(_servicesServices);
	
	var _filtersFilters = __webpack_require__(272);
	
	var _filtersFilters2 = _interopRequireDefault(_filtersFilters);
	
	var _appConfig = __webpack_require__(274);
	
	var _appConfig2 = _interopRequireDefault(_appConfig);
	
	var _appRun = __webpack_require__(275);
	
	var _appRun2 = _interopRequireDefault(_appRun);
	
	__webpack_require__(276);
	
	var localConfig = __webpack_require__(277);
	
	var app = _angular2['default'].module('app', [_angularUiRouter2['default'], _componentsComponents2['default'].name, _servicesServices2['default'].name, _videoplayerUi2['default'], 'ct.ui.router.extras.sticky', _filtersFilters2['default'].name]).config(_appConfig2['default']).run(_appRun2['default']).component('app', _appComponent2['default']);
	
	// used in pagination
	app.filter('startFrom', function () {
	  return function (input, start) {
	    start = parseInt(start, 10);
	    return input.slice(start);
	  };
	});
	
	/*
	 Bootstrap the app with properties from underlying java app before starting angular app.
	 Instead of automatically bootstrapping angular app from ng-app in html, manually bootstrap
	 after first receiving response from /properties endpoint.
	 https://blog.mariusschulz.com/2014/10/22/asynchronously-bootstrapping-angularjs-applications-with-server-side-data
	 */
	function loadConfiguration() {
	  var injector = _angular2['default'].injector(['ng'], true);
	  var $http = injector.get('$http');
	
	  return $http.get('/properties').then(function (res) {
	    _angular2['default'].module('config', []).value('config', res.data);
	  }, function () {
	    console.warn('## CONFIG ## Properties endpoint unreachable, using default properties.');
	    _angular2['default'].module('config', []).value('config', localConfig);
	  });
	}
	
	function getProfile() {
	  var injector = _angular2['default'].injector(['ng', 'profileService', 'auth.authInterceptor'], true);
	  var profileService = injector.get('profileService');
	  var localService = injector.get('localService');
	  var storageKeys = injector.get('storageKeys');
	
	  return profileService.getProfile().then(function (profile) {
	    localService.set(storageKeys.profile, profile.data);
	    var region = localService.get(storageKeys.selectedRegion);
	    if (!region) {
	      region = profile.data.region;
	      if (region) {
	        localService.set(storageKeys.selectedRegion, region);
	      }
	    }
	  });
	}
	
	function getRegions() {
	  var injector = _angular2['default'].injector(['ng', 'regionService', 'auth.authInterceptor'], true);
	  var regionService = injector.get('regionService');
	  var localService = injector.get('localService');
	  var storageKeys = injector.get('storageKeys');
	
	  return regionService.getRegions().then(function (regions) {
	    localService.set(storageKeys.regions, regions.data);
	  });
	}
	
	function authorizeUser() {
	  var injector = _angular2['default'].injector(['ng', 'config', 'auth'], true);
	  var $q = injector.get('$q');
	  var $timeout = injector.get('$timeout');
	  var authService = injector.get('authService');
	  // check token expiry every 10 mins and re-authorize if needed
	  $timeout(function () {
	    console.log('## AUTH ## Re-Authorize');
	    authorizeUser();
	  }, 10 * 60 * 1000);
	
	  return $q(function (resolve, reject) {
	    authService.authorize().then(function (token) {
	      console.info('## AUTH ## Success', token);
	      resolve(token);
	    }, function (reason) {
	      console.error('## AUTH ## Failure', reason);
	      reject(reason);
	      document.getElementsByClassName('loading')[0].innerText = 'Sorry, the 612 service failed to load. ' + 'Please try again.';
	    });
	  });
	}
	
	function appBootstrap() {
	  _angular2['default'].bootstrap(document, ['app'], { strictDi: true });
	  console.log('## APP ## Bootstrapped');
	}
	
	// Pre-Bootstrap Data Loader phase
	loadConfiguration().then(authorizeUser).then(function () {
	  var injector = _angular2['default'].injector(['ng'], true);
	  var $q = injector.get('$q');
	  return $q.all([getProfile(), getRegions()]);
	}).then(function () {
	  console.log('## APP ## Ready');
	}).then(appBootstrap);

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _appHtml = __webpack_require__(24);
	
	var _appHtml2 = _interopRequireDefault(_appHtml);
	
	__webpack_require__(25);
	
	var appComponent = {
	  template: _appHtml2['default'],
	  restrict: 'E'
	};
	
	exports['default'] = appComponent;
	module.exports = exports['default'];

/***/ },
/* 24 */
/***/ function(module, exports) {

	module.exports = "<!-- Place all UI elements intended to be present across all routes in this file -->\n<div class=\"app\">\n  <div ui-view=\"home\" ng-show=\"$root.$state.includes('app.home')\"></div>\n  <div ui-view></div>\n</div>\n"

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(26);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js!./../../node_modules/sass-loader/index.js!./app.scss", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js!./../../node_modules/sass-loader/index.js!./app.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "h1{font-family:Roboto,Helvetica,Arial,sans-serif;font-size:4.3vmin;font-weight:500;line-height:9vmin}h1,h2{margin:0}h2{font-family:Roboto Condensed,Arial Narrow,Helvetica,Arial,sans-serif;font-size:3.5vmin;font-weight:400}.section{clear:both;padding:0;margin:0}.group:after,.group:before{content:\"\";display:table}.group:after{clear:both}.group{zoom:1}.col{display:block;float:left;margin:1% 0}.col:first-child{margin-left:0}.col-2-2{width:100%}.col-1-2{width:49.2%}.col-3-3{width:100%}.col-2-3{width:66.1%}.col-1-3{width:32.2%}.col-4-4{width:100%}.col-3-4{width:74.6%}.col-2-4{width:49.2%}.col-1-4{width:23.8%}.app{height:100vh;width:100vw;background-color:#4863a0;-webkit-font-smoothing:subpixel-antialiased;-moz-osx-font-smoothing:grayscale;font-family:Roboto,Helvetica,Arial,sans-serif;color:#e8e8e8}.app .container{height:100%;width:90%;margin:0 5%;display:block}", ""]);
	
	// exports


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	// Layouts
	
	var _commonPageLayoutPageLayout = __webpack_require__(28);
	
	var _commonPageLayoutPageLayout2 = _interopRequireDefault(_commonPageLayoutPageLayout);
	
	var _commonPageLayoutSecondaryPageLayoutSecondary = __webpack_require__(39);
	
	var _commonPageLayoutSecondaryPageLayoutSecondary2 = _interopRequireDefault(_commonPageLayoutSecondaryPageLayoutSecondary);
	
	// Pages
	
	var _homeHome = __webpack_require__(45);
	
	var _homeHome2 = _interopRequireDefault(_homeHome);
	
	var _photosHomeLandingPhotosHomeLanding = __webpack_require__(51);
	
	var _photosHomeLandingPhotosHomeLanding2 = _interopRequireDefault(_photosHomeLandingPhotosHomeLanding);
	
	var _trafficHomeLandingTrafficHomeLanding = __webpack_require__(57);
	
	var _trafficHomeLandingTrafficHomeLanding2 = _interopRequireDefault(_trafficHomeLandingTrafficHomeLanding);
	
	var _trafficTraffic = __webpack_require__(63);
	
	var _trafficTraffic2 = _interopRequireDefault(_trafficTraffic);
	
	var _regionSelectionLandingRegionSelectionLanding = __webpack_require__(69);
	
	var _regionSelectionLandingRegionSelectionLanding2 = _interopRequireDefault(_regionSelectionLandingRegionSelectionLanding);
	
	var _enlargedLivefeedEnlargedLivefeed = __webpack_require__(75);
	
	var _enlargedLivefeedEnlargedLivefeed2 = _interopRequireDefault(_enlargedLivefeedEnlargedLivefeed);
	
	var _closingsDelaysLandingClosingsDelaysLanding = __webpack_require__(81);
	
	var _closingsDelaysLandingClosingsDelaysLanding2 = _interopRequireDefault(_closingsDelaysLandingClosingsDelaysLanding);
	
	var _videoplayerVideoplayer = __webpack_require__(87);
	
	var _videoplayerVideoplayer2 = _interopRequireDefault(_videoplayerVideoplayer);
	
	// Shared Components
	
	var _weatherHomeLandingWeatherHomeLanding = __webpack_require__(97);
	
	var _weatherHomeLandingWeatherHomeLanding2 = _interopRequireDefault(_weatherHomeLandingWeatherHomeLanding);
	
	var _commonRegionSelectionRegionSelection = __webpack_require__(103);
	
	var _commonRegionSelectionRegionSelection2 = _interopRequireDefault(_commonRegionSelectionRegionSelection);
	
	var _commonNews12ButtonNews12Button = __webpack_require__(109);
	
	var _commonNews12ButtonNews12Button2 = _interopRequireDefault(_commonNews12ButtonNews12Button);
	
	var _commonPageLayoutWTPageLayoutWT = __webpack_require__(115);
	
	var _commonPageLayoutWTPageLayoutWT2 = _interopRequireDefault(_commonPageLayoutWTPageLayoutWT);
	
	var _commonLiveFeedVideoLiveFeedVideo = __webpack_require__(121);
	
	var _commonLiveFeedVideoLiveFeedVideo2 = _interopRequireDefault(_commonLiveFeedVideoLiveFeedVideo);
	
	var _commonHeaderMainHeaderMain = __webpack_require__(127);
	
	var _commonHeaderMainHeaderMain2 = _interopRequireDefault(_commonHeaderMainHeaderMain);
	
	var _commonHeaderSecondaryHeaderSecondary = __webpack_require__(133);
	
	var _commonHeaderSecondaryHeaderSecondary2 = _interopRequireDefault(_commonHeaderSecondaryHeaderSecondary);
	
	var _commonNavbarNavbar = __webpack_require__(139);
	
	var _commonNavbarNavbar2 = _interopRequireDefault(_commonNavbarNavbar);
	
	var _commonNavbarSubMenuNavbarSubMenu = __webpack_require__(145);
	
	var _commonNavbarSubMenuNavbarSubMenu2 = _interopRequireDefault(_commonNavbarSubMenuNavbarSubMenu);
	
	var _commonStoryListStoryList = __webpack_require__(151);
	
	var _commonStoryListStoryList2 = _interopRequireDefault(_commonStoryListStoryList);
	
	var _commonNewsTickerNewsTicker = __webpack_require__(157);
	
	var _commonNewsTickerNewsTicker2 = _interopRequireDefault(_commonNewsTickerNewsTicker);
	
	var _commonLogoLogo = __webpack_require__(163);
	
	var _commonLogoLogo2 = _interopRequireDefault(_commonLogoLogo);
	
	var _commonOtherRegionsOtherRegions = __webpack_require__(169);
	
	var _commonOtherRegionsOtherRegions2 = _interopRequireDefault(_commonOtherRegionsOtherRegions);
	
	var _commonPollPoll = __webpack_require__(175);
	
	var _commonPollPoll2 = _interopRequireDefault(_commonPollPoll);
	
	var _commonWeatherIconsWeatherIcons = __webpack_require__(181);
	
	var _commonWeatherIconsWeatherIcons2 = _interopRequireDefault(_commonWeatherIconsWeatherIcons);
	
	var _commonPhotoGalleryPhotoGallery = __webpack_require__(187);
	
	var _commonPhotoGalleryPhotoGallery2 = _interopRequireDefault(_commonPhotoGalleryPhotoGallery);
	
	var _commonNews12ListNews12List = __webpack_require__(193);
	
	var _commonNews12ListNews12List2 = _interopRequireDefault(_commonNews12ListNews12List);
	
	var _commonPhotoListPhotoList = __webpack_require__(199);
	
	var _commonPhotoListPhotoList2 = _interopRequireDefault(_commonPhotoListPhotoList);
	
	var _commonIncidentListIncidentList = __webpack_require__(205);
	
	var _commonIncidentListIncidentList2 = _interopRequireDefault(_commonIncidentListIncidentList);
	
	var _commonArchivesArchives = __webpack_require__(211);
	
	var _commonArchivesArchives2 = _interopRequireDefault(_commonArchivesArchives);
	
	var _commonNews12AdNews12Ad = __webpack_require__(217);
	
	var _commonNews12AdNews12Ad2 = _interopRequireDefault(_commonNews12AdNews12Ad);
	
	var _commonCameraListCameraList = __webpack_require__(223);
	
	var _commonCameraListCameraList2 = _interopRequireDefault(_commonCameraListCameraList);
	
	var _commonCameraGalleryCameraGallery = __webpack_require__(229);
	
	var _commonCameraGalleryCameraGallery2 = _interopRequireDefault(_commonCameraGalleryCameraGallery);
	
	var _commonMapGalleryMapGallery = __webpack_require__(235);
	
	var _commonMapGalleryMapGallery2 = _interopRequireDefault(_commonMapGalleryMapGallery);
	
	var _commonPrerollPreroll = __webpack_require__(241);
	
	var _commonPrerollPreroll2 = _interopRequireDefault(_commonPrerollPreroll);
	
	var componentModule = _angular2['default'].module('app.components', [
	//-----------------------------------
	// Layouts
	//-----------------------------------
	_commonPageLayoutPageLayout2['default'].name, _commonPageLayoutSecondaryPageLayoutSecondary2['default'].name, _commonPageLayoutWTPageLayoutWT2['default'].name,
	//-----------------------------------
	// Pages
	//-----------------------------------
	_homeHome2['default'].name, _photosHomeLandingPhotosHomeLanding2['default'].name, _trafficTraffic2['default'].name, _regionSelectionLandingRegionSelectionLanding2['default'].name, _weatherHomeLandingWeatherHomeLanding2['default'].name, _trafficHomeLandingTrafficHomeLanding2['default'].name, _enlargedLivefeedEnlargedLivefeed2['default'].name, _videoplayerVideoplayer2['default'].name, _closingsDelaysLandingClosingsDelaysLanding2['default'].name,
	//-----------------------------------
	// Shared Components
	//-----------------------------------
	_commonNews12ButtonNews12Button2['default'].name, _commonHeaderMainHeaderMain2['default'].name, _commonHeaderSecondaryHeaderSecondary2['default'].name, _commonNavbarNavbar2['default'].name, _commonNavbarSubMenuNavbarSubMenu2['default'].name, _commonRegionSelectionRegionSelection2['default'].name, _commonLiveFeedVideoLiveFeedVideo2['default'].name, _commonStoryListStoryList2['default'].name, _commonNewsTickerNewsTicker2['default'].name, _commonLogoLogo2['default'].name, _commonOtherRegionsOtherRegions2['default'].name, _commonPollPoll2['default'].name, _commonWeatherIconsWeatherIcons2['default'].name, _commonPhotoGalleryPhotoGallery2['default'].name, _commonNews12ListNews12List2['default'].name, _commonPhotoListPhotoList2['default'].name, _commonArchivesArchives2['default'].name, _commonNews12AdNews12Ad2['default'].name, _commonIncidentListIncidentList2['default'].name, _commonCameraListCameraList2['default'].name, _commonCameraGalleryCameraGallery2['default'].name, _commonMapGalleryMapGallery2['default'].name, _commonCameraGalleryCameraGallery2['default'].name, _commonPrerollPreroll2['default'].name]);
	
	exports['default'] = componentModule;
	module.exports = exports['default'];

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _pageLayoutComponent = __webpack_require__(29);
	
	var _pageLayoutComponent2 = _interopRequireDefault(_pageLayoutComponent);
	
	var pageLayoutModule = _angular2['default'].module('pageLayout', [_angularUiRouter2['default'], 'constants', 'app.services']).component('pageLayout', _pageLayoutComponent2['default']);
	
	exports['default'] = pageLayoutModule;
	module.exports = exports['default'];

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _pageLayoutHtml = __webpack_require__(30);
	
	var _pageLayoutHtml2 = _interopRequireDefault(_pageLayoutHtml);
	
	var _pageLayoutController = __webpack_require__(31);
	
	var _pageLayoutController2 = _interopRequireDefault(_pageLayoutController);
	
	__webpack_require__(37);
	
	exports['default'] = {
	  restrict: 'E',
	  transclude: true,
	  bindings: {
	    page: '@',
	    title: '@',
	    headerConfig: '<',
	    hideHeader: '<',
	    hideSideBar: '<',
	    hideFooter: '<',
	    wideView: '<',
	    currentRegion: '<'
	  },
	  template: _pageLayoutHtml2['default'],
	  controller: _pageLayoutController2['default'],
	  controllerAs: 'vm'
	};
	module.exports = exports['default'];

/***/ },
/* 30 */
/***/ function(module, exports) {

	module.exports = "<header-main ng-show=\"!vm.hideHeader\"\n             header-config=\"vm.headerConfig\"\n             nav-items=\"vm.navItems\"\n             selected-index=\"vm.selectedIndex\"\n             on-nav-select=\"vm.navSelect(item)\"\n             region= \"vm.currentRegion\"\n></header-main>\n\n<section class=\"n12-main-body\" ng-class=\"vm.wideView ? '' : 'main-body-dark-line'\"> <!-- Custom ng-class will show/hide dark blue line at bottom of page -->\n  <div class=\"left-aside\" ng-class=\"{ wide: vm.hideSideBar || vm.wideView }\">\n    <h1 class=\"aside-header\" ng-bind-html=\"vm.title\"></h1>\n    <div class=\"aside-content main-content\" ng-transclude ng-class=\"{'hide-footer': vm.hideFooter}\">\n\n      <!-- Content Block -->\n\n    </div>\n\n    <div class=\"bottom-promo\" ng-if=\"!vm.wideView\">\n      <!-- Home center banner Ad -->\n      <news12-ad region=\"vm.currentRegion\" section=\"vm.adProps.home.sectionName\" ad-location=\"vm.adProps.home.bottomBannerLocation\" on-ad-select=\"vm.selectedLocation(event, location)\"></news12-ad>\n    </div>\n\n  </div>\n\n  <div class=\"right-aside\" ng-if=\"!vm.hideSideBar && !vm.wideView\">\n    <div class=\"aside-content\">\n      <weather-icons region=\"vm.currentRegion\"></weather-icons>\n      <div class=\"live-feed-container\">\n        <live-feed-video feed-config=\"vm.feedConfig\"\n                         on-select=\"vm.enlargeVideo()\"\n                         on-ready=\"vm.onLiveFeedReady(liveFeed)\"\n                         enlarge-keydown=\"vm.remoteKeyDownEnlargeBtn(event)\"\n        ></live-feed-video>\n      </div>\n\n      <div class=\"right-promo\">\n        <!-- Home Right Ad -->\n        <news12-ad region=\"vm.currentRegion\" section=\"vm.adProps.home.sectionName\" ad-location=\"vm.adProps.home.rightBannerLocation\" on-ad-select=\"vm.selectedLocation(event, location)\"></news12-ad>\n      </div>\n\n    </div>\n  </div>\n</section>\n\n<footer  ng-if=\"!vm.hideFooter\">\n  <div class=\"long-promo-banner\"></div>\n</footer>\n"

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _pubsubJs = __webpack_require__(32);
	
	var _pubsubJs2 = _interopRequireDefault(_pubsubJs);
	
	var _keycodeUi = __webpack_require__(33);
	
	var _keycodeUi2 = _interopRequireDefault(_keycodeUi);
	
	var _lodash = __webpack_require__(35);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var deps = {};
	/*---------------------------------------------------------*\
	 * OtherRegionsController
	\*---------------------------------------------------------*/
	
	var PageLayoutController = (function () {
	  //-----------------------------------
	  // Constructor
	  //-----------------------------------
	
	  function PageLayoutController($scope, $state, localService, storageKeys, states, topics, livefeedService, adProps, navigationService, $timeout, $document) {
	    var _this = this;
	
	    _classCallCheck(this, PageLayoutController);
	
	    deps.$state = $state;
	    deps.states = states;
	    deps.topics = topics;
	    deps.localService = localService;
	    deps.storageKeys = storageKeys;
	    deps.navigationService = navigationService;
	    deps.$timeout = $timeout;
	    deps.$document = $document[0];
	    this.name = 'pageLayout';
	    this.liveFeed = null;
	    this.feedConfig = {
	      story: {
	        videoUrl: livefeedService.getLivefeed()
	      }
	    };
	    this.adProps = adProps;
	
	    var token1 = _pubsubJs2['default'].subscribe(deps.topics.state.reactivate, function () {
	      if (_this.liveFeed) {
	        _this.liveFeed.initVideo();
	        _this.liveFeed.play();
	      }
	    });
	
	    var token2 = _pubsubJs2['default'].subscribe(deps.topics.state.inactivate, function () {
	      if (_this.liveFeed) {
	        _this.liveFeed.stop();
	      }
	    });
	
	    var token3 = _pubsubJs2['default'].subscribe(this.adProps.home.previousElement, function (msg, data) {
	      _this.adFocus = data.previousElement;
	    });
	
	    $scope.$on('$destroy', function () {
	      _pubsubJs2['default'].unsubscribe(token1);
	      _pubsubJs2['default'].unsubscribe(token2);
	      _pubsubJs2['default'].unsubscribe(token3);
	    });
	  }
	
	  //-----------------------------------
	  // Properties
	  //-----------------------------------
	
	  _createClass(PageLayoutController, [{
	    key: 'enlargeVideo',
	
	    //-----------------------------------
	    // Methods
	    //-----------------------------------
	
	    value: function enlargeVideo() {
	      deps.$state.go(deps.states.enlargedLiveFeed, { currentStory: this.feedConfig });
	    }
	  }, {
	    key: 'onLiveFeedReady',
	    value: function onLiveFeedReady(liveFeed) {
	      this.liveFeed = liveFeed;
	    }
	  }, {
	    key: 'remoteKeyDownEnlargeBtn',
	    value: function remoteKeyDownEnlargeBtn(event) {
	      if (_keycodeUi2['default'].isUp(event)) {
	        event.preventDefault();
	        deps.navigationService.focusEl('navbar', 'last');
	      } else if (_keycodeUi2['default'].isLeft(event)) {
	        event.preventDefault();
	        var pollCheck = !!deps.$document.querySelector('.poll-result');
	        if (pollCheck) {
	          deps.navigationService.focusEl('.main-menu-btn');
	        } else {
	          deps.navigationService.focusEl('.main-content', 1);
	        }
	      }
	    }
	  }, {
	    key: 'selectedLocation',
	    value: function selectedLocation(event, location) {
	      if (location === this.adProps.home.bottomBannerLocation) {
	        if (_keycodeUi2['default'].isUp(event)) {
	          event.preventDefault();
	          if (this.adFocus !== event.target && !_lodash2['default'].isUndefined(this.adFocus)) {
	            this.adFocus.focus();
	          } else if (deps.$document.querySelector('.btngroup')) {
	            deps.navigationService.focusEl('.btngroup', 'first');
	          } else {
	            var regionsCheck = deps.$document.querySelectorAll('other-regions button');
	            deps.navigationService.focusEl('.main-content', !_lodash2['default'].isUndefined(regionsCheck) ? regionsCheck.length : 1);
	          }
	        } else if (_keycodeUi2['default'].isRight(event)) {
	          this.adFocus = event.target;
	        }
	      } else if (location === this.adProps.home.rightBannerLocation) {
	        if (_keycodeUi2['default'].isLeft(event)) {
	          event.preventDefault();
	          if (deps.$document.querySelector('.btngroup')) {
	            deps.navigationService.focusEl('.main-menu-btn');
	          } else {
	            deps.navigationService.focusEl('.footer_center');
	          }
	        }
	      }
	    }
	  }, {
	    key: 'region',
	    get: function get() {
	      var _region = deps.localService.get(deps.storageKeys.selectedRegion);
	      return _region ? _region.abbr : 'LI';
	    }
	  }]);
	
	  return PageLayoutController;
	})();
	
	PageLayoutController.$inject = ['$scope', '$state', 'localService', 'storageKeys', 'states', 'topics', 'livefeedService', 'adProps', 'navigationService', '$timeout', '$document'];
	
	exports['default'] = PageLayoutController;
	module.exports = exports['default'];

/***/ },
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(38);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/sass-loader/index.js!./pageLayout.scss", function() {
				var newContent = require("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/sass-loader/index.js!./pageLayout.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "page-layout{height:100vh;width:100vw}page-layout header-main{position:absolute;top:8.9vh;width:100%;height:15%}page-layout footer{position:absolute;bottom:1vh;width:96.4vw;height:6.2vh}page-layout weather-icons{width:100%;height:9vh}page-layout .n12-main-body{position:absolute;top:23.7vh;width:100%;height:67vh}page-layout .n12-main-body .left-aside,page-layout .n12-main-body .right-aside{height:100%;display:inline-block;float:left}page-layout .n12-main-body .left-aside .aside-content,page-layout .n12-main-body .right-aside .aside-content{height:9vh}page-layout .n12-main-body .left-aside{width:75vw}page-layout .n12-main-body .left-aside.wide{width:100vw}page-layout .n12-main-body .left-aside.wide .aside-content{width:auto;border-right:none}page-layout .n12-main-body .left-aside .aside-header{margin-left:7.6vw;display:inline}page-layout .n12-main-body .left-aside .aside-content{position:relative;width:100%;height:46.6vh;background-color:#0f143a;border-top:.25vmin solid #a5b3d3;border-bottom:.25vmin solid #a5b3d3;border-right:.25vmin solid #a5b3d3}page-layout .n12-main-body .left-aside .hide-footer{height:60vh}page-layout .n12-main-body .right-aside{width:20vw;margin-left:1.4vw;height:100%;padding:0}page-layout .n12-main-body .right-aside .aside-content{height:100%;position:relative}page-layout .main-body-dark-line{background:linear-gradient(transparent 83.3%,#0f143a 0,#0f143a 98.3%,transparent 0)}page-layout .live-feed-container{width:100%;height:30.5vh;position:relative;background-color:#122563}page-layout .bottom-promo{position:relative;bottom:0;margin-left:13%;margin-top:3vh;height:8vh;text-align:center;max-width:74%}page-layout .bottom-promo news12-ad{background-color:transparent;border:none;height:100%;display:inline-block;position:relative}page-layout .bottom-promo news12-ad .footer_center{height:100%}page-layout .bottom-promo news12-ad .footer_center img{width:auto;max-width:100%}page-layout .right-promo{position:absolute;bottom:0;width:100%;max-height:28.7vh}page-layout .right-promo news12-ad{height:100%}", ""]);
	
	// exports


/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _pageLayoutSecondaryComponent = __webpack_require__(40);
	
	var _pageLayoutSecondaryComponent2 = _interopRequireDefault(_pageLayoutSecondaryComponent);
	
	var pageLayoutSecondaryModule = _angular2['default'].module('pageLayoutSecondary', [_angularUiRouter2['default']]).component('pageLayoutSecondary', _pageLayoutSecondaryComponent2['default']);
	
	exports['default'] = pageLayoutSecondaryModule;
	module.exports = exports['default'];

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _pageLayoutSecondaryHtml = __webpack_require__(41);
	
	var _pageLayoutSecondaryHtml2 = _interopRequireDefault(_pageLayoutSecondaryHtml);
	
	var _pageLayoutSecondaryController = __webpack_require__(42);
	
	var _pageLayoutSecondaryController2 = _interopRequireDefault(_pageLayoutSecondaryController);
	
	__webpack_require__(43);
	
	exports['default'] = {
	  restrict: 'E',
	  transclude: true,
	  bindings: {
	    leftNavItems: '<',
	    subnavMenuItems: '<',
	    title: '@',
	    region: '<',
	    modal: '<'
	  },
	  template: _pageLayoutSecondaryHtml2['default'],
	  controller: _pageLayoutSecondaryController2['default'],
	  controllerAs: 'vm'
	};
	module.exports = exports['default'];

/***/ },
/* 41 */
/***/ function(module, exports) {

	module.exports = "<div class=\"page-layout-container\" ng-class=\"vm.modal ? 'enlarged-view-layout' : 'small-view-layout'\">\n  <div class=\"section-header\" ng-if=\"!vm.modal\">\n    <header-secondary page-title=\"{{vm.title}}\"\n                      region=\"vm.region\">\n    </header-secondary>\n  </div>\n  <section class=\"n12-secondary-body\">\n    <navbar items=\"vm.subnavMenuItems\"\n            selected-index=\"vm.selectedIndex\"\n            on-select=\"vm.selectPage(item)\"\n            ng-if=\"!vm.modal\">\n    </navbar>\n    <div class=\"left-aside\"  ng-if=\"!vm.modal\">\n      <div class=\"left-navbar\">\n        <news12-button ng-repeat=\"item in vm.leftNavItems\" on-select=\"vm.navSelect(item)\" on-keydown=\"vm.onLeftNavKeyDown(event, $index)\">\n          {{item.title}}\n        </news12-button>\n      </div>\n      <div class=\"left-aside-promo-banner\">\n        <news12-ad region=\"vm.region\" ad-location=\"vm.adProps.photos.leftBannerLocation\" section=\"vm.adProps.photos.sectionName\"></news12-ad>\n      </div>\n    </div>\n    <div ng-class=\"vm.modal ? 'modal-view': 'right-aside'\">\n      <div class=\"secondary-section-content main-content\" ng-transclude>\n          <!-- Photos content -->\n      </div>\n    </div>\n    <div class=\"promo-banners\"  ng-if=\"!vm.modal\">\n      <div class=\"left-promo\">\n        <news12-ad region=\"vm.region\" ad-location=\"vm.adProps.photos.leftBottomBannerLocation\" section=\"vm.adProps.photos.sectionName\"></news12-ad>\n      </div>\n      <div class=\"right-promo\">\n        <news12-ad region=\"vm.region\" ad-location=\"vm.adProps.photos.rightBottomBannerLocation\" section=\"vm.adProps.photos.sectionName\"></news12-ad>\n      </div>\n    </div>\n  </section>\n</div>\n"

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	/*---------------------------------------------------------*\
	 * PageLayoutSecondaryController
	\*---------------------------------------------------------*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _keycodeUi = __webpack_require__(33);
	
	var _keycodeUi2 = _interopRequireDefault(_keycodeUi);
	
	var deps = {};
	
	var PageLayoutSecondaryController = (function () {
	  //-----------------------------------
	  // Constructor
	  //-----------------------------------
	
	  function PageLayoutSecondaryController($state, navigationService, adProps) {
	    _classCallCheck(this, PageLayoutSecondaryController);
	
	    this.$state = $state;
	
	    this.selectedIndex = 0;
	    this.name = 'pageLayoutSecondary';
	    this.adProps = adProps;
	    deps.navigationService = navigationService;
	  }
	
	  //-----------------------------------
	  // Methods
	  //-----------------------------------
	
	  _createClass(PageLayoutSecondaryController, [{
	    key: 'onLeftNavKeyDown',
	    value: function onLeftNavKeyDown(e, index) {
	      if (_keycodeUi2['default'].isRight(e)) {
	        e.preventDefault();
	        deps.navigationService.focusElAsync(index === 0 ? 'navbar' : '.main-content');
	      }
	    }
	  }, {
	    key: 'navSelect',
	    value: function navSelect(item) {
	      if (item && item.state) {
	        this.$state.go(item.state, {}, { reload: true });
	      }
	    }
	  }]);
	
	  return PageLayoutSecondaryController;
	})();
	
	PageLayoutSecondaryController.$inject = ['$state', 'navigationService', 'adProps'];
	
	exports['default'] = PageLayoutSecondaryController;
	module.exports = exports['default'];

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(44);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/sass-loader/index.js!./pageLayoutSecondary.scss", function() {
				var newContent = require("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/sass-loader/index.js!./pageLayoutSecondary.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "h1{font-family:Roboto,Helvetica,Arial,sans-serif;font-size:4.3vmin;font-weight:500;line-height:9vmin}h1,h2{margin:0}h2{font-family:Roboto Condensed,Arial Narrow,Helvetica,Arial,sans-serif;font-size:3.5vmin;font-weight:400}page-layout-secondary{height:100vh;width:100vw}page-layout-secondary .page-layout-container{height:100vh;width:100vw;background:#4863a0;background:linear-gradient(#4863a0 8.8%,#2c37ab 0,#2c37ab 15.25%,#080c73 0,#080c73 0,#080c73 19.45%,#2c37ab 0,#2c37ab 26%,#080c73 0,#4863a0 0)}page-layout-secondary .page-layout-container .section-header{display:block;height:19.45vh;width:90%;padding:0 5%}page-layout-secondary .page-layout-container .n12-secondary-body{width:100%;height:72vh;display:block}page-layout-secondary .page-layout-container .n12-secondary-body navbar{width:78vw;height:6.55vh;margin-left:22vw}page-layout-secondary .page-layout-container .n12-secondary-body .left-aside{display:inline-block;height:49.5vh;width:16vw;margin-left:5vw;position:relative}page-layout-secondary .page-layout-container .n12-secondary-body .left-aside .left-navbar{position:absolute;top:0;width:100%;height:24vh}page-layout-secondary .page-layout-container .n12-secondary-body .left-aside .left-navbar news12-button button{width:100%;height:6.6vh;margin-bottom:2vh}page-layout-secondary .page-layout-container .n12-secondary-body .left-aside .left-navbar news12-button button>div{height:100%;padding:0}page-layout-secondary .page-layout-container .n12-secondary-body .left-aside .left-aside-promo-banner{height:23.7vh;width:100%;position:absolute;bottom:0}page-layout-secondary .page-layout-container .n12-secondary-body .right-aside{position:relative;box-sizing:border-box;border-top:.25vmin solid #a5b3d3;border-left:.25vmin solid #a5b3d3;border-bottom:.25vmin solid #a5b3d3;display:inline-block;height:49.5vh;width:78vw;background-color:#0f143a}page-layout-secondary .page-layout-container .n12-secondary-body .right-aside .secondary-section-content{width:100%;height:100%;overflow:hidden}page-layout-secondary .page-layout-container .n12-secondary-body .modal-view{height:100vh;width:100vw}page-layout-secondary .page-layout-container .n12-secondary-body .modal-view .secondary-section-content{width:100%;height:100%;overflow:hidden}page-layout-secondary .page-layout-container .n12-secondary-body .promo-banners{width:90%;padding:0 5%;margin-top:1vh;height:13.42vh;position:relative}page-layout-secondary .page-layout-container .n12-secondary-body .promo-banners .left-promo,page-layout-secondary .page-layout-container .n12-secondary-body .promo-banners .right-promo{width:44.6vw;display:inline-block;height:15.3vh}page-layout-secondary .page-layout-container .n12-secondary-body .promo-banners .left-promo{float:left}page-layout-secondary .page-layout-container .n12-secondary-body .promo-banners .right-promo{float:right}page-layout-secondary .enlarged-view-layout{background:linear-gradient(#4863a0 15.5%,#080c73 0,#080c73 19.2%,#2c37ab 0,#2c37ab 25.9%,#4863a0 0)}", ""]);
	
	// exports


/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	stateConfiguration.$inject = ["$stateProvider"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _pubsubJs = __webpack_require__(32);
	
	var _pubsubJs2 = _interopRequireDefault(_pubsubJs);
	
	var _homeComponent = __webpack_require__(46);
	
	var _homeComponent2 = _interopRequireDefault(_homeComponent);
	
	var homeState = {
	  name: 'app.home',
	  abstract: true,
	  sticky: true,
	  views: {
	    home: {
	      template: '<home></home>'
	    }
	  },
	  title: {
	    key: 'app.home.title',
	    en: 'News'
	  },
	  onReactivate: ['$state', '$rootScope', '$timeout', 'topics', function ($state, $rootScope, $timeout, topics) {
	    if ($rootScope.previousActiveElement) {
	      // Restore focus to previously focused dom element
	      $timeout(function () {
	        _pubsubJs2['default'].publish(topics.state.reactivate, { source: 'home' });
	      }, 100); // needed 100 here to properly allow time to set focus
	    }
	  }],
	  onInactivate: ['topics', function (topics) {
	    _pubsubJs2['default'].publish(topics.state.inactivate, { source: 'home' });
	  }]
	};
	
	/* @ngInject */
	function stateConfiguration($stateProvider) {
	  var subStates = [{ id: 'news', title: 'News', url: '/' }, { id: 'extra', title: 'Extra', url: '/extra' }, { id: 'inDepth', title: 'In Depth', url: '/indepth' }, { id: 'features', title: 'Features', url: '/features' }];
	
	  $stateProvider.state(homeState);
	
	  subStates.forEach(function (state) {
	    $stateProvider.state({
	      name: 'app.home.' + state.id,
	      url: state.url,
	      title: {
	        key: 'app.home.' + state.id + '.title',
	        en: state.title
	      }
	    });
	  });
	}
	
	var homeModule = _angular2['default'].module('home', [_angularUiRouter2['default'], 'config', 'constants', 'app.services']).config(stateConfiguration).component('home', _homeComponent2['default']);
	
	exports['default'] = homeModule;
	module.exports = exports['default'];

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _homeHtml = __webpack_require__(47);
	
	var _homeHtml2 = _interopRequireDefault(_homeHtml);
	
	var _homeController = __webpack_require__(48);
	
	var _homeController2 = _interopRequireDefault(_homeController);
	
	__webpack_require__(49);
	
	var homeComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _homeHtml2['default'],
	  controller: _homeController2['default'],
	  controllerAs: 'vm'
	};
	
	exports['default'] = homeComponent;
	module.exports = exports['default'];

/***/ },
/* 47 */
/***/ function(module, exports) {

	module.exports = "<page-layout page=\"news\" title=\"{{vm.activeSection.title}}\" header-config=\"vm.headerConfig\" current-region='vm.currentRegion'>\n  <news12-button class=\"closings\" on-select=\"vm.closingsAndDelays_onSelect()\" on-keydown=\"vm.onClosingsKeyDown(event)\" ng-show=\"vm.showClosingsButton\">Closings <br>& Delays</news12-button>\n  <story-list ng-if=\"vm.isActiveSection('storylist')\"\n              stories=\"vm.stories\"\n              on-select=\"vm.onStorySelect(story, focusItem)\"\n              on-keydown=\"vm.onStoryListKeyDown(event)\"\n              page-size=\"vm.storyPageSize\"\n              focus-item=\"vm.currentStory.focusItem\"></story-list>\n  <poll ng-if=\"vm.isActiveSection('poll')\"\n        on-exit=\"vm.onPollExit()\"\n        on-keydown=\"vm.onPollKeyDown(isEventUp)\"></poll>\n  <archives ng-if=\"vm.isActiveSection('archives')\"\n            page-size=\"vm.storyPageSize\"\n            focus-item=\"vm.currentStory.focusItem\"\n            on-select=\"vm.onArchiveSelect(story, focusItem)\"></archives>\n  <other-regions ng-if=\"vm.isActiveSection('other_regions')\"\n                 on-select=\"vm.onRegionSelect(region)\"\n                 on-keydown=\"vm.onOtherRegionKeyDown(event, region, index)\"></other-regions>\n</page-layout>\n"

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	/*---------------------------------------------------------*\
	 * Imports
	\*---------------------------------------------------------*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _pubsubJs = __webpack_require__(32);
	
	var _pubsubJs2 = _interopRequireDefault(_pubsubJs);
	
	var _keycodeUi = __webpack_require__(33);
	
	var _keycodeUi2 = _interopRequireDefault(_keycodeUi);
	
	var _lodash = __webpack_require__(35);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var deps = {};
	
	/*---------------------------------------------------------*\
	 * HomeController
	\*---------------------------------------------------------*/
	
	var HomeController = (function () {
	  //-----------------------------------
	  // Constructor
	  //-----------------------------------
	
	  function HomeController($scope, $rootScope, $state, $timeout, $stateParams, topics, navigationService, newsService, closingsAndDelaysService, localService, storageKeys, states, adProps, $document) {
	    var _this = this;
	
	    _classCallCheck(this, HomeController);
	
	    deps.$state = $state;
	    deps.$timeout = $timeout;
	    deps.topics = topics;
	    deps.navigationService = navigationService;
	    deps.newsService = newsService;
	    deps.states = states;
	    deps.localService = localService;
	    deps.storageKeys = storageKeys;
	    deps.$stateParams = $stateParams;
	    deps.$rootScope = $rootScope;
	    deps.adProps = adProps;
	    deps.$document = $document[0];
	
	    this.name = 'home';
	    this.showClosingsButton = false;
	    this.headerConfig = {};
	    this.currentRegion = localService.get(storageKeys.selectedRegion);
	    this.storyPageSize = 3;
	    this.stories = [];
	
	    var token1 = _pubsubJs2['default'].subscribe(deps.topics.headerMain.menuReady, function (msg, data) {
	      _this.onMenuReady(data);
	    });
	    var token2 = _pubsubJs2['default'].subscribe(deps.topics.headerMain.selectTab, function (msg, data) {
	      _this.onTabSelect(data.item, data.previousItem);
	    });
	    var token3 = _pubsubJs2['default'].subscribe(deps.topics.headerMain.selectSection, function (msg, item) {
	      _this.onSectionSelect(item);
	    });
	
	    var token4 = _pubsubJs2['default'].subscribe(deps.topics.state.reactivate, function () {
	      if (deps.$rootScope.previousActiveElement) {
	        // Restore focus to previously focused dom element
	        $timeout(function () {
	          if (_this.isFocusLost(deps.$rootScope.previousActiveElement)) {
	            deps.navigationService.focusElAsync('.main-content');
	          } else {
	            deps.$rootScope.previousActiveElement.focus();
	          }
	          delete deps.$rootScope.previousActiveElement;
	        });
	      }
	    });
	
	    $scope.$on('$destroy', function () {
	      _pubsubJs2['default'].unsubscribe(token1);
	      _pubsubJs2['default'].unsubscribe(token2);
	      _pubsubJs2['default'].unsubscribe(token3);
	      _pubsubJs2['default'].unsubscribe(token4);
	    });
	
	    closingsAndDelaysService.hasClosings(this.region).then(function (data) {
	      _this.showClosingsButton = data;
	    });
	    this.showClosings = true;
	  }
	
	  //-----------------------------------
	  // Properties
	  //-----------------------------------
	
	  _createClass(HomeController, [{
	    key: 'isFocusLost',
	
	    //-----------------------------------
	    // Methods
	    //-----------------------------------
	    value: function isFocusLost(prevHtmlElement) {
	      // if for any reason focus is lost and lands on the body or a subNavItem element was the last item focused
	      // before changing state then set focus to the main content section. Mostly used for T&W and forecast video
	      // https://tools.emedia.cv.net/jira/browse/NSW-424
	      // but can be used for other use cases
	      if (_angular2['default'].isDefined(prevHtmlElement) && (_lodash2['default'].contains(prevHtmlElement.tagName.toLowerCase(), 'body') || _lodash2['default'].contains(prevHtmlElement.className, 'sub-nav-item'))) {
	        deps.navigationService.focusElAsync('.main-content');
	      }
	    }
	  }, {
	    key: 'onMenuReady',
	    value: function onMenuReady(data) {
	      if (data && _angular2['default'].isObject(data) && !_angular2['default'].isArray(data)) {
	        this.activeTab = data.activeTab;
	        this.activeSection = this.activeTab && _angular2['default'].isArray(data.activeTab.sections) ? data.activeTab.sections[0] : null;
	        if (this.activeSection) {
	          this.updateStories().then(function () {
	            deps.$timeout(function () {
	              deps.navigationService.focusElAsync('.main-content');
	            });
	          });
	        }
	      }
	    }
	  }, {
	    key: 'onTabSelect',
	    value: function onTabSelect(item, previousItem) {
	      if (_angular2['default'].isObject(item) && !_angular2['default'].isArray(item)) {
	        this.activeTab = item;
	        if (item !== previousItem && item.hasStories) {
	          // default to first story on first tab select
	          this.activeSection = item.sections[0];
	          this.updateStories().then(function () {
	            if (item.sections.length < 2) {
	              // select content if submenu is not active
	              deps.navigationService.focusElAsync('.main-content');
	            }
	
	            deps.$timeout(function () {
	              if (item.sections.length < 2) {
	                // select content if submenu is not active
	                deps.navigationService.focusElAsync('.main-content');
	              }
	            });
	          });
	        }
	      }
	    }
	  }, {
	    key: 'onSectionSelect',
	    value: function onSectionSelect(item) {
	      if (item && item.state && item.state.name) {
	        if (item.state.params) {
	          deps.$state.go(item.state.name, item.state.params);
	        } else {
	          deps.$state.go(item.state.name);
	        }
	      } else if (_angular2['default'].isObject(item) && !_angular2['default'].isArray(item)) {
	        this.activeSection = item;
	
	        if (this.activeSection.type !== 'storylist') {
	          deps.$timeout(function () {
	            deps.navigationService.focusElAsync('.main-content');
	          });
	          return;
	        }
	
	        this.updateStories().then(function () {
	          deps.$timeout(function () {
	            deps.navigationService.focusElAsync('.main-content');
	          });
	        });
	      }
	    }
	  }, {
	    key: 'isActiveSection',
	    value: function isActiveSection(section) {
	      return !_lodash2['default'].isUndefined(this.activeSection) && (section === this.activeSection.id || section === this.activeSection.type);
	    }
	  }, {
	    key: 'onClosingsKeyDown',
	    value: function onClosingsKeyDown(e) {
	      var topics = deps.topics.nav;
	      var pollCheck = undefined;
	      switch (true) {
	        case _keycodeUi2['default'].isUp(e):
	          _pubsubJs2['default'].publish(topics.up, 'home.closings');
	          e.preventDefault();
	          break;
	        case _keycodeUi2['default'].isDown(e):
	          pollCheck = !!deps.$document.querySelector('.poll-result');
	          _pubsubJs2['default'].publish(topics.down, { source: 'home.closings', pollResultVisible: pollCheck });
	          e.preventDefault();
	          break;
	        case _keycodeUi2['default'].isLeft(e):
	        case _keycodeUi2['default'].isRight(e):
	          e.preventDefault();
	          break;
	      }
	    }
	  }, {
	    key: 'onStoryListKeyDown',
	    value: function onStoryListKeyDown(e) {
	      if (_keycodeUi2['default'].isUp(e)) {
	        this.focusOnNavOrClosings();
	        e.preventDefault();
	      }
	    }
	  }, {
	    key: 'onPollKeyDown',
	    value: function onPollKeyDown(isEventUp) {
	      if (isEventUp) {
	        this.focusOnNavOrClosings();
	      }
	    }
	  }, {
	    key: 'onOtherRegionKeyDown',
	    value: function onOtherRegionKeyDown(e, region, index) {
	      if (_keycodeUi2['default'].isUp(e)) {
	        if (_lodash2['default'].inRange(index, 0, 3)) {
	          this.focusOnNavOrClosings();
	          e.preventDefault();
	        }
	      } else if (_keycodeUi2['default'].isDown(e)) {
	        var elems = deps.$document.querySelectorAll('other-regions button');
	        var destIndex = elems.length - 1;
	        var previousElement = elems[destIndex];
	        _pubsubJs2['default'].publish(deps.adProps.home.previousElement, { previousElement: previousElement });
	      }
	    }
	  }, {
	    key: 'focusOnNavOrClosings',
	    value: function focusOnNavOrClosings() {
	      if (this.showClosingsButton) {
	        deps.navigationService.focusEl('.main-content .closings');
	      } else {
	        deps.navigationService.focusEl('navbar .selected');
	      }
	    }
	  }, {
	    key: 'onRegionSelect',
	    value: function onRegionSelect(region) {
	      console.log('## ACTION ## REGION SELECTED', region);
	      deps.localService.set(deps.storageKeys.selectedRegion, region);
	      deps.$state.go(deps.states.home, null, { reload: true });
	      _pubsubJs2['default'].publish(deps.topics.regions.select, region);
	    }
	  }, {
	    key: 'onPollExit',
	    value: function onPollExit() {
	      var _this2 = this;
	
	      deps.$timeout(function () {
	        _this2.activeSection = _this2.activeTab.sections[0];
	        deps.navigationService.focusElAsync('.main-content');
	      });
	    }
	  }, {
	    key: 'closingsAndDelays_onSelect',
	    value: function closingsAndDelays_onSelect() {
	      deps.$state.go(deps.states.closingsAndDelays, {});
	    }
	  }, {
	    key: 'onStorySelect',
	    value: function onStorySelect(story, focusItem) {
	      if (_angular2['default'].isObject(story) && !_angular2['default'].isArray(story)) {
	        deps.$state.go(deps.states.videoplayer, { category: this.activeTab.id, currentStory: { story: story, focusItem: focusItem } });
	      }
	    }
	  }, {
	    key: 'onArchiveSelect',
	    value: function onArchiveSelect(story, focusItem) {
	      var objCheck = _angular2['default'].isObject(story) && !_angular2['default'].isArray(story);
	      if (objCheck) {
	        deps.$state.go(deps.states.videoplayer, { category: this.activeTab.id, currentStory: { story: story, focusItem: focusItem } });
	      }
	    }
	  }, {
	    key: 'updateStories',
	    value: function updateStories() {
	      var _this3 = this;
	
	      return deps.newsService.getDataFeed(this.region, this.activeSection.id).then(function (data) {
	        deps.$timeout(function () {
	          _this3.stories = data;
	        });
	      });
	    }
	  }, {
	    key: 'region',
	    get: function get() {
	      var _region = deps.localService.get(deps.storageKeys.selectedRegion);
	      return _region ? _region.abbr : 'LI';
	    }
	  }]);
	
	  return HomeController;
	})();
	
	HomeController.$inject = ['$scope', '$rootScope', '$state', '$timeout', '$stateParams', 'topics', 'navigationService', 'newsService', 'closingsAndDelaysService', 'localService', 'storageKeys', 'states', 'adProps', '$document'];
	
	exports['default'] = HomeController;
	module.exports = exports['default'];

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(50);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../node_modules/css-loader/index.js!./../../../../node_modules/sass-loader/index.js!./home.scss", function() {
				var newContent = require("!!./../../../../node_modules/css-loader/index.js!./../../../../node_modules/sass-loader/index.js!./home.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "h1{font-family:Roboto,Helvetica,Arial,sans-serif;font-size:4.3vmin;font-weight:500;line-height:9vmin}h1,h2{margin:0}h2{font-family:Roboto Condensed,Arial Narrow,Helvetica,Arial,sans-serif;font-size:3.5vmin;font-weight:400}home .closings{height:7.13vh;position:absolute;right:-.25vmin;top:-7.4vh}home .closings button{height:100%}home .closings button>div{background-color:#900;padding:0 1.5vw;height:100%}home .closings button:focus,home .closings button:hover{color:#000;background:linear-gradient(#f7f7f7,#000 55%,#000 70%,#d7d7d7)}home .closings button:focus>div,home .closings button:hover>div{background-color:#ffac25}", ""]);
	
	// exports


/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	stateConfiguration.$inject = ["$stateProvider"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _photosHomeLandingComponent = __webpack_require__(52);
	
	var _photosHomeLandingComponent2 = _interopRequireDefault(_photosHomeLandingComponent);
	
	var stateSettings = {
	  name: 'app.home.photos',
	  state: {
	    url: '/photos?subRegion',
	    views: {
	      'home@app': {
	        template: '<photos-home-landing></photos-home-landing>'
	      }
	    },
	    title: {
	      key: 'app.photosHomeLanding.title',
	      en: 'photos'
	    }
	  }
	};
	
	/* @ngInject */
	function stateConfiguration($stateProvider) {
	  $stateProvider.state(stateSettings.name, stateSettings.state);
	}
	
	var photosHomeLandingModule = _angular2['default'].module('photosHomeLanding', [_angularUiRouter2['default'], 'constants', 'app.services']).config(stateConfiguration).component('photosHomeLanding', _photosHomeLandingComponent2['default']);
	
	exports['default'] = photosHomeLandingModule;
	module.exports = exports['default'];

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _photosHomeLandingHtml = __webpack_require__(53);
	
	var _photosHomeLandingHtml2 = _interopRequireDefault(_photosHomeLandingHtml);
	
	var _photosHomeLandingController = __webpack_require__(54);
	
	var _photosHomeLandingController2 = _interopRequireDefault(_photosHomeLandingController);
	
	__webpack_require__(55);
	
	exports['default'] = {
	  restrict: 'E',
	  bindings: {},
	  template: _photosHomeLandingHtml2['default'],
	  controller: _photosHomeLandingController2['default'],
	  controllerAs: 'vm'
	};
	module.exports = exports['default'];

/***/ },
/* 53 */
/***/ function(module, exports) {

	module.exports = "<page-layout-secondary title=\"Photos\"\n        left-nav-items=\"vm.leftNavItems\"\n        subnav-menu-items=\"vm.subnavMenuItems\"\n        region=\"vm.currentRegion\"\n        modal = \"vm.activeModal\">\n  <div ng-class=\"vm.activeModal ? 'photos-section-enlarged' : 'photos-section'\">\n    <photo-list ng-if=\"vm.isActiveSection('photos') && !vm.photos.showImages\"\n                sub-region= \"vm.currentRegion\"></photo-list>\n    <photo-gallery ng-if=\"vm.isActiveSection('photos') && vm.photos.showImages\"\n                   images = \"vm.images\"\n                   modal= \"vm.activeModal\"\n                   slideshow-on=\"vm.slideshowOn\"></photo-gallery>\n    <other-regions ng-if=\"vm.isActiveSection('regions')\"\n                   title=\"Choose a Location:\"\n                   on-select=\"vm.onRegionSelect(region)\"\n                   current-region=\"vm.currentRegion\"\n                   on-keydown=\"vm.onOtherRegionKeyDown(event, region, index)\"></other-regions>\n  </div>\n</page-layout-secondary>\n"

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	/*---------------------------------------------------------*\
	 * Imports
	\*---------------------------------------------------------*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _pubsubJs = __webpack_require__(32);
	
	var _pubsubJs2 = _interopRequireDefault(_pubsubJs);
	
	var _keycodeUi = __webpack_require__(33);
	
	var _keycodeUi2 = _interopRequireDefault(_keycodeUi);
	
	var _lodash = __webpack_require__(35);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	/*---------------------------------------------------------*\
	 * Weakmaps
	\*---------------------------------------------------------*/
	var deps = {};
	
	/*---------------------------------------------------------*\
	 * PhotosHomeLandingController
	\*---------------------------------------------------------*/
	
	var PhotosHomeLandingController = (function () {
	  //-----------------------------------
	  // Constructor
	  //-----------------------------------
	
	  function PhotosHomeLandingController($scope, $rootScope, $timeout, topics, navigationService, photos, localService, storageKeys, states, $state, $stateParams) {
	    var _this = this;
	
	    _classCallCheck(this, PhotosHomeLandingController);
	
	    this.name = 'photosHomeLanding';
	
	    deps.$state = $state;
	    deps.$scope = $scope;
	    deps.states = states;
	    deps.$timeout = $timeout;
	    deps.$stateParams = $stateParams;
	    deps.topics = topics;
	    deps.$rootScope = $rootScope;
	    deps.navigationService = navigationService;
	    deps.topics = topics;
	    deps.$timeout = $timeout;
	
	    this.photos = photos;
	    this.$scope = $scope;
	    this.slideshowOn = false;
	    this.leftNavItems = [{
	      id: 'news',
	      title: 'News',
	      state: deps.states.home,
	      sections: []
	    }, {
	      id: 'weather',
	      title: 'Weather',
	      state: deps.states.weather_center,
	      sections: []
	    }, {
	      id: 'traffic',
	      title: 'Traffic',
	      state: deps.states.traffic_center,
	      sections: []
	    }];
	    this.subnavMenuItems = [{
	      title: 'Photos',
	      id: 'photos'
	    }, {
	      title: 'Slideshow: ' + (this.slideshowOn ? 'On' : 'Off'),
	      id: 'slideshow'
	    }, {
	      title: 'Change Region',
	      id: 'regions'
	    }]; // TODO, render items dynamically
	    this.currentRegion = deps.$stateParams.subRegion ? JSON.parse(deps.$stateParams.subRegion) : localService.get(storageKeys.selectedRegion);
	
	    var token = _pubsubJs2['default'].subscribe(topics.component.selectPhotos, function (msn, data) {
	      _this.images = data;
	      _this.photos.showImages = true;
	    });
	    var token1 = _pubsubJs2['default'].subscribe(deps.topics.nav.enter, function (msg, data) {
	      if (data.source === 'navbar') {
	        // No matter what is chosen we always go back to the list view
	        if (data.data.id !== 'slideshow') {
	          _this.photos.showImages = false;
	        }
	
	        if (data.data === _this.subnavMenuItems[1]) {
	          // TODO Add logic to toggle slide show and update display
	          var item = data.data;
	          _this.slideshowOn = !_this.slideshowOn;
	          data.data.title = 'Slideshow: ' + (_this.slideshowOn ? 'On' : 'Off');
	          _pubsubJs2['default'].publish(deps.topics.component.slideshowToggle, { data: item, slideshowOn: _this.slideshowOn });
	        } else {
	          _this.subNavSelect(data.data);
	        }
	        _this.$scope.$apply();
	      }
	    });
	    var token2 = _pubsubJs2['default'].subscribe(deps.topics.state.reactivate, function () {
	      if (deps.$rootScope.previousActiveElement) {
	        // Restore focus to previously focused dom element
	        deps.$timeout(function () {
	          deps.$rootScope.previousActiveElement.focus();
	          console.log(deps.$rootScope.previousActiveElement);
	          delete deps.$rootScope.previousActiveElement;
	        });
	      }
	    });
	
	    this.subNavSelect(this.subnavMenuItems[0]);
	
	    deps.$scope.$on('$destroy', function () {
	      _pubsubJs2['default'].unsubscribe(token);
	      _pubsubJs2['default'].unsubscribe(token1);
	      _pubsubJs2['default'].unsubscribe(token2);
	    });
	  }
	
	  //-----------------------------------
	  // Methods
	  //-----------------------------------
	
	  _createClass(PhotosHomeLandingController, [{
	    key: 'subNavSelect',
	    value: function subNavSelect(item) {
	      if (item) {
	        this.activeSection = item;
	        this.photos.showImages = false;
	
	        // This initial timeout is necessary to wait for the old .main-content to have
	        // been cleared from the DOM
	        deps.$timeout(function () {
	          deps.navigationService.focusElAsync('.main-content');
	        });
	      }
	    }
	  }, {
	    key: 'isActiveSection',
	    value: function isActiveSection(section) {
	      return section === this.activeSection.id;
	    }
	  }, {
	    key: 'onRegionSelect',
	    value: function onRegionSelect(region) {
	      if (region) {
	        deps.$state.go(deps.$state.$current, { subRegion: JSON.stringify(region) });
	      }
	    }
	  }, {
	    key: 'onOtherRegionKeyDown',
	    value: function onOtherRegionKeyDown(e, region, index) {
	      if (_keycodeUi2['default'].isUp(e)) {
	        if (_lodash2['default'].inRange(index, 0, 3)) {
	          deps.navigationService.focusEl('navbar .selected');
	          e.preventDefault();
	        }
	      }
	    }
	  }]);
	
	  return PhotosHomeLandingController;
	})();
	
	PhotosHomeLandingController.$inject = ['$scope', '$rootScope', '$timeout', 'topics', 'navigationService', 'photos', 'localService', 'storageKeys', 'states', '$state', '$stateParams'];
	
	exports['default'] = PhotosHomeLandingController;
	module.exports = exports['default'];

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(56);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../node_modules/css-loader/index.js!./../../../../node_modules/sass-loader/index.js!./photosHomeLanding.scss", function() {
				var newContent = require("!!./../../../../node_modules/css-loader/index.js!./../../../../node_modules/sass-loader/index.js!./photosHomeLanding.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "h1{font-family:Roboto,Helvetica,Arial,sans-serif;font-size:4.3vmin;font-weight:500;line-height:9vmin}h1,h2{margin:0}h2{font-family:Roboto Condensed,Arial Narrow,Helvetica,Arial,sans-serif;font-size:3.5vmin;font-weight:400}page-layout-secondary{position:absolute}page-layout-secondary .photos-section{display:block;position:relative;width:100%;height:100%}page-layout-secondary .photos-section photo-list{width:100%}page-layout-secondary .photos-section photo-gallery{width:72%}page-layout-secondary .photos-section other-regions{width:83.5%}page-layout-secondary .photos-section-enlarged{display:block;position:relative;width:100%;height:100%}page-layout-secondary .photos-section-enlarged photo-gallery{width:100%}", ""]);
	
	// exports


/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	stateConfiguration.$inject = ["$stateProvider"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _trafficHomeLandingComponent = __webpack_require__(58);
	
	var _trafficHomeLandingComponent2 = _interopRequireDefault(_trafficHomeLandingComponent);
	
	var stateSettings = {
	  name: 'app.home.traffichome',
	  state: {
	    url: '/traffic?subRegion',
	    views: {
	      'home@app': {
	        template: '<traffic-home-landing></traffic-home-landing>'
	      }
	    },
	    title: {
	      key: 'app.trafficHomeLanding.title',
	      en: 'traffic'
	    }
	  }
	};
	
	/* @ngInject */
	function stateConfiguration($stateProvider) {
	  $stateProvider.state(stateSettings.name, stateSettings.state);
	}
	
	var trafficHomeLandingModule = _angular2['default'].module('trafficHomeLanding', [_angularUiRouter2['default'], 'constants', 'app.services']).config(stateConfiguration).component('trafficHomeLanding', _trafficHomeLandingComponent2['default']);
	
	exports['default'] = trafficHomeLandingModule;
	module.exports = exports['default'];

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _trafficHomeLandingHtml = __webpack_require__(59);
	
	var _trafficHomeLandingHtml2 = _interopRequireDefault(_trafficHomeLandingHtml);
	
	var _trafficHomeLandingController = __webpack_require__(60);
	
	var _trafficHomeLandingController2 = _interopRequireDefault(_trafficHomeLandingController);
	
	__webpack_require__(61);
	
	exports['default'] = {
	  restrict: 'E',
	  bindings: {
	    subRegion: '<',
	    leftNavItems: '<',
	    badge: '@'
	  },
	  template: _trafficHomeLandingHtml2['default'],
	  controller: _trafficHomeLandingController2['default'],
	  controllerAs: 'vm'
	};
	module.exports = exports['default'];

/***/ },
/* 59 */
/***/ function(module, exports) {

	module.exports = "<page-layout-w-t title=\"Traffic\"\n                 left-nav-items=\"vm.leftNavItems\"\n                 subnav-menu-items=\"vm.subnavMenuItems\"\n                 region=\"vm.currentRegion\">\n  <navbar items=\"vm.subnavMenuItems\"\n          selected-index=\"vm.selectedIndex\"\n          on-select=\"vm.selectPage(item)\">\n  </navbar>\n  <div class=\"left-aside\">\n    <div class=\"left-navbar\">\n      <news12-button ng-repeat=\"item in vm.leftNavItems\" badge=\"{{item.badge}}\" on-select=\"vm.navSelect(item)\">\n        {{item.title}}\n      </news12-button>\n    </div>\n    <div class=\"left-aside-promo-banner\">\n      <news12-ad region=\"vm.currentRegion\" ad-location=\"vm.adProps.photos.leftBannerLocation\" section=\"vm.adProps.photos.sectionName\"></news12-ad>\n    </div>\n  </div>\n  <div class=\"right-aside\">\n    <div class=\"secondary-section-content main-content\">\n      <map-gallery ng-if=\"vm.isActiveSection('Maps')\"\n                   maps = \"vm.maps\"\n                   pausemap-on=\"vm.pausemapOn\"></map-gallery>\n      <camera-list ng-if=\"vm.isActiveSection('Cameras') && vm.showCameras == true\"\n                  sub-region= \"vm.currentRegion\"></camera-list>\n      <camera-gallery ng-if=\"vm.showCamerasPhotos == true\"\n                      cameras = \"vm.cameras\"\n                      modal= \"vm.activeModal\"\n                      slideshow-on=\"vm.slideshowOn\"></camera-gallery>\n      <incident-list ng-if=\"vm.isActiveSection('Delays')\"\n                  sub-region=\"vm.currentRegion\"></incident-list>\n      <other-regions ng-if=\"vm.isActiveSection('Region')\"\n                     title=\"Choose a Location:\"\n                     on-select=\"vm.onRegionSelect(region)\"\n                     current-region=\"vm.currentRegion\">\n      </other-regions>\n    </div>\n  </div>\n\n</page-layout-w-t>\n"

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	/*---------------------------------------------------------*\
	 * Imports
	\*---------------------------------------------------------*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _pubsubJs = __webpack_require__(32);
	
	var _pubsubJs2 = _interopRequireDefault(_pubsubJs);
	
	var deps = {};
	
	/*---------------------------------------------------------*\
	 * Weakmaps
	 \*---------------------------------------------------------*/
	var TIMEOUT = new WeakMap();
	var TOPICS = new WeakMap();
	var NAVIGATION = new WeakMap();
	
	/*---------------------------------------------------------*\
	 * TrafficHomeLanding
	\*---------------------------------------------------------*/
	
	var TrafficHomeLandingController = (function () {
	  //-----------------------------------
	  // Constructor
	  //-----------------------------------
	
	  function TrafficHomeLandingController($state, $stateParams, $scope, $timeout, topics, navigationService, localService, storageKeys, states, trafficService, adProps) {
	    var _this = this;
	
	    _classCallCheck(this, TrafficHomeLandingController);
	
	    TIMEOUT.set(this, $timeout);
	    TOPICS.set(this, topics);
	    NAVIGATION.set(this, navigationService);
	
	    deps.trafficService = trafficService;
	    this.adProps = adProps;
	
	    deps.$state = $state;
	    deps.$stateParams = $stateParams;
	    this.name = 'trafficHomeLanding';
	    deps.states = states;
	    this.$scope = $scope;
	    this.showCameras = false;
	    this.pausemapOn = false;
	
	    deps.localService = localService;
	    // this.currentRegion is the LOCAL region variable
	    this.currentRegion = deps.$stateParams.subRegion ? JSON.parse(deps.$stateParams.subRegion) : localService.get(storageKeys.selectedRegion);
	
	    this.leftNavItems = [{
	      id: 'news',
	      title: 'News',
	      state: states.home,
	      sections: []
	    }, {
	      id: 'weather',
	      title: 'Weather',
	      state: states.weather_center,
	      sections: []
	    }];
	    this.subnavMenuItems = [{
	      title: this.pausemapOn ? 'Resume Maps' : 'Pause Maps',
	      id: 'Maps'
	    }, {
	      title: 'Cameras',
	      id: 'Cameras'
	    }, {
	      title: 'Delays',
	      id: 'Delays'
	    }, {
	      title: 'Region',
	      id: 'Region'
	    }]; // TODO, render items dynamically
	
	    var token2 = _pubsubJs2['default'].subscribe(topics.component.selectPhotos, function (msn, data) {
	      _this.cameras = data;
	      _this.showCameras = _this.cameras.showCameras;
	      _this.showCamerasPhotos = _this.cameras.showCamerasPhotos;
	    });
	
	    var token = _pubsubJs2['default'].subscribe(TOPICS.get(this).nav.enter, function (msg, data) {
	      if (data.source === 'navbar') {
	        _this.showCamerasPhotos = false;
	        // When clicking on subnav
	        if (data.data === _this.subnavMenuItems[0]) {
	          var item = data.data;
	          _this.pausemapOn = !_this.pausemapOn;
	          data.data.title = _this.pausemapOn ? 'Resume Maps' : 'Pause Maps';
	          _pubsubJs2['default'].publish(TOPICS.get(_this).component.slideshowToggle, { data: item, pausemapOn: _this.pausemapOn });
	        } else if (data.data.title === 'Cameras') {
	          _this.showCameras = true;
	          _this.pausemapOn = true;
	        } else {
	          _this.pausemapOn = true;
	        }
	        _this.subNavSelect(data.data);
	        _this.$scope.$apply();
	      }
	    });
	    $scope.$on('$destroy', _pubsubJs2['default'].unsubscribe.bind(_pubsubJs2['default'], token));
	    $scope.$on('$destroy', _pubsubJs2['default'].unsubscribe.bind(_pubsubJs2['default'], token2));
	    this.subNavSelect(this.subnavMenuItems[0]);
	    // focus on index 0 in subnavbar
	    this.selectedIndex = 0;
	    this.$onInit = function () {
	      trafficService.getTrafficPlaypauseMaps(_this.currentRegion.abbr).then(_this.applyMap.bind(_this));
	    };
	  }
	
	  //-----------------------------------
	  // Properties
	  //-----------------------------------
	  //-----------------------------------
	  // Methods
	  //-----------------------------------
	
	  _createClass(TrafficHomeLandingController, [{
	    key: 'applyMap',
	    value: function applyMap(item) {
	      var _this2 = this;
	
	      TIMEOUT.get(this)(function () {
	        _this2.maps = item.data;
	      });
	    }
	  }, {
	    key: 'subNavSelect',
	    value: function subNavSelect(item) {
	      var _this3 = this;
	
	      this.showCamerasPhotos = false;
	      this.activeSection = item;
	      // This initial timeout is necessary to wait for the old .main-content to have
	      // been cleared from the DOM
	      TIMEOUT.get(this)(function () {
	        // focus on navbar
	        NAVIGATION.get(_this3).focusElAsync('.selected');
	      });
	    }
	  }, {
	    key: 'isActiveSection',
	    value: function isActiveSection(section) {
	      return section === this.activeSection.id;
	    }
	  }, {
	    key: 'navSelect',
	    value: function navSelect(item) {
	      if (item && item.state) {
	        deps.$state.go(item.state);
	      }
	    }
	  }, {
	    key: 'onRegionSelect',
	    value: function onRegionSelect(region) {
	      var _this4 = this;
	
	      TIMEOUT.get(this)(function () {
	        deps.trafficService.getTrafficPlaypauseMaps(region.abbr).then(_this4.applyMap.bind(_this4));
	      });
	      deps.$state.go(deps.$state.$current, { subRegion: JSON.stringify(region) });
	    }
	
	    //-----------------------------------
	    // Events
	    //-----------------------------------
	  }]);
	
	  return TrafficHomeLandingController;
	})();
	
	TrafficHomeLandingController.$inject = ['$state', '$stateParams', '$scope', '$timeout', 'topics', 'navigationService', 'localService', 'storageKeys', 'states', 'trafficService', 'adProps'];
	
	exports['default'] = TrafficHomeLandingController;
	module.exports = exports['default'];

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(62);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../node_modules/css-loader/index.js!./../../../../node_modules/sass-loader/index.js!./trafficHomeLanding.scss", function() {
				var newContent = require("!!./../../../../node_modules/css-loader/index.js!./../../../../node_modules/sass-loader/index.js!./trafficHomeLanding.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "h1{font-family:Roboto,Helvetica,Arial,sans-serif;font-size:4.3vmin;font-weight:500;line-height:9vmin}h1,h2{margin:0}h2{font-family:Roboto Condensed,Arial Narrow,Helvetica,Arial,sans-serif;font-size:3.5vmin;font-weight:400}page-layout-w-t{position:absolute}page-layout-w-t .main-content img{height:100%;padding-left:7%}", ""]);
	
	// exports


/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	stateConfiguration.$inject = ["$stateProvider"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _trafficComponent = __webpack_require__(64);
	
	var _trafficComponent2 = _interopRequireDefault(_trafficComponent);
	
	var stateSettings = {
	  name: 'app.traffic',
	  state: {
	    url: '/traffic',
	    views: {
	      '': {
	        template: '<traffic></traffic>'
	      }
	    },
	    title: {
	      key: 'app.traffic.title',
	      en: 'News'
	    }
	  }
	};
	
	/* @ngInject */
	function stateConfiguration($stateProvider) {
	  $stateProvider.state(stateSettings.name, stateSettings.state);
	}
	
	var _module = _angular2['default'].module('traffic', [_angularUiRouter2['default'], 'config', 'constants', 'apiService']).config(stateConfiguration).component('traffic', _trafficComponent2['default']);
	
	exports['default'] = _module;
	module.exports = exports['default'];

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _trafficHtml = __webpack_require__(65);
	
	var _trafficHtml2 = _interopRequireDefault(_trafficHtml);
	
	var _trafficController = __webpack_require__(66);
	
	var _trafficController2 = _interopRequireDefault(_trafficController);
	
	__webpack_require__(67);
	
	var component = {
	  restrict: 'E',
	  bindings: {},
	  template: _trafficHtml2['default'],
	  controller: _trafficController2['default'],
	  controllerAs: 'vm'
	};
	
	exports['default'] = component;
	module.exports = exports['default'];

/***/ },
/* 65 */
/***/ function(module, exports) {

	module.exports = "<page-layout page=\"traffic\" title=\"{{vm.activeSection.title}}\" header-config=\"vm.headerConfig\" current-region = 'vm.currentRegion'>\n\n    <div class=\"ng-scope\" style=\"height: 100%;display: flex;align-items: center;justify-content: center;opacity: 0.2;color: #e1f0ff;\">\n        <i class=\"fa fa-cogs\" style=\"font-size: 14vw;\"></i>\n    </div>\n\n</page-layout>\n"

/***/ },
/* 66 */
/***/ function(module, exports) {

	/*---------------------------------------------------------*\
	 * Imports
	\*---------------------------------------------------------*/
	
	/*---------------------------------------------------------*\
	 * WeakMaps
	\*---------------------------------------------------------*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var deps = {};
	
	/*---------------------------------------------------------*\
	 * TrafficController
	\*---------------------------------------------------------*/
	
	var TrafficController = (function () {
	  //-----------------------------------
	  // Constructor
	  //-----------------------------------
	
	  function TrafficController(localService, storageKeys) {
	    _classCallCheck(this, TrafficController);
	
	    deps.localService = localService;
	    deps.storageKeys = storageKeys;
	
	    this.name = 'traffic';
	    this.headerConfig = {};
	    this.currentRegion = localService.get(storageKeys.selectedRegion);
	  }
	
	  //-----------------------------------
	  // Properties
	  //-----------------------------------
	
	  _createClass(TrafficController, [{
	    key: 'region',
	    get: function get() {
	      var _region = deps.localService.get(deps.storageKeys.selectedRegion);
	      return _region ? _region.abbr : 'LI';
	    }
	
	    //-----------------------------------
	    // Methods
	    //-----------------------------------
	  }]);
	
	  return TrafficController;
	})();
	
	TrafficController.$inject = ['localService', 'storageKeys'];
	
	exports['default'] = TrafficController;
	module.exports = exports['default'];

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(68);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../node_modules/css-loader/index.js!./../../../../node_modules/sass-loader/index.js!./traffic.scss", function() {
				var newContent = require("!!./../../../../node_modules/css-loader/index.js!./../../../../node_modules/sass-loader/index.js!./traffic.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "h1{font-family:Roboto,Helvetica,Arial,sans-serif;font-size:4.3vmin;font-weight:500;line-height:9vmin}h1,h2{margin:0}h2{font-family:Roboto Condensed,Arial Narrow,Helvetica,Arial,sans-serif;font-size:3.5vmin;font-weight:400}", ""]);
	
	// exports


/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	stateConfiguration.$inject = ["$stateProvider"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _regionSelectionLandingComponent = __webpack_require__(70);
	
	var _regionSelectionLandingComponent2 = _interopRequireDefault(_regionSelectionLandingComponent);
	
	var stateSettings = {
	  name: 'app.regionSelectionLanding',
	  state: {
	    url: '/region-selection',
	    views: {
	      '': {
	        template: '<region-selection-landing></region-selection-landing>'
	      }
	    },
	    title: {
	      key: 'app.regionSelectionLanding.title',
	      en: 'Select a region'
	    }
	  }
	};
	
	/* @ngInject */
	function stateConfiguration($stateProvider) {
	  $stateProvider.state(stateSettings.name, stateSettings.state);
	}
	
	var regionSelectionLandingModule = _angular2['default'].module('regionSelectionLanding', [_angularUiRouter2['default'], 'app.services', 'constants']).config(stateConfiguration).component('regionSelectionLanding', _regionSelectionLandingComponent2['default']);
	
	exports['default'] = regionSelectionLandingModule;
	module.exports = exports['default'];

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _regionSelectionLandingHtml = __webpack_require__(71);
	
	var _regionSelectionLandingHtml2 = _interopRequireDefault(_regionSelectionLandingHtml);
	
	var _regionSelectionLandingController = __webpack_require__(72);
	
	var _regionSelectionLandingController2 = _interopRequireDefault(_regionSelectionLandingController);
	
	__webpack_require__(73);
	
	exports['default'] = {
	  restrict: 'E',
	  bindings: {},
	  template: _regionSelectionLandingHtml2['default'],
	  controller: _regionSelectionLandingController2['default'],
	  controllerAs: 'vm'
	};
	module.exports = exports['default'];

/***/ },
/* 71 */
/***/ function(module, exports) {

	module.exports = "<page-layout header-config=\"vm.headerConfig\" wide-view=\"true\" hide-footer=\"true\">\n\n    <h2 class=\"subtitle\">Please select a region to launch:</h2>\n\n    <region-selection\n            selected=\"vm.region\"\n            regions=\"vm.listOfRegions\"\n            columns=\"3\"\n            on-select=\"vm.selectRegion(region)\">\n    </region-selection>\n\n</page-layout>\n"

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _pubsubJs = __webpack_require__(32);
	
	var _pubsubJs2 = _interopRequireDefault(_pubsubJs);
	
	/*---------------------------------------------------------*\
	 * RegionSelectionLandingController
	\*---------------------------------------------------------*/
	var deps = {};
	
	var RegionSelectionLandingController = (function () {
	  //-----------------------------------
	  // Constructor
	  //-----------------------------------
	
	  function RegionSelectionLandingController($state, navigationService, localService, storageKeys, topics, states) {
	    _classCallCheck(this, RegionSelectionLandingController);
	
	    this.name = 'regionSelectionLanding';
	    deps.$state = $state;
	    deps.localService = localService;
	    deps.storageKeys = storageKeys;
	    deps.topics = topics;
	    deps.states = states;
	
	    this.headerConfig = {
	      hideNewsTicker: true,
	      hideNavbar: true
	    };
	    this.region = localService.get(deps.storageKeys.selectedRegion);
	    this.listOfRegions = localService.get(deps.storageKeys.regions);
	    navigationService.focusElAsync('.main-content' + (this.region ? ' .selected' : ''));
	  }
	
	  //-----------------------------------
	  // Methods
	  //-----------------------------------
	
	  _createClass(RegionSelectionLandingController, [{
	    key: 'selectRegion',
	    value: function selectRegion(region) {
	      if (_angular2['default'].isObject(region) && !_angular2['default'].isArray(region)) {
	        console.log('## ACTION ## REGION SELECTED', region);
	        this.region = region;
	        deps.localService.set(deps.storageKeys.selectedRegion, region);
	        deps.$state.go(deps.states.home);
	        _pubsubJs2['default'].publish(deps.topics.regions.select, region);
	      }
	    }
	  }]);
	
	  return RegionSelectionLandingController;
	})();
	
	RegionSelectionLandingController.$inject = ['$state', 'navigationService', 'localService', 'storageKeys', 'topics', 'states'];
	
	exports['default'] = RegionSelectionLandingController;
	module.exports = exports['default'];

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(74);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../node_modules/css-loader/index.js!./../../../../node_modules/sass-loader/index.js!./regionSelectionLanding.scss", function() {
				var newContent = require("!!./../../../../node_modules/css-loader/index.js!./../../../../node_modules/sass-loader/index.js!./regionSelectionLanding.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "region-selection-landing .main-content{padding-left:10%;padding-top:3%}region-selection-landing h2.subtitle{margin-bottom:2%}", ""]);
	
	// exports


/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	stateConfiguration.$inject = ["$stateProvider"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _enlargedLivefeedComponent = __webpack_require__(76);
	
	var _enlargedLivefeedComponent2 = _interopRequireDefault(_enlargedLivefeedComponent);
	
	var stateSettings = {
	  name: 'app.enlargedLivefeed',
	  state: {
	    url: '/livefeed',
	    sticky: false, // keep this. we test for sticky === false
	    views: {
	      '': {
	        template: '<enlarged-livefeed></enlarged-livefeed>'
	      }
	    },
	    title: {
	      key: 'app.enlargedLivefeed.title',
	      en: 'Enlarged livefeed'
	    },
	    params: {
	      currentStory: undefined
	    }
	  }
	};
	
	/* @ngInject */
	function stateConfiguration($stateProvider) {
	  $stateProvider.state(stateSettings.name, stateSettings.state);
	}
	
	var enlargedLivefeedModule = _angular2['default'].module('enlargedLivefeed', [_angularUiRouter2['default'], 'constants']).config(stateConfiguration).component('enlargedLivefeed', _enlargedLivefeedComponent2['default']);
	
	exports['default'] = enlargedLivefeedModule;
	module.exports = exports['default'];

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _enlargedLivefeedHtml = __webpack_require__(77);
	
	var _enlargedLivefeedHtml2 = _interopRequireDefault(_enlargedLivefeedHtml);
	
	var _enlargedLivefeedController = __webpack_require__(78);
	
	var _enlargedLivefeedController2 = _interopRequireDefault(_enlargedLivefeedController);
	
	__webpack_require__(79);
	
	exports['default'] = {
	  restrict: 'E',
	  bindings: {},
	  template: _enlargedLivefeedHtml2['default'],
	  controller: _enlargedLivefeedController2['default'],
	  controllerAs: 'vm'
	};
	module.exports = exports['default'];

/***/ },
/* 77 */
/***/ function(module, exports) {

	module.exports = "<div class=\"enlarged-livefeed\"  ng-keyup=\"vm.remoteKeyup($event)\" tabindex=\"0\">\n  <div class=\"enlarged-livefeed-container\">\n    <div class=\"player-container\">\n      <div class=\"player\">\n        <live-feed-video feed-config=\"vm.feedConfig\"\n                         on-ready=\"vm.onLiveFeedReady(liveFeed)\"\n        ></live-feed-video>\n      </div>\n    </div>\n    <div class=\"navbar\">\n      <news12-button on-select=\"vm.goBack()\">Back</news12-button>\n      <div class=\"enlarged-livefeed-logo\">\n        <img src=\"./../../../assets/images/news12-logo.png\"> <!--TODO, exchange image once cv assets are provided -->\n      </div>\n    </div>\n  </div>\n</div>"

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _keycodeUi = __webpack_require__(33);
	
	var _keycodeUi2 = _interopRequireDefault(_keycodeUi);
	
	var _pubsubJs = __webpack_require__(32);
	
	var _pubsubJs2 = _interopRequireDefault(_pubsubJs);
	
	var _lodash = __webpack_require__(35);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var deps = {};
	/*---------------------------------------------------------*\
	 * EnlargedLivefeedController
	\*---------------------------------------------------------*/
	
	var EnlargedLivefeedController = (function () {
	  //-----------------------------------
	  // Constructor
	  //-----------------------------------
	
	  function EnlargedLivefeedController($state, $rootScope, $element, $stateParams, navigationService, topics, states) {
	    _classCallCheck(this, EnlargedLivefeedController);
	
	    deps.topics = topics;
	    deps.$state = $state;
	    deps.$element = $element;
	    deps.states = states;
	    deps.$stateParams = $stateParams;
	    deps.$rootScope = $rootScope;
	    this.feedConfig = deps.$stateParams.currentStory;
	    this.name = 'enlargedLivefeed';
	    this.liveFeed = null;
	    navigationService.focusEl('.navbar');
	  }
	
	  _createClass(EnlargedLivefeedController, [{
	    key: 'goBack',
	    value: function goBack() {
	      deps.$state.go(deps.$rootScope.previousState.name, deps.$rootScope.previousParams);
	    }
	  }, {
	    key: 'onLiveFeedReady',
	    value: function onLiveFeedReady(liveFeed) {
	      if (_angular2['default'].isObject(liveFeed) && !_lodash2['default'].isUndefined(liveFeed.API)) {
	        this.liveFeed = liveFeed;
	      }
	    }
	  }, {
	    key: 'remoteKeyup',
	    value: function remoteKeyup(e) {
	      if (_keycodeUi2['default'].isPlayPause(e) && this.liveFeed) {
	        this.liveFeed.playPause();
	      } else if (_keycodeUi2['default'].isBack(e)) {
	        e.preventDefault();
	        e.stopPropagation();
	        _pubsubJs2['default'].publish(deps.topics.remoteKeys.back, { e: e });
	        this.goBack();
	      }
	    }
	  }]);
	
	  return EnlargedLivefeedController;
	})();
	
	EnlargedLivefeedController.$inject = ['$state', '$rootScope', '$element', '$stateParams', 'navigationService', 'topics', 'states'];
	
	exports['default'] = EnlargedLivefeedController;
	module.exports = exports['default'];

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(80);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../node_modules/css-loader/index.js!./../../../../node_modules/sass-loader/index.js!./enlargedLivefeed.scss", function() {
				var newContent = require("!!./../../../../node_modules/css-loader/index.js!./../../../../node_modules/sass-loader/index.js!./enlargedLivefeed.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "enlarged-livefeed .enlarged-livefeed{height:100vh;width:100vw;background:#4863a0;background:linear-gradient(#4863a0 15.5%,#080c73 0,#080c73 19.2%,#2c37ab 0,#2c37ab 25.9%,#4863a0 0)}enlarged-livefeed .enlarged-livefeed .enlarged-livefeed-container{width:53vw;height:67.6vh;margin:0 auto;display:block}enlarged-livefeed .enlarged-livefeed .enlarged-livefeed-container .player-container{width:100%;height:100%;padding-top:9.26vh}enlarged-livefeed .enlarged-livefeed .enlarged-livefeed-container .player-container .player{height:100%;background-color:#000;border:.25vmin solid #a5b3d3;position:relative;display:flex;align-items:center;justify-content:center}enlarged-livefeed .enlarged-livefeed .enlarged-livefeed-container .player-container .player live-feed-video{height:100%;width:100%}enlarged-livefeed .enlarged-livefeed .enlarged-livefeed-container .player-container .player live-feed-video .videoplayerContainer{height:100%;flex:1;border:none}enlarged-livefeed .enlarged-livefeed .enlarged-livefeed-container .player-container .player live-feed-video button{display:none}enlarged-livefeed .enlarged-livefeed .enlarged-livefeed-container .navbar{width:100%;margin-top:7.4vh;height:4.6vh}enlarged-livefeed .enlarged-livefeed .enlarged-livefeed-container .navbar news12-button{float:left}enlarged-livefeed .enlarged-livefeed .enlarged-livefeed-container .navbar news12-button button{width:6.5vw;height:100%}enlarged-livefeed .enlarged-livefeed .enlarged-livefeed-container .navbar news12-button button>div{height:100%;padding:0;line-height:200%}enlarged-livefeed .enlarged-livefeed .enlarged-livefeed-container .navbar .enlarged-livefeed-logo{float:right;width:16.7vw;height:100%;position:relative}enlarged-livefeed .enlarged-livefeed .enlarged-livefeed-container .navbar .enlarged-livefeed-logo>img{width:100%;position:absolute;top:0;bottom:0;margin:auto}", ""]);
	
	// exports


/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	stateConfiguration.$inject = ["$stateProvider"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _closingsDelaysLandingComponent = __webpack_require__(82);
	
	var _closingsDelaysLandingComponent2 = _interopRequireDefault(_closingsDelaysLandingComponent);
	
	var stateSettings = {
	  name: 'app.home.closingsAndDelays',
	  state: {
	    url: '/closings-delays',
	    views: {
	      'home@app': {
	        template: '<closings-delays-landing></closings-delays-landing>'
	      }
	    },
	    title: {
	      key: 'app.closingsDelaysLanding.title',
	      en: 'Closings and Delays'
	    }
	  }
	};
	
	/* @ngInject */
	function stateConfiguration($stateProvider) {
	  $stateProvider.state(stateSettings.name, stateSettings.state);
	}
	
	var closingsDelaysLandingModule = _angular2['default'].module('closingsDelaysLanding', [_angularUiRouter2['default'], 'constants', 'app.services']).config(stateConfiguration).component('closingsDelaysLanding', _closingsDelaysLandingComponent2['default']);
	
	exports['default'] = closingsDelaysLandingModule;
	module.exports = exports['default'];

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _closingsDelaysLandingHtml = __webpack_require__(83);
	
	var _closingsDelaysLandingHtml2 = _interopRequireDefault(_closingsDelaysLandingHtml);
	
	var _closingsDelaysLandingController = __webpack_require__(84);
	
	var _closingsDelaysLandingController2 = _interopRequireDefault(_closingsDelaysLandingController);
	
	__webpack_require__(85);
	
	exports['default'] = {
	  restrict: 'E',
	  bindings: {},
	  template: _closingsDelaysLandingHtml2['default'],
	  controller: _closingsDelaysLandingController2['default'],
	  controllerAs: 'vm'
	};
	module.exports = exports['default'];

/***/ },
/* 83 */
/***/ function(module, exports) {

	module.exports = "<page-layout page=\"closingsAndDelays\"\n             title=\"Closings / Delays\"\n             hide-footer=\"true\"\n             wide-view=\"true\"\n             header-config=\"vm.headerConfig\"\n             current-region=\"vm.currentRegion\">\n  <div class=\"row row1\">\n    <div class=\"column column1\"><div>Alpha</div></div>\n    <div class=\"column column2\"><div>Community</div></div>\n    <div class=\"column column3\"><div>Facility / Status</div></div>\n  </div>\n  <div class=\"row row2\">\n    <div class=\"column column1\">\n      <news12-list list-id=\"alphaList\"\n                   id=\"alphaList\"\n                   items=\"vm.alphaData\"\n                   item-click-handler=\"vm.alphaList_itemClickHandler\"\n                   show-icon=\"false\"\n                   down-is-next=\"false\"\n                   up-is-prev=\"true\"\n                   cancel-all-down-key-events=\"true\"\n                   next-component-handler=\"vm.alphaList_nextComponentHandler\"\n                   prev-component-handler=\"vm.listPrevComponentHandler\"></news12-list>\n    </div>\n    <div class=\"column column2\">\n      <div class=\"select-message\" ng-if=\"!vm.communities\">\n        Please make a selection to see what cities are available.\n      </div>\n      <div class=\"select-message\" ng-if=\"vm.communities && vm.communities.length === 0\">\n        No communities available.\n      </div>\n      <news12-list list-id=\"communityList\"\n                   id=\"communityList\"\n                   items=\"vm.communities\"\n                   show-icon=\"false\"\n                   up-is-prev=\"true\"\n                   down-is-next=\"false\"\n                   cancel-all-down-key-events=\"true\"\n                   ng-if=\"vm.communities && vm.communities.length\"\n                   item-click-handler=\"vm.communityList_itemClickHandler\"\n                   next-component-handler=\"vm.communityList_nextComponentHandler\"\n                   prev-component-handler=\"vm.communityList_prevComponentHandler\"></news12-list>\n    </div>\n    <div class=\"column column3\">\n      <div class=\"closings\">\n        <div class=\"closing\" ng-repeat=\"item in vm.closingsAndDelaysPage\" ng-if=\"vm.communities && vm.communities.length\">\n          <div class=\"item\" ng-if=\"item && item.ORG_NAME !== undefined\">\n            <span class=\"org\">{{item.ORG_NAME}}:</span> {{item.STATUS_DESCRIPTION}}\n          </div>\n        </div>\n      </div>\n      <div class=\"pagination\" ng-if=\"vm.closingsAndDelays.length && vm.communities && vm.communities.length\">\n        <span class=\"page\">\n          {{vm.page * vm.pageSize + 1}} - {{vm.pageEndIndex}}\n          of {{vm.closingsAndDelays.length}}\n        </span>\n        <div class=\"prevTarget\">\n          <news12-button id=\"prev\" ng-if=\"vm.hasPrev\" on-select=\"vm.prevSelectHandler()\" on-keydown=\"vm.prevNextMainLeftHandler(event, 'prev')\">Prev</news12-button>\n        </div>\n        <div class=\"nextTarget\">\n          <news12-button id=\"next\" ng-if=\"vm.hasNext\" on-select=\"vm.nextSelectHandler()\" on-keydown=\"vm.prevNextMainLeftHandler(event, 'next')\">Next</news12-button>\n          <news12-button on-select=\"vm.main_onSelect()\" on-keydown=\"vm.prevNextMainLeftHandler(event, 'main')\">Main</news12-button>\n        </div>\n      </div>\n    </div>\n  </div>\n</page-layout>\n"

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	/*---------------------------------------------------------*\
	 * Imports
	\*---------------------------------------------------------*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _keycodeUi = __webpack_require__(33);
	
	var _keycodeUi2 = _interopRequireDefault(_keycodeUi);
	
	var _pubsubJs = __webpack_require__(32);
	
	var _pubsubJs2 = _interopRequireDefault(_pubsubJs);
	
	/*---------------------------------------------------------*\
	 * Constants
	\*---------------------------------------------------------*/
	var labelMap = function labelMap(label) {
	  return {
	    label: label
	  };
	};
	var deps = {};
	/*---------------------------------------------------------*\
	 * ClosingsDelaysLanding
	\*---------------------------------------------------------*/
	
	var ClosingsDelaysLandingController = (function () {
	  //-----------------------------------
	  // Constructor
	  //-----------------------------------
	
	  function ClosingsDelaysLandingController($rootScope, regionService, navigationService, closingsAndDelaysService, localService, storageKeys, $timeout, $scope, $state, topics) {
	    var _this = this;
	
	    _classCallCheck(this, ClosingsDelaysLandingController);
	
	    this.name = 'closingsDelaysLanding';
	
	    this.regionService = regionService;
	    this.navigationService = navigationService;
	    this.closingsAndDelaysService = closingsAndDelaysService;
	    this.$timeout = $timeout;
	    this.currentRegion = localService.get(storageKeys.selectedRegion);
	
	    this.localService = localService;
	    this.storageKeys = storageKeys;
	
	    this.headerConfig = {
	      hideNewsTicker: true
	    };
	
	    deps.navigationService = navigationService;
	    deps.topics = topics;
	    deps.$state = $state;
	    deps.$scope = $scope;
	    deps.$rootScope = $rootScope;
	    this.alphaData = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').map(labelMap);
	    this.communities = undefined;
	    this.closingsAndDelays = undefined;
	
	    this.page = 0;
	    this.pageSize = 6;
	
	    this.alphaList_itemClickHandler = this.alphaList_itemClickHandler.bind(this);
	    this.communityList_itemClickHandler = this.communityList_itemClickHandler.bind(this);
	    this.communityList_prevComponentHandler = this.communityList_prevComponentHandler.bind(this);
	    this.communityList_nextComponentHandler = this.communityList_nextComponentHandler.bind(this);
	    this.alphaList_nextComponentHandler = this.alphaList_nextComponentHandler.bind(this);
	
	    var token1 = _pubsubJs2['default'].subscribe(deps.topics.headerMain.selectSection, function (msg, item) {
	      _this.onSectionSelect(item);
	    });
	
	    var token2 = _pubsubJs2['default'].subscribe(deps.topics.state.reactivate, function () {
	      if (deps.$rootScope.previousActiveElement) {
	        $timeout(function () {
	          _this.navigationService.focusEl('#alphaList');
	          delete deps.$rootScope.previousActiveElement;
	        });
	      }
	    });
	
	    var token3 = _pubsubJs2['default'].subscribe(deps.topics.state.inactivate, function () {
	      // clear when leaving to a modal like T&W weather or forcast video. When coming back start over
	      _this.communities = undefined;
	      _this.closingsAndDelays = undefined;
	    });
	
	    deps.$scope.$on('$destroy', function () {
	      _pubsubJs2['default'].unsubscribe(token1);
	      _pubsubJs2['default'].unsubscribe(token2);
	      _pubsubJs2['default'].unsubscribe(token3);
	    });
	  }
	
	  //-----------------------------------
	  // Lifecycle
	  //-----------------------------------
	
	  _createClass(ClosingsDelaysLandingController, [{
	    key: '$postLink',
	    value: function $postLink() {
	      var _this2 = this;
	
	      this.regionService.getCities(this.region).then(function (data) {
	        _this2.townships = data.data.DataSet['diffgr:diffgram'].NewDataSet.cities.map(function (city) {
	          return city.CITY;
	        });
	        _this2.navigationService.focusElAsync('#alphaList');
	      });
	    }
	
	    //-----------------------------------
	    // Properties
	    //-----------------------------------
	  }, {
	    key: 'updatePage',
	
	    //-----------------------------------
	    // Methods
	    //-----------------------------------
	    value: function updatePage() {
	      this._closingsAndDelaysPage = this._closingsAndDelays ? this._closingsAndDelays.slice(this.page * this.pageSize, this.page * this.pageSize + this.pageSize).concat() : [];
	
	      for (var i = this._closingsAndDelaysPage.length; i < 6; i++) {
	        this._closingsAndDelaysPage.push({});
	      }
	    }
	
	    //-----------------------------------
	    // Events
	    //-----------------------------------
	  }, {
	    key: 'alphaList_itemClickHandler',
	    value: function alphaList_itemClickHandler(event) {
	      this.alphaSelectedIndex = event.$index;
	
	      // clear old closings
	      this.closingsAndDelays = undefined;
	
	      this.communities = this.townships.filter(function (town) {
	        return town ? town.charAt(0) === event.item.label : false;
	      }).map(labelMap);
	
	      if (this.communities.length) {
	        this.navigationService.focusElAsync('#communityList');
	      }
	    }
	  }, {
	    key: 'listPrevComponentHandler',
	    value: function listPrevComponentHandler(index, up) {
	      if (up) {
	        deps.navigationService.focusEl('navbar');
	      }
	    }
	  }, {
	    key: 'communityList_itemClickHandler',
	    value: function communityList_itemClickHandler(event) {
	      var _this3 = this;
	
	      this.page = 0;
	
	      this.communityListIndex = event.$index;
	
	      this.closingsAndDelaysService.getClosings(this.region, event.item.label).then(function (data) {
	        _this3.closingsAndDelays = data.data.DataSet.NewDataSet.closings;
	
	        _this3.navigationService.focusElAsync('.nextTarget');
	      });
	    }
	  }, {
	    key: 'alphaList_nextComponentHandler',
	    value: function alphaList_nextComponentHandler(nextIndex, down) {
	      if (down) {
	        return;
	      }
	      this.alphaSelectedIndex = nextIndex;
	
	      if (this.communities && this.communities.length) {
	        this.navigationService.focusElAsync('#communityList', this.communityListIndex);
	      }
	    }
	  }, {
	    key: 'communityList_prevComponentHandler',
	    value: function communityList_prevComponentHandler(nextIndex, isUp) {
	      this.communityListIndex = nextIndex;
	
	      if (isUp) {
	        deps.navigationService.focusEl('navbar');
	      } else {
	        deps.navigationService.focusEl('#alphaList', this.alphaSelectedIndex);
	      }
	    }
	  }, {
	    key: 'communityList_nextComponentHandler',
	    value: function communityList_nextComponentHandler(nextIndex, down) {
	      this.communityListIndex = nextIndex;
	
	      // If the user has pressed right from communities
	      if (!down && this.communities && this.communities.length) {
	        if (document.getElementById('prev')) {
	          this.navigationService.focusElAsync('#prev');
	        } else if (document.getElementById('next')) {
	          this.navigationService.focusElAsync('#next');
	        } else if (document.getElementById('main')) {
	          this.navigationService.focusElAsync('#main');
	        }
	      }
	    }
	  }, {
	    key: 'prevSelectHandler',
	    value: function prevSelectHandler() {
	      this.page -= 1;
	
	      if (this.page === 0) {
	        this.navigationService.focusElAsync('.nextTarget');
	      }
	    }
	  }, {
	    key: 'nextSelectHandler',
	    value: function nextSelectHandler() {
	      this.page += 1;
	
	      if (this.page + 1 === this.totalPages) {
	        this.navigationService.focusElAsync('.prevTarget');
	      }
	    }
	  }, {
	    key: 'main_onSelect',
	    value: function main_onSelect() {
	      this.page = 0;
	
	      if (this.page === 0) {
	        this.navigationService.focusElAsync('.nextTarget');
	      }
	    }
	  }, {
	    key: 'prevNextMainLeftHandler',
	    value: function prevNextMainLeftHandler(event, which) {
	      if (_keycodeUi2['default'].isLeft(event) && (which === 'main' && !this.hasNext && !this.hasPrev || which === 'prev' || which === 'next' && !this.hasPrev)) {
	        this.navigationService.focusElAsync('#communityList', this.communityListIndex);
	      }if (_keycodeUi2['default'].isUp(event)) {
	        this.navigationService.focusElAsync('navbar', 'last');
	      }
	    }
	  }, {
	    key: 'onSectionSelect',
	    value: function onSectionSelect(item) {
	      if (item && item.state && item.state.name) {
	        if (item.state.params) {
	          deps.$state.go(item.state.name, item.state.params);
	        } else {
	          deps.$state.go(item.state.name);
	        }
	      }
	    }
	  }, {
	    key: 'closingsAndDelays',
	    set: function set(value) {
	      this._closingsAndDelays = value;
	
	      this.updatePage();
	    },
	    get: function get() {
	      return this._closingsAndDelays;
	    }
	  }, {
	    key: 'page',
	    set: function set(value) {
	      this._page = value;
	
	      this.updatePage();
	    },
	    get: function get() {
	      return this._page;
	    }
	  }, {
	    key: 'closingsAndDelaysPage',
	    get: function get() {
	      return this._closingsAndDelaysPage;
	    }
	  }, {
	    key: 'totalPages',
	    get: function get() {
	      return this.closingsAndDelays ? Math.ceil(this.closingsAndDelays.length / this.pageSize) : 0;
	    }
	  }, {
	    key: 'hasNext',
	    get: function get() {
	      return this.page + 1 < this.totalPages;
	    }
	  }, {
	    key: 'hasPrev',
	    get: function get() {
	      return this.page > 0;
	    }
	  }, {
	    key: 'pageEndIndex',
	    get: function get() {
	      return Math.min(this.page * this.pageSize + this.pageSize, this.closingsAndDelays.length);
	    }
	  }, {
	    key: 'region',
	    get: function get() {
	      var _region = this.localService.get(this.storageKeys.selectedRegion);
	
	      return _region ? _region.abbr : 'LI';
	    }
	  }]);
	
	  return ClosingsDelaysLandingController;
	})();
	
	ClosingsDelaysLandingController.$inject = ['$rootScope', 'regionService', 'navigationService', 'closingsAndDelaysService', 'localService', 'storageKeys', '$timeout', '$scope', '$state', 'topics'];
	
	exports['default'] = ClosingsDelaysLandingController;
	module.exports = exports['default'];

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(86);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../node_modules/css-loader/index.js!./../../../../node_modules/sass-loader/index.js!./closingsDelaysLanding.scss", function() {
				var newContent = require("!!./../../../../node_modules/css-loader/index.js!./../../../../node_modules/sass-loader/index.js!./closingsDelaysLanding.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "closings-delays-landing{font-size:0;color:#dadada}closings-delays-landing .column{position:relative;margin:0;padding:0;margin-right:-.25vmin;vertical-align:top}closings-delays-landing .column news12-list label{margin-right:2.25vw}closings-delays-landing .column news12-list li:focus label{color:#ffac25}closings-delays-landing .column .down-arrow,closings-delays-landing .column .up-arrow{margin:0;padding:0}closings-delays-landing .column .down-arrow .up,closings-delays-landing .column .up-arrow .up{width:0;height:0;border-left:1vw solid transparent;border-right:1vw solid transparent;border-bottom:1.4vh solid #dadada;float:right;margin:1vh 2.5vw}closings-delays-landing .column .down-arrow .down,closings-delays-landing .column .up-arrow .down{width:0;height:0;border-left:1vw solid transparent;border-right:1vw solid transparent;border-top:1.4vh solid #dadada;float:right;margin:1vh 2.5vw}closings-delays-landing .column ul{clear:both}closings-delays-landing .main,closings-delays-landing .row1 div{font-size:4vmin;font-weight:700;margin:3.5vh}closings-delays-landing .column1{height:100%;width:15%;text-align:right}closings-delays-landing .column2{height:100%;width:27%}closings-delays-landing .column3{height:100%;width:58%}closings-delays-landing .row{position:relative}closings-delays-landing .row1{height:10vh}closings-delays-landing .row1 .column{display:inline-block;border:none;margin:0;padding:0}closings-delays-landing .row2{height:50vh}closings-delays-landing .row2 .column{display:inline-block;border-left:.25vmin solid #a5b3d3;border-top:.25vmin solid #a5b3d3}closings-delays-landing .row2 .column1{border-left:none}closings-delays-landing .row2 .column1 news12-list,closings-delays-landing .row2 .column2 news12-list{height:100%}closings-delays-landing .row2 .column2 .down-arrow .down,closings-delays-landing .row2 .column2 .down-arrow .up,closings-delays-landing .row2 .column2 .up-arrow .down,closings-delays-landing .row2 .column2 .up-arrow .up{float:left;margin-left:50%}closings-delays-landing .row2 .column3{overflow:hidden;position:relative}closings-delays-landing .row2 .column3 .closings{margin:0;padding:0}closings-delays-landing .row2 .column3 .closings .closing{font-size:2.4vmin;border-bottom:.25vmin solid #232a51;padding:.9vw 2vw;margin:0;font-weight:400;height:3.2vh}closings-delays-landing .row2 .column3 .pagination{position:absolute;right:0;bottom:0;margin:2vh;padding:0;font-size:2.5vmin}closings-delays-landing .row2 .column3 .pagination .nextTarget,closings-delays-landing .row2 .column3 .pagination .prevTarget{display:inline-block;margin:0;padding:0}closings-delays-landing .row2 .column3 .pagination .page{margin-right:1vw}closings-delays-landing .row2 .column3 .pagination news12-button{height:2.4vh}closings-delays-landing .row2 .column3 .pagination news12-button button>div{padding:.8vh .8vw}closings-delays-landing .row2 .select-message{font-size:3vmin;font-weight:400;margin:3.5vh}", ""]);
	
	// exports


/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	stateConfiguration.$inject = ["$stateProvider"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _videoplayerComponent = __webpack_require__(88);
	
	var _videoplayerComponent2 = _interopRequireDefault(_videoplayerComponent);
	
	var stateSettings = {
	  name: 'app.videoplayer',
	  state: {
	    url: '/videoplayer',
	    sticky: false, // keep this. we test for sticky === false
	    views: {
	      '': {
	        template: '<videoplayer></videoplayer>'
	      }
	    },
	    title: {
	      key: 'app.videoplayer.title',
	      en: 'Videoplayer'
	    },
	    params: {
	      currentStory: undefined,
	      category: undefined,
	      ad: undefined
	    }
	  }
	};
	
	/* @ngInject */
	function stateConfiguration($stateProvider) {
	  $stateProvider.state(stateSettings.name, stateSettings.state);
	}
	
	var videoplayerModule = _angular2['default'].module('videoplayer', [_angularUiRouter2['default'], 'constants']).config(stateConfiguration).component('videoplayer', _videoplayerComponent2['default']);
	
	exports['default'] = videoplayerModule;
	module.exports = exports['default'];

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _videoplayerHtml = __webpack_require__(89);
	
	var _videoplayerHtml2 = _interopRequireDefault(_videoplayerHtml);
	
	var _videoplayerController = __webpack_require__(90);
	
	var _videoplayerController2 = _interopRequireDefault(_videoplayerController);
	
	__webpack_require__(95);
	
	exports['default'] = {
	  restrict: 'E',
	  bindings: {},
	  template: _videoplayerHtml2['default'],
	  controller: _videoplayerController2['default'],
	  controllerAs: 'vm'
	};
	module.exports = exports['default'];

/***/ },
/* 89 */
/***/ function(module, exports) {

	module.exports = "<div class=\"videoplayer focusable\" tabindex=\"0\" ng-keydown=\"vm.remoteKey($event)\" ng-init=\"vm.timeoutPlay()\">\n  <videogular\n      vg-player-ready=\"vm.onPlayerReady($API)\"\n      vg-theme=\"vm.config.theme\"\n      vg-plays-inline=\"vm.config.playsInline\"\n      vg-native-fullscreen=\"false\"\n      vg-error=\"vm.onError($event)\"\n      vg-complete=\"vm.onComplete()\">\n    <vg-media vg-src=\"vm.config.sources\" vg-loop=\"vg.config.loop\">\n    </vg-media>\n    <vg-controls ng-hide=\"vm.lockControls\">\n      <vg-play-pause-button ng-keydown=\"vm.playPause($event)\" class=\"focusable\"></vg-play-pause-button>\n      <vg-playback-button vg-speeds=\"[1]\"></vg-playback-button>\n      <vg-scrub-bar ng-keydown=\"vm.scroll($event)\">\n        <vg-scrub-bar-current-time class=\"focusable\"></vg-scrub-bar-current-time>\n      </vg-scrub-bar>\n      <vg-time-display>{{ currentTime | date:'mm:ss' }}</vg-time-display>\n    </vg-controls>\n    <vg-preroll ng-if=\"vm.playPreroll\" lock-controls=\"vm.lockControls\" region=\"vm.region\" category=\"vm.category\" on-complete=\"vm.onPrerollComplete()\"></vg-preroll>\n    <vg-buffering></vg-buffering>\n  </videogular>\n</div>\n"

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	/*---------------------------------------------------------*\
	 * Imports
	\*---------------------------------------------------------*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _keycodeUi = __webpack_require__(33);
	
	var _keycodeUi2 = _interopRequireDefault(_keycodeUi);
	
	var _mimeTypes = __webpack_require__(91);
	
	var _mimeTypes2 = _interopRequireDefault(_mimeTypes);
	
	var _lodash = __webpack_require__(35);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	/*---------------------------------------------------------*\
	 * constants
	\*---------------------------------------------------------*/
	var deps = {};
	/*---------------------------------------------------------*\
	 * VideoplayerController
	\*---------------------------------------------------------*/
	
	var VideoplayerController = (function () {
	  /* ----------------------------------- *\
	   * Constructor
	  \* ----------------------------------- */
	
	  function VideoplayerController($rootScope, $scope, $sce, $timeout, $state, $interval, $stateParams, states, navigationService, localService, topics, storageKeys, adRotationFrequency) {
	    var _this = this;
	
	    _classCallCheck(this, VideoplayerController);
	
	    deps.$rootScope = $rootScope;
	    deps.$scope = $scope;
	    deps.$state = $state;
	    deps.states = states;
	    deps.$timeout = $timeout;
	    deps.$interval = $interval;
	    deps.navigationService = navigationService;
	    deps.topics = topics;
	    deps.$stateParams = $stateParams;
	    deps.localService = localService;
	    deps.storageKeys = storageKeys;
	    deps.adRotationFrequency = adRotationFrequency;
	
	    this.name = 'videoplayer';
	    this.currentPlayerState = 'Stop';
	    this.API = null;
	    this.lockControls = false;
	    // Ad and Preroll related params
	    this.isAd = deps.$stateParams.ad !== undefined;
	    this.playPreroll = this.shouldPlayPreroll();
	    var selectedRegion = deps.localService.get(deps.storageKeys.selectedRegion);
	    this.region = selectedRegion ? selectedRegion.abbr : 'LI';
	    this.category = deps.$stateParams.category || 'news';
	    if (this.isAd) {
	      this.videoSource = deps.$stateParams.ad ? deps.$stateParams.ad.src : null;
	    } else {
	      this.videoSource = deps.$stateParams.currentStory ? deps.$stateParams.currentStory.story.videoUrl : null;
	    }
	
	    if (!this.playPreroll && !this.isAd) {
	      // Preroll in not going to play, but we still need to increment video play count
	      this.incrementPrerollCount();
	    }
	
	    deps.$timeout(function () {
	      var mimeType = undefined;
	      // amazon fire TV workaround for MPG files. Currently MPG videos do not play on firetv.
	      // if the mimetype is set to video/mpeg.
	      // therefore we are forcefully faking it to use .mp4 when the extension is mpg.
	      if (_lodash2['default'].contains(_this.videoSource, '.mpg')) {
	        mimeType = 'video/mp4';
	      } else {
	        mimeType = _mimeTypes2['default'].lookup(_this.videoSource);
	      }
	      _this.config = {
	        autohide: true,
	        autohideTime: 1000,
	        playsInline: false,
	        loop: false,
	        preload: 'none',
	        sources: [{
	          src: $sce.trustAsResourceUrl(_this.videoSource),
	          type: mimeType
	        }],
	        theme: './../../../assets/videogular/videogular.css'
	      };
	    });
	
	    deps.$scope.$on('$destroy', function () {
	      deps.$interval.cancel(_this.promise);
	    });
	  }
	
	  _createClass(VideoplayerController, [{
	    key: '$postLink',
	    value: function $postLink() {
	      deps.navigationService.focusElAsync(this.name);
	    }
	  }, {
	    key: 'shouldPlayPreroll',
	    value: function shouldPlayPreroll() {
	      // determine if preroll ad should play
	      if (this.isAd) {
	        // don't preroll on top of video ads
	        return false;
	      }
	      return this.prerollCount === 0;
	    }
	  }, {
	    key: 'incrementPrerollCount',
	    value: function incrementPrerollCount() {
	      this.prerollCount = (this.prerollCount + 1) % deps.adRotationFrequency;
	    }
	  }, {
	    key: 'onPlayerReady',
	    value: function onPlayerReady(API) {
	      this.API = API;
	      this.API.playsInline = true;
	      this.API.setPlayback(1);
	    }
	  }, {
	    key: 'timeoutPlay',
	    value: function timeoutPlay() {
	      var _this2 = this;
	
	      deps.$timeout(function () {
	        _this2.API.toggleFullScreen();
	        _this2.API.play();
	        _this2.currentStatus = deps.topics.playerStates.play.name;
	      });
	    }
	  }, {
	    key: 'seekRepeat',
	    value: function seekRepeat(option, scroll) {
	      var _this3 = this;
	
	      var totalTime = this.API.totalTime / 1000;
	      var currentTime = this.API.currentTime / 1000;
	      var frameTime = totalTime / 100 * 3;
	
	      if (option === deps.topics.playerStates.forward.name) {
	        if (totalTime >= currentTime + frameTime) {
	          var scrollSpeed = scroll ? 1 : 2;
	          this.API.pause();
	          this.API.seekTime(currentTime + frameTime);
	          this.currentStatus = deps.topics.playerStates.forward.name;
	          this.API.setPlayback(scrollSpeed);
	        } else {
	          this.API.seekTime(totalTime);
	          deps.$interval.cancel(this.promise);
	          this.currentStatus = deps.topics.playerStates.play.name;
	          this.goBack();
	        }
	      } else if (option === deps.topics.playerStates.rewind.name) {
	        if (currentTime - 3 > 0) {
	          var scrollSpeed = scroll ? 1 : -2;
	          this.API.seekTime(currentTime - frameTime);
	          this.currentStatus = deps.topics.playerStates.rewind.name;
	          this.API.setPlayback(scrollSpeed);
	        } else {
	          deps.$interval.cancel(this.promise);
	          this.API.stop();
	          this.currentStatus = this.API.currentState;
	          this.API.setPlayback(1);
	          this.API.seekTime(0);
	          deps.$timeout(function () {
	            _this3.API.play();
	            _this3.currentStatus = deps.topics.playerStates.play.name;
	          });
	        }
	      }
	    }
	  }, {
	    key: 'remoteKey',
	    value: function remoteKey(e) {
	      var _this4 = this;
	
	      var ignoreVideoControls = this.lockControls || this.isAd;
	      if (_angular2['default'].isDefined(this.promise)) {
	        deps.$interval.cancel(this.promise);
	      }
	      switch (true) {
	        // BACK BUTTON
	        case _keycodeUi2['default'].isBack(e):
	          // removing this due to android webview issue. Once we have ability to
	          // handle android webview back we can reenable this
	          // e.preventDefault();
	          break;
	        // UP / DOWN
	        case _keycodeUi2['default'].isDown(e) || _keycodeUi2['default'].isUp(e):
	          if (!ignoreVideoControls) {
	            deps.navigationService.focusElAsync('.controls-container');
	          }
	          break;
	        // PLAY / PAUSE
	        case _keycodeUi2['default'].isPlayPause(e):
	          if (!ignoreVideoControls) {
	            if (this.currentStatus === deps.topics.playerStates.play.name) {
	              this.API.playPause();
	            } else {
	              this.API.play();
	            }
	            this.currentStatus = deps.topics.playerStates.play.name;
	            this.API.setPlayback(1);
	          }
	          break;
	        // RWD
	        case _keycodeUi2['default'].isRewind(e):
	          if (!ignoreVideoControls) {
	            this.promise = deps.$interval(function () {
	              _this4.seekRepeat(deps.topics.playerStates.rewind.name);
	            }, 100);
	          }
	          break;
	        // FF
	        case _keycodeUi2['default'].isFastForward(e) && !ignoreVideoControls:
	          if (!ignoreVideoControls) {
	            this.promise = deps.$interval(function () {
	              _this4.seekRepeat(deps.topics.playerStates.forward.name);
	            }, 100);
	          }
	          break;
	      }
	    }
	  }, {
	    key: 'playPause',
	    value: function playPause(e) {
	      if (_keycodeUi2['default'].isEnter(e)) {
	        this.API.playPause();
	      } else if (_keycodeUi2['default'].isRight(e)) {
	        _angular2['default'].element(document.getElementsByTagName('vg-scrub-bar'))[0].focus();
	      }
	    }
	  }, {
	    key: 'scroll',
	    value: function scroll(e) {
	      var _this5 = this;
	
	      e.preventDefault();
	      if (_keycodeUi2['default'].isLeft(e)) {
	        this.seekRepeat(deps.topics.playerStates.rewind.name, true);
	      } else if (_keycodeUi2['default'].isRight(e)) {
	        this.seekRepeat(deps.topics.playerStates.forward.name, true);
	        deps.$timeout(function () {
	          _this5.API.play();
	        }, 100);
	      } else if (_keycodeUi2['default'].isPlayPause(e)) {
	        this.currentStatus = deps.topics.playerStates.play.name;
	      }
	      this.API.setPlayback(1);
	    }
	  }, {
	    key: 'onComplete',
	    value: function onComplete() {
	      // go back when video completes
	      this.goBack();
	    }
	  }, {
	    key: 'onPrerollComplete',
	    value: function onPrerollComplete() {
	      this.incrementPrerollCount();
	    }
	  }, {
	    key: 'goBack',
	    value: function goBack() {
	      deps.$state.go(deps.$rootScope.previousState.name, deps.$rootScope.previousParams);
	    }
	  }, {
	    key: 'prerollCount',
	    get: function get() {
	      return deps.localService.get(deps.storageKeys.adPlayCount) || 0;
	    },
	    set: function set(count) {
	      deps.localService.set(deps.storageKeys.adPlayCount, count);
	    }
	  }]);
	
	  return VideoplayerController;
	})();
	
	VideoplayerController.$inject = ['$rootScope', '$scope', '$sce', '$timeout', '$state', '$interval', '$stateParams', 'states', 'navigationService', 'localService', 'topics', 'storageKeys', 'adRotationFrequency'];
	
	exports['default'] = VideoplayerController;
	module.exports = exports['default'];

/***/ },
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(96);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../node_modules/css-loader/index.js!./../../../../node_modules/sass-loader/index.js!./videoplayer.scss", function() {
				var newContent = require("!!./../../../../node_modules/css-loader/index.js!./../../../../node_modules/sass-loader/index.js!./videoplayer.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "h1{font-family:Roboto,Helvetica,Arial,sans-serif;font-size:4.3vmin;font-weight:500;line-height:9vmin}h1,h2{margin:0}h2{font-family:Roboto Condensed,Arial Narrow,Helvetica,Arial,sans-serif;font-size:3.5vmin;font-weight:400}.videoplayer{width:100vw;height:100vh;background-color:#000;margin:auto;overflow:hidden}.videoplayer videogular{width:100%;height:100%}.videoplayer videogular .container{margin:0;padding:0;position:absolute;width:100%;height:.5vh;top:3vh}.videoplayer videogular vg-scrub-bar .container{top:45%}", ""]);
	
	// exports


/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	stateConfiguration.$inject = ["$stateProvider"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _weatherHomeLandingComponent = __webpack_require__(98);
	
	var _weatherHomeLandingComponent2 = _interopRequireDefault(_weatherHomeLandingComponent);
	
	/* CHANGE weatherhome TO weather ONCE WEATHER CENTER NAVBARSUBMENU IS DONE*/
	var stateSettings = {
	  name: 'app.home.weatherhome',
	  state: {
	    url: '/weather?subRegion',
	    views: {
	      'home@app': {
	        template: '<weather-home-landing></weather-home-landing>'
	      }
	    },
	    title: {
	      key: 'app.weatherHomeLanding.title',
	      en: 'weather'
	    }
	  }
	};
	
	/* @ngInject */
	function stateConfiguration($stateProvider) {
	  $stateProvider.state(stateSettings.name, stateSettings.state);
	}
	
	var weatherHomeLandingModule = _angular2['default'].module('weatherHomeLanding', [_angularUiRouter2['default'], 'constants', 'app.services']).config(stateConfiguration).component('weatherHomeLanding', _weatherHomeLandingComponent2['default']);
	
	exports['default'] = weatherHomeLandingModule;
	module.exports = exports['default'];

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _weatherHomeLandingHtml = __webpack_require__(99);
	
	var _weatherHomeLandingHtml2 = _interopRequireDefault(_weatherHomeLandingHtml);
	
	var _weatherHomeLandingController = __webpack_require__(100);
	
	var _weatherHomeLandingController2 = _interopRequireDefault(_weatherHomeLandingController);
	
	__webpack_require__(101);
	
	exports['default'] = {
	  restrict: 'E',
	  bindings: {
	    subRegion: '<',
	    leftNavItems: '<',
	    badge: '@',
	    title: '@',
	    region: '<',
	    modal: '<'
	  },
	  template: _weatherHomeLandingHtml2['default'],
	  controller: _weatherHomeLandingController2['default'],
	  controllerAs: 'vm'
	};
	module.exports = exports['default'];

/***/ },
/* 99 */
/***/ function(module, exports) {

	module.exports = "<page-layout-w-t title=\"Weather\"\n                 left-nav-items=\"vm.leftNavItems\"\n                 subnav-menu-items=\"vm.subnavMenuItems\"\n                 region=\"vm.currentRegion\"\n                 modal = \"vm.activeModal\">\n  <navbar ng-if=\"vm.showMenu == true\"\n          items=\"vm.subnavMenuItems\"\n          selected-index=\"vm.selectedIndex\"\n          on-select=\"vm.selectPage(item)\">\n  </navbar>\n  <navbar class=\"test\"\n          ng-if=\"vm.showSubMenu == true\"\n          items=\"vm.subnavSecondaryMenuItems\"\n          selected-index=\"vm.selectedIndex\"\n          on-select=\"vm.selectPage(item)\">\n  </navbar>\n  <div class=\"left-aside\">\n    <div class=\"left-navbar\">\n      <news12-button ng-repeat=\"item in vm.leftNavItems\" badge=\"{{item.badge}}\" on-select=\"vm.navSelect(item)\">\n        {{item.title}}\n      </news12-button>\n      <news12-button class=\"weather_alert_button\" on-select=\"vm.weatherAlert_onSelect()\" ng-show=\"vm.showWeatherAlertButton\">Weather Alert</news12-button>\n    </div>\n    <div class=\"left-aside-promo-banner\">\n      <news12-ad region=\"vm.currentRegion\" ad-location=\"vm.adProps.photos.leftBannerLocation\" section=\"vm.adProps.photos.sectionName\"></news12-ad>\n    </div>\n  </div>\n  <div class=\"right-aside\">\n    <div class=\"secondary-section-content main-content\">\n      <div ng-if=\"vm.loading\" class=\"load\">\n        <i class=\"load-spinner fa fa-spinner fa-pulse fa-5x\"></i>\n      </div>\n      <img ng-if=\"vm.isActiveSection('Region') == false && vm.showWeatherAlert == false && !vm.loading\" sub-region= \"vm.currentRegion\" src={{vm.activeSection.link}}>\n      <other-regions ng-if=\"vm.isActiveSection('Region') && vm.showWeatherAlert == false\"\n                     title=\"Choose a Location:\"\n                     on-select=\"vm.onRegionSelect(region)\"\n                     current-region=\"vm.currentRegion\">\n      </other-regions>\n      <div class=\"weather_alert_main\" ng-show=\"vm.showWeatherAlert\">\n        <h1>Weather Alert</h1>\n        <div id=\"weather_alert_message\"></div>\n      </div>\n    </div>\n  </div>\n\n</page-layout-w-t>\n"

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	/*---------------------------------------------------------*\
	 * Imports
	 \*---------------------------------------------------------*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _lodash = __webpack_require__(35);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _pubsubJs = __webpack_require__(32);
	
	var _pubsubJs2 = _interopRequireDefault(_pubsubJs);
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var deps = {};
	
	/*---------------------------------------------------------*\
	 * Weakmaps
	 \*---------------------------------------------------------*/
	var TIMEOUT = new WeakMap();
	var TOPICS = new WeakMap();
	var NAVIGATION = new WeakMap();
	
	/*---------------------------------------------------------*\
	 * WeatherHomeLanding
	 \*---------------------------------------------------------*/
	function gotoVideo(story) {
	  deps.$state.go(deps.states.videoplayer, { category: 'weather', currentStory: story }, { location: true });
	}
	
	var WeatherHomeLandingController = (function () {
	  //-----------------------------------
	  // Constructor
	  //-----------------------------------
	
	  function WeatherHomeLandingController($q, $state, $stateParams, $scope, $timeout, topics, navigationService, photos, weatherVideoService, weatherCurrentService, localService, storageKeys, states, tickerService, adProps, $rootScope) {
	    var _this = this;
	
	    _classCallCheck(this, WeatherHomeLandingController);
	
	    TIMEOUT.set(this, $timeout);
	    TOPICS.set(this, topics);
	    NAVIGATION.set(this, navigationService);
	
	    deps.$state = $state;
	    deps.$rootScope = $rootScope;
	    this.adProps = adProps;
	    deps.tickerService = tickerService;
	    deps.$stateParams = $stateParams;
	    this.name = 'weatherHomeLanding';
	    deps.states = states;
	    this.$scope = $scope;
	    this.photos = photos;
	
	    deps.weatherVideoService = weatherVideoService;
	    deps.localService = localService;
	    // this.currentRegion is the LOCAL region variable
	    this.currentRegion = deps.$stateParams.subRegion ? JSON.parse(deps.$stateParams.subRegion) : localService.get(storageKeys.selectedRegion);
	    // const region is the GLOBAL region variable
	    var region = _lodash2['default'].isUndefined(this.subRegion) ? deps.localService.get(storageKeys.selectedRegion) : this.subRegion;
	    $q.all([this.loadWeatherVideo(this.currentRegion), this.loadTicker(this.currentRegion)]).then(function (values) {
	      var menu = values[0];
	      var link = menu.rss.channel.item['media:content'].url;
	      _this.currentStory = {
	        story: { videoUrl: link }
	      };
	      if (_this.tickerData.type === 'WEATHER ALERT') {
	        _this.showWeatherAlertButton = true;
	        _this.showWeatherAlert = true;
	        _this.setAlertBadge(_this.leftNavItems, _this.tickerData);
	      }
	    });
	
	    this.showWeatherAlertButton = false;
	    this.showWeatherAlert = false;
	    this.showSubMenu = false;
	    this.showMenu = true;
	    this.leftNavItems = [{
	      id: 'news',
	      title: 'News',
	      state: deps.states.home,
	      sections: []
	    }, {
	      id: 'traffic',
	      title: 'Traffic',
	      state: deps.states.traffic_center,
	      sections: []
	    }];
	    this.subnavMenuItems = [{
	      title: 'Current',
	      id: 'Current'
	    }];
	    var token = _pubsubJs2['default'].subscribe(TOPICS.get(this).nav.enter, function (msg, data) {
	      if (data.source === 'navbar') {
	        _this.showWeatherAlert = false;
	        // When clicking on subnav
	        for (var i in _this.subnavMenuItems) {
	          if (({}).hasOwnProperty.call(_this.subnavMenuItems, i)) {
	            if (data.data === _this.subnavMenuItems[_this.subnavMenuItems.length - 1]) {
	              _this.subNavSelect(_this.subnavMenuItems[_this.subnavMenuItems.length - 1]);
	            } else if (data.data === _this.subnavMenuItems[i]) {
	              if (!_lodash2['default'].isUndefined(_this.subRegion)) {
	                weatherCurrentService.getWeatherSubMenu(region.abbr).then(_this.applySubMenu.bind(_this));
	              } else {
	                weatherCurrentService.getWeatherSubMenu(_this.currentRegion.abbr).then(_this.applySubMenu.bind(_this));
	              }
	            } else {
	              _this.subNavSelect(data.data);
	            }
	          }
	        }
	        // when clicking on subnavSecondary
	        for (var i in _this.subnavSecondaryMenuItems) {
	          if (({}).hasOwnProperty.call(_this.subnavMenuItems, i)) {
	            _this.showWeatherAlert = false;
	            if (data.data === _this.subnavSecondaryMenuItems[i]) {
	              // When clicking on back on subnavsecondary
	              if (data.data === _this.subnavSecondaryMenuItems[0]) {
	                _this.showSubMenu = false;
	                _this.showMenu = true;
	                data.data = _this.subnavMenuItems[0];
	                //  When clicking on forecast video
	              } else if (data.data.title === 'Forecast Video') {
	                  gotoVideo(_this.currentStory);
	                } else {
	                  _this.subNavSelect(_this.subnavSecondaryMenuItems[i]);
	                  var currentlink = _this.subnavSecondaryMenuItems[i].link;
	                  if (data.data.title === _this.subnavSecondaryMenuItems[i].id) {
	                    _this.selectImage(currentlink);
	                    break;
	                  }
	                }
	            } else {
	              _this.subNavSelect(data.data);
	            }
	          }
	        }
	        _this.$scope.$apply();
	      }
	    });
	
	    var token1 = _pubsubJs2['default'].subscribe(topics.state.reactivate, function () {
	      if (deps.$rootScope.previousActiveElement) {
	        // Restore focus to previously focused dom element
	        $timeout(function () {
	          if (_this.isFocusLost(deps.$rootScope.previousActiveElement)) {
	            NAVIGATION.get(_this).focusElAsync('.main-content');
	          } else {
	            _this.subNavSelect(_this.subnavMenuItems[1]);
	            _this.selectedIndex = 1;
	          }
	          delete deps.$rootScope.previousActiveElement;
	        });
	      }
	    });
	
	    this.$scope.$on('$destroy', function () {
	      _pubsubJs2['default'].unsubscribe(token);
	      _pubsubJs2['default'].unsubscribe(token1);
	    });
	
	    weatherCurrentService.getWeatherSubMenu(this.currentRegion.abbr).then(this.applyMenu.bind(this));
	    this.$onInit = function () {
	      _this.selectedIndex = 0;
	    };
	    this.subNavSelect(this.subnavMenuItems[0]);
	  }
	
	  //-----------------------------------
	  // Methods
	  //-----------------------------------
	
	  _createClass(WeatherHomeLandingController, [{
	    key: 'subNavSelect',
	    value: function subNavSelect(item) {
	      var _this2 = this;
	
	      this.activeSection = item;
	      // This initial timeout is necessary to wait for the old .main-content to have
	      // been cleared from the DOM
	      TIMEOUT.get(this)(function () {
	        if (_this2.showMenu) {
	          // focus on navbar
	          NAVIGATION.get(_this2).focusElAsync('.selected');
	        } else {
	          // focus on subnavbar
	          NAVIGATION.get(_this2).focusElAsync('navbar.test .selected');
	        }
	      });
	    }
	  }, {
	    key: 'isFocusLost',
	    value: function isFocusLost(prevHtmlElement) {
	      // if for any reason focus is lost and lands on the body or a subNavItem element was the last item focused
	      // before changing state then set focus to the main content section. Mostly used for T&W and forecast video
	      // https://tools.emedia.cv.net/jira/browse/NSW-424
	      // but can be used for other use cases
	      if (_angular2['default'].isDefined(prevHtmlElement) && (_lodash2['default'].contains(prevHtmlElement.tagName.toLowerCase(), 'body') || _lodash2['default'].contains(prevHtmlElement.className, 'sub-nav-item'))) {
	        NAVIGATION.get(this).focusElAsync('.main-content');
	      }
	    }
	  }, {
	    key: 'loadTicker',
	    value: function loadTicker(region) {
	      var _this3 = this;
	
	      var regions = region ? region.abbr : 'LI';
	      return deps.tickerService.getTicker(regions).then(function (res) {
	        _this3.tickerData = {
	          type: res.data.rss.channel.item.title,
	          message: res.data.rss.channel.item.content
	        };
	        return res.data;
	      });
	    }
	  }, {
	    key: 'loadWeatherVideo',
	    value: function loadWeatherVideo(region) {
	      var regions = region ? region.abbr : 'LI';
	      return deps.weatherVideoService.getweatherVideo(regions).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: 'setAlertBadge',
	    value: function setAlertBadge(menu, type) {
	      var el = document.getElementById('weather_alert_message');
	      var types = {
	        'WEATHER ALERT': 'weather',
	        'TRAFFIC ALERT': 'traffic'
	      };
	      var id = types[type.type];
	      if (id) {
	        menu.forEach(function (item) {
	          item.badge = item.id === id ? 'Alert' : null;
	        });
	      }
	      el.innerHTML = 'loading...';
	      el.innerHTML = type.message;
	    }
	  }, {
	    key: 'isActiveSection',
	    value: function isActiveSection(section) {
	      return section === this.activeSection.id;
	    }
	  }, {
	    key: 'navSelect',
	    value: function navSelect(item) {
	      if (item && item.state) {
	        deps.$state.go(item.state);
	      }
	    }
	  }, {
	    key: 'onRegionSelect',
	    value: function onRegionSelect(region) {
	      deps.$state.go(deps.$state.$current, { subRegion: JSON.stringify(region) });
	      this.selectedIndex = 0;
	      this.subNavSelect(this.subnavMenuItems[0]);
	    }
	  }, {
	    key: 'weatherAlert_onSelect',
	    value: function weatherAlert_onSelect() {
	      this.showWeatherAlert = true;
	    }
	  }, {
	    key: 'selectImage',
	    value: function selectImage(item) {
	      var _this4 = this;
	
	      // Create temporary image attribute so we can load the image and display
	      // loading while it is coming in.
	      var img = document.createElement('img');
	
	      this.loading = true;
	      this.error = false;
	
	      img.addEventListener('load', function () {
	        _this4.loading = false;
	        _this4.$scope.$apply();
	      });
	
	      img.addEventListener('error', function () {
	        _this4.error = true;
	        _this4.loading = false;
	        _this4.$scope.$apply();
	      });
	
	      img.src = item;
	      this.activeSection.link = img.src;
	    }
	  }, {
	    key: 'applyMenu',
	    value: function applyMenu(item) {
	      var _this5 = this;
	
	      var groups = _lodash2['default'].groupBy(item.data.location.menu, function (subgroup) {
	        return subgroup.menuName;
	      });
	      var subnavMenuArray = [];
	
	      for (var key in groups) {
	        if (({}).hasOwnProperty.call(groups, key)) {
	          var CurrentLink = _lodash2['default'].isEmpty(groups[key][0].display) ? groups[key][0].submenu.item[0].itemDisplay : groups[key][0].display;
	
	          subnavMenuArray.push({
	            title: key,
	            id: key,
	            link: CurrentLink
	          });
	        }
	      }
	
	      TIMEOUT.get(this)(function () {
	        _this5.subnavMenuItems = subnavMenuArray;
	        _this5.subnavMenuItems.splice(_this5.subnavMenuItems.length, 0, { title: 'Region', id: 'Region' });
	        // focus on index 0 in subnavbar
	        _this5.selectedIndex = 0;
	      });
	      this.selectImage(subnavMenuArray[0].link);
	      this.subNavSelect(subnavMenuArray[0]);
	    }
	  }, {
	    key: 'applySubMenu',
	    value: function applySubMenu(item) {
	      var _this6 = this;
	
	      var subnavSecondaryMenuArray = [];
	
	      var groups = _lodash2['default'].groupBy(item.data.location.menu, function (subgroup) {
	        return subgroup.menuName;
	      });
	      for (var key in groups) {
	        if (({}).hasOwnProperty.call(groups, key)) {
	          if (key === this.activeSection.id && _lodash2['default'].isEmpty(groups[key][0].display)) {
	            var subMenuArray = groups[key][0].submenu.item;
	            for (var j in subMenuArray) {
	              if (({}).hasOwnProperty.call(subMenuArray, j)) {
	                subnavSecondaryMenuArray.push({
	                  title: subMenuArray[j].itemName,
	                  id: subMenuArray[j].itemName,
	                  link: subMenuArray[j].itemDisplay
	                });
	              }
	            }
	            this.showSubMenu = true;
	            this.showMenu = false;
	            // focus on index 1 subnavbarSecondary
	            this.selectedIndex = 1;
	            break;
	          } else {
	            this.showSubMenu = false;
	            this.showMenu = true;
	          }
	        }
	      }
	      TIMEOUT.get(this)(function () {
	        _this6.subnavSecondaryMenuItems = subnavSecondaryMenuArray;
	        _this6.subnavSecondaryMenuItems.splice(0, 0, { title: 'Back', id: 'Back' });
	        _this6.subnavSecondaryMenuItems.splice(_this6.subnavSecondaryMenuItems.length, 0, { title: 'Region', id: 'Region' });
	      });
	      this.selectImage(subnavSecondaryMenuArray[0].link);
	    }
	  }]);
	
	  return WeatherHomeLandingController;
	})();
	
	WeatherHomeLandingController.$inject = ['$q', '$state', '$stateParams', '$scope', '$timeout', 'topics', 'navigationService', 'photos', 'weatherVideoService', 'weatherCurrentService', 'localService', 'storageKeys', 'states', 'tickerService', 'adProps', '$rootScope'];
	
	exports['default'] = WeatherHomeLandingController;
	module.exports = exports['default'];

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(102);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../node_modules/css-loader/index.js!./../../../../node_modules/sass-loader/index.js!./weatherHomeLanding.scss", function() {
				var newContent = require("!!./../../../../node_modules/css-loader/index.js!./../../../../node_modules/sass-loader/index.js!./weatherHomeLanding.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "h1{font-family:Roboto,Helvetica,Arial,sans-serif;font-size:4.3vmin;font-weight:500;line-height:9vmin}h1,h2{margin:0}h2{font-family:Roboto Condensed,Arial Narrow,Helvetica,Arial,sans-serif;font-size:3.5vmin;font-weight:400}page-layout-w-t{position:absolute}page-layout-w-t .main-content img{height:100%;padding-left:7%}page-layout-w-t .main-content .load{position:absolute;height:100%;margin-left:7%;width:50%}page-layout-w-t .main-content i.load-spinner{position:absolute;top:40%;left:40%}page-layout-w-t .weather_alert_button button{height:100%}page-layout-w-t .weather_alert_button button>div{background-color:#900;padding:0 1.5vw;height:100%}page-layout-w-t .weather_alert_button button:focus,page-layout-w-t .weather_alert_button button:hover{color:#000;background:linear-gradient(#f7f7f7,#000 55%,#000 70%,#d7d7d7)}page-layout-w-t .weather_alert_button button:focus>div,page-layout-w-t .weather_alert_button button:hover>div{background-color:#ffac25}page-layout-w-t .weather_alert_main h1{margin:2% 20% 2% 2%;text-align:center;background-color:#900}page-layout-w-t .weather_alert_main #weather_alert_message{margin:0;padding:0 20% 2.5% 2.5%;font-size:2.4vmin}", ""]);
	
	// exports


/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _regionSelectionComponent = __webpack_require__(104);
	
	var _regionSelectionComponent2 = _interopRequireDefault(_regionSelectionComponent);
	
	var regionSelectionModule = _angular2['default'].module('regionSelection', []).component('regionSelection', _regionSelectionComponent2['default']);
	
	exports['default'] = regionSelectionModule;
	module.exports = exports['default'];

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _regionSelectionHtml = __webpack_require__(105);
	
	var _regionSelectionHtml2 = _interopRequireDefault(_regionSelectionHtml);
	
	var _regionSelectionController = __webpack_require__(106);
	
	var _regionSelectionController2 = _interopRequireDefault(_regionSelectionController);
	
	__webpack_require__(107);
	
	exports['default'] = {
	  restrict: 'E',
	  bindings: {
	    selected: '<',
	    regions: '<',
	    columns: '<',
	    onSelect: '&',
	    onKeydown: '&'
	  },
	  template: _regionSelectionHtml2['default'],
	  controller: _regionSelectionController2['default'],
	  controllerAs: 'vm'
	};
	module.exports = exports['default'];

/***/ },
/* 105 */
/***/ function(module, exports) {

	module.exports = "<div class=\"section group\">\n  <div ng-repeat=\"region in vm.regions\" class=\"col col-1-{{vm.columns || 3}}\">\n    <news12-button on-select=\"vm.select(region)\" on-keydown=\"vm.keyDown(event, region, $index)\" ng-class=\"{'focusable-first': $index == 0, selected: region.abbr === vm.selected.abbr }\">{{region.name}}</news12-button>\n  </div>\n</div>\n"

/***/ },
/* 106 */
/***/ function(module, exports) {

	/*---------------------------------------------------------*\
	 * RegionSelectionController
	\*---------------------------------------------------------*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var RegionSelectionController = (function () {
	  //-----------------------------------
	  // Constructor
	  //-----------------------------------
	
	  function RegionSelectionController() {
	    _classCallCheck(this, RegionSelectionController);
	
	    this.name = 'regionSelection';
	  }
	
	  _createClass(RegionSelectionController, [{
	    key: 'select',
	    value: function select(region) {
	      this.selected = region;
	      this.onSelect({
	        region: region
	      });
	    }
	  }, {
	    key: 'keyDown',
	    value: function keyDown(event, region, index) {
	      this.onKeydown({
	        event: event,
	        region: region,
	        index: index
	      });
	    }
	  }]);
	
	  return RegionSelectionController;
	})();
	
	exports['default'] = RegionSelectionController;
	module.exports = exports['default'];

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(108);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/sass-loader/index.js!./regionSelection.scss", function() {
				var newContent = require("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/sass-loader/index.js!./regionSelection.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "region-selection news12-button button{width:16vw}", ""]);
	
	// exports


/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _news12ButtonComponent = __webpack_require__(110);
	
	var _news12ButtonComponent2 = _interopRequireDefault(_news12ButtonComponent);
	
	var news12ButtonModule = _angular2['default'].module('news12Button', []).component('news12Button', _news12ButtonComponent2['default']);
	
	exports['default'] = news12ButtonModule;
	module.exports = exports['default'];

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _news12ButtonHtml = __webpack_require__(111);
	
	var _news12ButtonHtml2 = _interopRequireDefault(_news12ButtonHtml);
	
	var _news12ButtonController = __webpack_require__(112);
	
	var _news12ButtonController2 = _interopRequireDefault(_news12ButtonController);
	
	__webpack_require__(113);
	
	exports['default'] = {
	  restrict: 'E',
	  transclude: 'div',
	  bindings: {
	    badge: '@',
	    onSelect: '&',
	    onKeydown: '&',
	    onKeyup: '&'
	  },
	  template: _news12ButtonHtml2['default'],
	  controller: _news12ButtonController2['default'],
	  controllerAs: 'vm'
	};
	module.exports = exports['default'];

/***/ },
/* 111 */
/***/ function(module, exports) {

	module.exports = "<button class=\"focusable\"\n        ng-class=\"{'has-badge': vm.badge}\"\n        ng-click=\"vm.onSelect()\"\n        ng-keydown=\"vm.keyDown($event)\"\n        ng-keyup=\"vm.keyUp($event)\"\n        tabindex=\"0\">\n  <div>\n    <div ng-transclude></div>\n    <div ng-if=\"vm.badge\" class=\"badge\">{{vm.badge}}</div>\n  </div>\n</button>\n"

/***/ },
/* 112 */
/***/ function(module, exports) {

	/*---------------------------------------------------------*\
	 * News12ButtonController
	\*---------------------------------------------------------*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var News12ButtonController = (function () {
	  //-----------------------------------
	  // Constructor
	  //-----------------------------------
	
	  function News12ButtonController() {
	    _classCallCheck(this, News12ButtonController);
	
	    this.name = 'news12Button';
	  }
	
	  //-----------------------------------
	  // Events
	  //-----------------------------------
	
	  _createClass(News12ButtonController, [{
	    key: 'keyDown',
	    value: function keyDown(event) {
	      this.onKeydown({ event: event });
	    }
	  }, {
	    key: 'keyUp',
	    value: function keyUp(event) {
	      this.onKeyup({ event: event });
	    }
	  }]);
	
	  return News12ButtonController;
	})();
	
	exports['default'] = News12ButtonController;
	module.exports = exports['default'];

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(114);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/sass-loader/index.js!./news12Button.scss", function() {
				var newContent = require("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/sass-loader/index.js!./news12Button.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "h1{font-family:Roboto,Helvetica,Arial,sans-serif;font-size:4.3vmin;margin:0;font-weight:500;line-height:9vmin}h2{font-size:3.5vmin;margin:0}h2,news12-button button{font-family:Roboto Condensed,Arial Narrow,Helvetica,Arial,sans-serif;font-weight:400}news12-button button{border:none;background:linear-gradient(#7c83cd,#15174c);padding:.2rem;color:#e8e8e8;font-stretch:condensed;font-size:2.7vmin;transition:transform 50ms ease-out;outline:none;line-height:100%}news12-button button>div{background-color:#36349d;display:flex;flex-direction:column;align-items:center;justify-content:center;padding:1.5vh 1.5vw}news12-button button:hover>div{background-color:#3b39ac}news12-button button:focus{color:#000;background:linear-gradient(#f7f7f7,#000 55%,#000 70%,#d7d7d7)}news12-button button:focus>div{background-color:#ffac25}news12-button button:active>div{color:#000;transform:scale(.96)}news12-button button .badge{background-color:#900;color:#e8e8e8;padding:.1vh 1vw}news12-button.selected button>div{background-color:#0f143a}news12-button.selected button:focus{color:#000;background:linear-gradient(#f7f7f7,#000 55%,#000 70%,#d7d7d7)}news12-button.selected button:focus>div{background-color:#ffac25}", ""]);
	
	// exports


/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _pageLayoutWTComponent = __webpack_require__(116);
	
	var _pageLayoutWTComponent2 = _interopRequireDefault(_pageLayoutWTComponent);
	
	var pageLayoutWTModule = _angular2['default'].module('pageLayoutWT', [_angularUiRouter2['default']]).component('pageLayoutWT', _pageLayoutWTComponent2['default']);
	
	exports['default'] = pageLayoutWTModule;
	module.exports = exports['default'];

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _pageLayoutWTHtml = __webpack_require__(117);
	
	var _pageLayoutWTHtml2 = _interopRequireDefault(_pageLayoutWTHtml);
	
	var _pageLayoutWTController = __webpack_require__(118);
	
	var _pageLayoutWTController2 = _interopRequireDefault(_pageLayoutWTController);
	
	__webpack_require__(119);
	
	exports['default'] = {
	  restrict: 'E',
	  transclude: true,
	  bindings: {
	    leftNavItems: '<',
	    subnavMenuItems: '<',
	    subnavSecondaryMenuItems: '<',
	    title: '@',
	    region: '<'
	  },
	  template: _pageLayoutWTHtml2['default'],
	  controller: _pageLayoutWTController2['default'],
	  controllerAs: 'vm'
	};
	module.exports = exports['default'];

/***/ },
/* 117 */
/***/ function(module, exports) {

	module.exports = "<div class=\"page-layout-container\" ng-class=\"vm.modal\">\n  <div class=\"section-header\" ng-if=\"!vm.modal\">\n    <header-secondary page-title=\"{{vm.title}}\"\n                      region=\"vm.region\">\n    </header-secondary>\n  </div>\n  <section class=\"n12-secondary-body\">\n\n    <div class=\"transclude_main\" ng-transclude>\n\n    </div>\n\n    <div class=\"promo-banners\"  ng-if=\"!vm.modal\">\n      <div class=\"left-promo\">\n        <news12-ad region=\"vm.region\" ad-location=\"vm.adProps.photos.leftBottomBannerLocation\" section=\"vm.adProps.photos.sectionName\"></news12-ad>\n      </div>\n      <div class=\"right-promo\">\n        <news12-ad region=\"vm.region\" ad-location=\"vm.adProps.photos.rightBottomBannerLocation\" section=\"vm.adProps.photos.sectionName\"></news12-ad>\n      </div>\n    </div>\n  </section>\n</div>\n"

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	/*---------------------------------------------------------*\
	 * PageLayoutWT
	\*---------------------------------------------------------*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _keycodeUi = __webpack_require__(33);
	
	var _keycodeUi2 = _interopRequireDefault(_keycodeUi);
	
	var deps = {};
	
	var PageLayoutWTController = (function () {
	  //-----------------------------------
	  // Constructor
	  //-----------------------------------
	
	  function PageLayoutWTController($state, navigationService, adProps) {
	    _classCallCheck(this, PageLayoutWTController);
	
	    this.$state = $state;
	
	    this.selectedIndex = 0;
	    this.name = 'pageLayoutWT';
	    this.adProps = adProps;
	    deps.navigationService = navigationService;
	  }
	
	  //-----------------------------------
	  // Methods
	  //-----------------------------------
	
	  _createClass(PageLayoutWTController, [{
	    key: 'onLeftNavKeyDown',
	    value: function onLeftNavKeyDown(e, index) {
	      if (_keycodeUi2['default'].isRight(e)) {
	        e.preventDefault();
	        deps.navigationService.focusElAsync(index === 0 ? 'navbar' : '.main-content');
	      }
	    }
	  }, {
	    key: 'navSelect',
	    value: function navSelect(item) {
	      if (item && item.state) {
	        this.$state.go(item.state);
	      }
	    }
	  }]);
	
	  return PageLayoutWTController;
	})();
	
	PageLayoutWTController.$inject = ['$state', 'navigationService', 'adProps'];
	
	exports['default'] = PageLayoutWTController;
	module.exports = exports['default'];

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(120);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/sass-loader/index.js!./pageLayoutWT.scss", function() {
				var newContent = require("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/sass-loader/index.js!./pageLayoutWT.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "h1{font-family:Roboto,Helvetica,Arial,sans-serif;font-size:4.3vmin;font-weight:500;line-height:9vmin}h1,h2{margin:0}h2{font-family:Roboto Condensed,Arial Narrow,Helvetica,Arial,sans-serif;font-size:3.5vmin;font-weight:400}page-layout-w-t{height:100vh;width:100vw}page-layout-w-t .page-layout-container{height:100vh;width:100vw;background:#4863a0;background:linear-gradient(#4863a0 8.8%,#2c37ab 0,#2c37ab 15.25%,#080c73 0,#080c73 0,#080c73 19.45%,#2c37ab 0,#2c37ab 26%,#080c73 0,#4863a0 0)}page-layout-w-t .page-layout-container .section-header{display:block;height:19.45vh;width:90%;padding:0 5%}page-layout-w-t .page-layout-container .n12-secondary-body{width:100%;height:72vh;display:block}page-layout-w-t .page-layout-container .n12-secondary-body navbar{width:78vw;height:6.55vh;margin-left:22vw}page-layout-w-t .page-layout-container .n12-secondary-body .left-aside{display:inline-block;height:49.5vh;width:16vw;margin-left:5vw;position:relative}page-layout-w-t .page-layout-container .n12-secondary-body .left-aside .left-navbar{position:absolute;top:0;width:100%;height:24vh}page-layout-w-t .page-layout-container .n12-secondary-body .left-aside .left-navbar news12-button button{width:100%;height:6.6vh;margin-bottom:2vh}page-layout-w-t .page-layout-container .n12-secondary-body .left-aside .left-navbar news12-button button>div{height:100%;padding:0}page-layout-w-t .page-layout-container .n12-secondary-body .left-aside .left-aside-promo-banner{height:21vh;width:100%;position:absolute;bottom:0}page-layout-w-t .page-layout-container .n12-secondary-body .left-aside .left-aside-promo-banner img{width:100%;height:100%}page-layout-w-t .page-layout-container .n12-secondary-body .right-aside{position:relative;box-sizing:border-box;border-top:.25vmin solid #a5b3d3;border-left:.25vmin solid #a5b3d3;border-bottom:.25vmin solid #a5b3d3;display:inline-block;height:49.5vh;width:78vw;float:right;background-color:#0f143a}page-layout-w-t .page-layout-container .n12-secondary-body .right-aside .secondary-section-content{width:100%;height:100%;overflow:hidden}page-layout-w-t .page-layout-container .n12-secondary-body .promo-banners{width:90%;padding:0 5%;margin-top:1vh;height:13.42vh;position:relative}page-layout-w-t .page-layout-container .n12-secondary-body .promo-banners .left-promo,page-layout-w-t .page-layout-container .n12-secondary-body .promo-banners .right-promo{width:44.5vw;height:100%;display:inline-block}page-layout-w-t .page-layout-container .n12-secondary-body .promo-banners .left-promo img,page-layout-w-t .page-layout-container .n12-secondary-body .promo-banners .right-promo img{width:100%;height:100%}page-layout-w-t .page-layout-container .n12-secondary-body .promo-banners .left-promo{float:left}page-layout-w-t .page-layout-container .n12-secondary-body .promo-banners .right-promo{float:right}", ""]);
	
	// exports


/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _liveFeedVideoComponent = __webpack_require__(122);
	
	var _liveFeedVideoComponent2 = _interopRequireDefault(_liveFeedVideoComponent);
	
	var liveFeedVideoModule = _angular2['default'].module('liveFeedVideo', [_angularUiRouter2['default'], 'constants']).component('liveFeedVideo', _liveFeedVideoComponent2['default']);
	
	exports['default'] = liveFeedVideoModule;
	module.exports = exports['default'];

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _liveFeedVideoHtml = __webpack_require__(123);
	
	var _liveFeedVideoHtml2 = _interopRequireDefault(_liveFeedVideoHtml);
	
	var _liveFeedVideoController = __webpack_require__(124);
	
	var _liveFeedVideoController2 = _interopRequireDefault(_liveFeedVideoController);
	
	__webpack_require__(125);
	
	exports['default'] = {
	  restrict: 'E',
	  bindings: {
	    feedConfig: '<', // This will take a config object with something like {feedUrl: 'http://...', size:'large'}
	    onSelect: '&',
	    onReady: '&',
	    enlargeKeydown: '&'
	  },
	  template: _liveFeedVideoHtml2['default'],
	  controller: _liveFeedVideoController2['default'],
	  controllerAs: 'vm'
	};
	module.exports = exports['default'];

/***/ },
/* 123 */
/***/ function(module, exports) {

	module.exports = "<div class=\"videoplayerContainer\">\n  <videogular vg-theme=\"vm.config.theme\"\n              vg-native-fullscreen=\"false\"\n              vg-error=\"vm.onError($event)\"\n              vg-player-ready=\"vm.onPlayerReady($API)\">\n    <vg-media vg-src=\"vm.config.sources\">\n    </vg-media>\n    <vg-buffering></vg-buffering>\n  </videogular>\n</div>\n<button ng-click=\"vm.onSelect()\"\n        ng-keydown=\"vm.remoteKeydown($event)\"\n        class=\"focusable\">\n  <span>Enlarge</span>\n  <div class=\"enlargeIcons\">\n    <div class=\"bottomIcon\"></div>\n    <div class=\"topIcon\"></div>\n  </div>\n</button>\n"

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _mimeTypes = __webpack_require__(91);
	
	var _mimeTypes2 = _interopRequireDefault(_mimeTypes);
	
	/*---------------------------------------------------------*\
	 * LiveFeedVideoController
	\*---------------------------------------------------------*/
	var deps = {};
	
	var LiveFeedVideoController = (function () {
	  //-----------------------------------
	  // Constructor
	  //-----------------------------------
	
	  function LiveFeedVideoController($state, $sce, $timeout) {
	    _classCallCheck(this, LiveFeedVideoController);
	
	    deps.$sce = $sce;
	    deps.$state = $state;
	    deps.$timeout = $timeout;
	
	    this.name = 'liveFeedVideo';
	    this.API = null;
	  }
	
	  //-----------------------------------
	  // Lifecycle
	  //-----------------------------------
	
	  _createClass(LiveFeedVideoController, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.initVideo();
	    }
	
	    //-----------------------------------
	    // Methods
	    //-----------------------------------
	  }, {
	    key: 'initVideo',
	    value: function initVideo() {
	      var _this = this;
	
	      deps.$timeout(function () {
	        var videoUrl = _this.feedConfig.story.videoUrl.slice(0, _this.feedConfig.story.videoUrl.indexOf('?'));
	        _this.config = {
	          preload: 'none',
	          sources: [{
	            src: deps.$sce.trustAsResourceUrl(_this.feedConfig.story.videoUrl),
	            type: _mimeTypes2['default'].lookup(videoUrl)
	          }],
	          theme: './../../../../assets/videogular/videogular.css'
	        };
	      });
	    }
	  }, {
	    key: 'onPlayerReady',
	    value: function onPlayerReady(API) {
	      var _this2 = this;
	
	      if (API) {
	        this.API = API;
	        this.API.playsInline = true;
	        this.onReady({
	          liveFeed: this
	        });
	        deps.$timeout(function () {
	          _this2.API.play();
	        });
	      }
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      var _this3 = this;
	
	      if (this.API && this.API.isReady) {
	        deps.$timeout(function () {
	          _this3.API.play();
	        });
	      }
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      if (this.API && this.API.isReady) {
	        this.API.pause();
	      }
	    }
	  }, {
	    key: 'playPause',
	    value: function playPause() {
	      if (this.API && this.API.isReady) {
	        this.API.playPause();
	      }
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      if (this.API && this.API.isReady) {
	        this.API.stop();
	      }
	    }
	  }, {
	    key: 'remoteKeydown',
	    value: function remoteKeydown(e) {
	      this.enlargeKeydown({
	        event: e
	      });
	    }
	  }]);
	
	  return LiveFeedVideoController;
	})();
	
	LiveFeedVideoController.$inject = ['$state', '$sce', '$timeout'];
	
	exports['default'] = LiveFeedVideoController;
	module.exports = exports['default'];

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(126);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/sass-loader/index.js!./liveFeedVideo.scss", function() {
				var newContent = require("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/sass-loader/index.js!./liveFeedVideo.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "h1{font-family:Roboto,Helvetica,Arial,sans-serif;font-size:4.3vmin;font-weight:500;line-height:9vmin}h1,h2{margin:0}h2{font-family:Roboto Condensed,Arial Narrow,Helvetica,Arial,sans-serif;font-size:3.5vmin;font-weight:400}live-feed-video{background-color:#3c40b0}live-feed-video .videoplayerContainer{height:86.4%;position:relative;box-sizing:border-box;border-top:.8vw solid #122563;border-right:.8vw solid #122563;border-left:.8vw solid #122563;background-color:#000;display:flex;align-items:center;justify-content:center}live-feed-video .videoplayerContainer videogular{width:100%;height:85%}live-feed-video .videoplayerContainer videogular video{flex:1;object-fit:fill;max-width:100%;max-height:100%;width:100%;height:100%}live-feed-video button{height:13.6%;width:100%;position:absolute;bottom:0;background:#122563;border:none;font-family:Roboto,Helvetica,Arial,sans-serif;font-size:2.7vmin}live-feed-video button.selected,live-feed-video button:focus,live-feed-video button:hover{outline:none;color:#000;background:#ffac25}live-feed-video button.selected .enlargeIcons .bottomIcon,live-feed-video button.selected .enlargeIcons .topIcon,live-feed-video button:focus .enlargeIcons .bottomIcon,live-feed-video button:focus .enlargeIcons .topIcon,live-feed-video button:hover .enlargeIcons .bottomIcon,live-feed-video button:hover .enlargeIcons .topIcon{background:#000}live-feed-video button.selected .enlargeIcons .bottomIcon,live-feed-video button.selected .enlargeIcons .topIcon,live-feed-video button:focus .enlargeIcons .bottomIcon,live-feed-video button:focus .enlargeIcons .topIcon,live-feed-video button:hover .enlargeIcons .bottomIcon,live-feed-video button:hover .enlargeIcons .topIcon{border:.2vmin solid #e8e8e8}live-feed-video button:active{background:#ffac25}live-feed-video button .enlargeIcons{display:inline-block;width:2vmin;height:2vmin;position:relative}live-feed-video button .enlargeIcons .bottomIcon,live-feed-video button .enlargeIcons .topIcon{position:absolute;height:80%;width:80%;box-sizing:border-box;border:.2vmin solid #8d9ec3}live-feed-video button .enlargeIcons .bottomIcon{bottom:0;left:0;background:#0f237c}live-feed-video button .enlargeIcons .topIcon{top:0;right:0;background:#45609f}", ""]);
	
	// exports


/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _headerMainComponent = __webpack_require__(128);
	
	var _headerMainComponent2 = _interopRequireDefault(_headerMainComponent);
	
	var headerMainModule = _angular2['default'].module('headerMain', ['constants']).component('headerMain', _headerMainComponent2['default']);
	
	exports['default'] = headerMainModule;
	module.exports = exports['default'];

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _headerMainHtml = __webpack_require__(129);
	
	var _headerMainHtml2 = _interopRequireDefault(_headerMainHtml);
	
	var _headerMainController = __webpack_require__(130);
	
	var _headerMainController2 = _interopRequireDefault(_headerMainController);
	
	__webpack_require__(131);
	
	exports['default'] = {
	  restrict: 'E',
	  bindings: {
	    headerConfig: '<',
	    navItems: '<',
	    selectedIndex: '<',
	    region: '<'
	  },
	  template: _headerMainHtml2['default'],
	  controller: _headerMainController2['default'],
	  controllerAs: 'vm'
	};
	module.exports = exports['default'];

/***/ },
/* 129 */
/***/ function(module, exports) {

	module.exports = "<news-ticker ng-if=\"!vm.headerConfig.hideNewsTicker && vm.tickerData !== undefined\"\n             type=\"vm.tickerData.type\"\n             data=\"vm.tickerData.message\"\n></news-ticker>\n\n<logo ng-if=\"!vm.hideHeader\" region=\"vm.region\"></logo>\n\n<div class=\"top-row\">\n    <navbar ng-if=\"!vm.headerConfig.hideNavbar\"\n            flex=\"true\"\n            items=\"vm.navItems\"\n            selected-index=\"vm.selectedIndex\"\n            cycle-navigation=\"true\"\n            on-select=\"vm.selectTab(item)\"\n    >\n    </navbar>\n</div>\n<div class=\"bottom-row\">\n    <navbar-sub-menu ng-if=\"!vm.headerConfig.hideNavbar\"\n                     ng-class=\"{show: vm.showSubMenu}\"\n                     items=\"vm.subMenuItems\"\n                     on-select=\"vm.selectSubMenuItem(item)\"\n                     on-blur=\"vm.showSubMenu = false\"\n    >\n    </navbar-sub-menu>\n</div>\n\n\n"

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	/*---------------------------------------------------------*\
	 * Imports
	\*---------------------------------------------------------*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _pubsubJs = __webpack_require__(32);
	
	var _pubsubJs2 = _interopRequireDefault(_pubsubJs);
	
	var _lodash = __webpack_require__(35);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var deps = {};
	
	/*---------------------------------------------------------*\
	 * HeaderMainController
	\*---------------------------------------------------------*/
	
	var HeaderMainController = (function () {
	  //-----------------------------------
	  // Constructor
	  //-----------------------------------
	
	  function HeaderMainController($scope, $q, $state, $timeout, categoryService, tickerService, navigationService, localService, storageKeys, topics) {
	    var _this = this;
	
	    _classCallCheck(this, HeaderMainController);
	
	    deps.$state = $state;
	    deps.$scope = $scope;
	    deps.$timeout = $timeout;
	    deps.categoryService = categoryService;
	    deps.tickerService = tickerService;
	    deps.navigationService = navigationService;
	    deps.localService = localService;
	    deps.storageKeys = storageKeys;
	    deps.topics = topics;
	
	    // Only load menu and ticker if the parent did not request to hide the bar
	    if (!this.headerConfig || !this.headerConfig.hideNavbar) {
	      // parallelize requests to speed up rendering
	      $q.all([this.loadMenu(), this.loadTicker()]).then(function (values) {
	        var menu = values[0];
	        if (_this.tickerData.type) {
	          _this.setAlertBadge(menu, _this.tickerData.type);
	        }
	      });
	    }
	
	    this.name = 'headerMain';
	    var token1 = _pubsubJs2['default'].subscribe(deps.topics.headerMain.resetSubnav, function () {
	      deps.$timeout(function () {
	        if (_this.subMenuItems) {
	          _this.selectSubMenuItem(_this.subMenuItems[0]);
	        }
	      });
	      _this.hideBlur();
	    });
	
	    deps.$scope.$on('$destroy', function () {
	      _pubsubJs2['default'].unsubscribe(token1);
	    });
	  }
	
	  //-----------------------------------
	  // Methods
	  //-----------------------------------
	
	  _createClass(HeaderMainController, [{
	    key: 'loadMenu',
	    value: function loadMenu() {
	      var _this2 = this;
	
	      var regionId = this.region ? this.region.abbr : 'LI';
	      // fetch navigation data
	      return deps.categoryService.getCategories(regionId).then(function (menu) {
	        deps.$timeout(function () {
	          _this2.navItems = menu;
	          _this2.selectedIndex = _this2.getRouteIndex();
	          _this2.onMenuReady(menu);
	        });
	        return menu;
	      });
	    }
	  }, {
	    key: 'loadTicker',
	    value: function loadTicker() {
	      var _this3 = this;
	
	      var regionId = this.region ? this.region.abbr : 'LI';
	      return deps.tickerService.getTicker(regionId).then(function (res) {
	        if (!res.data) {
	          return [];
	        }
	        _this3.tickerData = {
	          type: res.data.rss.channel.item.title,
	          message: res.data.rss.channel.item.content
	        };
	        return res.data;
	      });
	    }
	  }, {
	    key: 'getRouteIndex',
	    value: function getRouteIndex() {
	      var states = _lodash2['default'].map(this.navItems, 'state');
	      return states.indexOf(deps.$state.current.name);
	    }
	  }, {
	    key: 'setAlertBadge',
	    value: function setAlertBadge(menu, type) {
	      var types = {
	        'WEATHER ALERT': 'weather',
	        'TRAFFIC ALERT': 'traffic'
	      };
	      var id = types[type];
	      menu.forEach(function (item) {
	        item.badge = item.id === id ? 'Alert' : null;
	      });
	    }
	  }, {
	    key: 'onMenuReady',
	    value: function onMenuReady(menu) {
	      _pubsubJs2['default'].publish(deps.topics.headerMain.menuReady, {
	        menu: menu,
	        activeTab: menu[this.selectedIndex]
	      });
	    }
	  }, {
	    key: 'selectTab',
	    value: function selectTab(item) {
	      var previousItem = this.navItems[this.selectedIndex];
	      this.selectedIndex = this.navItems.indexOf(item);
	      this.subMenuItems = item.sections;
	
	      // only show submenu if there are multiple items
	      if (Array.isArray(item.sections) && item.sections.length > 1) {
	        this.showSubMenu = true;
	
	        deps.navigationService.focusElAsync('navbar-sub-menu');
	      }
	
	      _pubsubJs2['default'].publish(deps.topics.headerMain.selectTab, {
	        item: item,
	        previousItem: previousItem
	      });
	
	      // notify ad component to refresh its ads
	      _pubsubJs2['default'].publish(deps.topics.ads.refreshAd);
	    }
	  }, {
	    key: 'selectSubMenuItem',
	    value: function selectSubMenuItem(item) {
	      this.showSubMenu = false;
	      _pubsubJs2['default'].publish(deps.topics.headerMain.selectSection, item);
	
	      // notify ad component to refresh its ads
	      _pubsubJs2['default'].publish(deps.topics.ads.refreshAd);
	    }
	  }, {
	    key: 'hideBlur',
	    value: function hideBlur() {
	      var _this4 = this;
	
	      deps.$timeout(function () {
	        _this4.showSubMenu = false;
	      });
	    }
	  }]);
	
	  return HeaderMainController;
	})();
	
	HeaderMainController.$inject = ['$scope', '$q', '$state', '$timeout', 'categoryService', 'tickerService', 'navigationService', 'localService', 'storageKeys', 'topics'];
	
	exports['default'] = HeaderMainController;
	module.exports = exports['default'];

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(132);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/sass-loader/index.js!./headerMain.scss", function() {
				var newContent = require("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/sass-loader/index.js!./headerMain.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "header-main{position:relative}header-main news-ticker{position:absolute;top:0;left:5.2%;height:28%;width:91%}header-main logo{position:absolute;top:27.5%;width:20.8%;height:72%;left:5.2%;z-index:100}header-main .top-row{background-color:#2c37ab;position:absolute;top:27.5%;width:100%;height:46%}header-main .top-row navbar{position:absolute;left:26%;top:0;bottom:0;right:3.6%}header-main .bottom-row{background-color:#080c73;position:absolute;top:73%;width:100%;height:27%}header-main .bottom-row navbar-sub-menu{position:absolute;top:0;left:26%;right:3.6%;height:100%;opacity:0;transition:opacity .15s linear}header-main .bottom-row navbar-sub-menu a{display:none;outline:none;font-size:0}header-main .bottom-row navbar-sub-menu.show{opacity:1}header-main .bottom-row navbar-sub-menu.show a{display:block}", ""]);
	
	// exports


/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _headerSecondaryComponent = __webpack_require__(134);
	
	var _headerSecondaryComponent2 = _interopRequireDefault(_headerSecondaryComponent);
	
	var headerSecondaryModule = _angular2['default'].module('headerSecondary', []).component('headerSecondary', _headerSecondaryComponent2['default']);
	
	exports['default'] = headerSecondaryModule;
	module.exports = exports['default'];

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _headerSecondaryHtml = __webpack_require__(135);
	
	var _headerSecondaryHtml2 = _interopRequireDefault(_headerSecondaryHtml);
	
	var _headerSecondaryController = __webpack_require__(136);
	
	var _headerSecondaryController2 = _interopRequireDefault(_headerSecondaryController);
	
	__webpack_require__(137);
	
	exports['default'] = {
	  restrict: 'E',
	  bindings: {
	    pageTitle: '@',
	    region: '<'
	  },
	  template: _headerSecondaryHtml2['default'],
	  controller: _headerSecondaryController2['default'],
	  controllerAs: 'vm'
	};
	module.exports = exports['default'];

/***/ },
/* 135 */
/***/ function(module, exports) {

	module.exports = "<div class=\"header-secondary\">\n  <logo region=\"vm.region\"></logo>\n  <div class=\"header-secondary-title\">\n    <h1>{{vm.pageTitle}}</h1>\n  </div>\n  <div class=\"weather-icons-container\">\n    <weather-icons region=\"vm.region\"></weather-icons>\n  </div>\n</div>\n"

/***/ },
/* 136 */
/***/ function(module, exports) {

	/*---------------------------------------------------------*\
	 * HeaderSecondaryController
	\*---------------------------------------------------------*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var HeaderSecondaryController =
	//-----------------------------------
	// Constructor
	//-----------------------------------
	function HeaderSecondaryController() {
	  _classCallCheck(this, HeaderSecondaryController);
	
	  this.name = 'headerSecondary';
	};
	
	exports['default'] = HeaderSecondaryController;
	module.exports = exports['default'];

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(138);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/sass-loader/index.js!./headerSecondary.scss", function() {
				var newContent = require("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/sass-loader/index.js!./headerSecondary.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "h1{font-family:Roboto,Helvetica,Arial,sans-serif;font-size:4.3vmin;font-weight:500;line-height:9vmin}h1,h2{margin:0}h2{font-family:Roboto Condensed,Arial Narrow,Helvetica,Arial,sans-serif;font-size:3.5vmin;font-weight:400}.header-secondary{width:100%;height:100%;display:block;position:relative}.header-secondary .header-secondary-title,.header-secondary .weather-icons-container,.header-secondary logo{display:inline-block;position:relative;height:100%}.header-secondary logo{width:20%}.header-secondary logo div{height:100%;position:absolute;top:22%;width:100%}.header-secondary .header-secondary-title{width:30%}.header-secondary .header-secondary-title h1{position:absolute;bottom:1vh;padding-left:.5vw;font-size:3.5vmin}.header-secondary .weather-icons-container{width:22%;float:right}.header-secondary .weather-icons-container div{top:33%;position:absolute;width:100%;float:right}", ""]);
	
	// exports


/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _navbarComponent = __webpack_require__(140);
	
	var _navbarComponent2 = _interopRequireDefault(_navbarComponent);
	
	var navbarModule = _angular2['default'].module('navbar', ['constants']).component('navbar', _navbarComponent2['default']);
	
	exports['default'] = navbarModule;
	module.exports = exports['default'];

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _navbarHtml = __webpack_require__(141);
	
	var _navbarHtml2 = _interopRequireDefault(_navbarHtml);
	
	var _navbarController = __webpack_require__(142);
	
	var _navbarController2 = _interopRequireDefault(_navbarController);
	
	__webpack_require__(143);
	
	exports['default'] = {
	  restrict: 'E',
	  bindings: {
	    items: '<',
	    selectedIndex: '=',
	    flex: '<',
	    cycleNavigation: '<',
	    onSelect: '&'
	  },
	  template: _navbarHtml2['default'],
	  controller: _navbarController2['default'],
	  controllerAs: 'vm'
	};
	module.exports = exports['default'];

/***/ },
/* 141 */
/***/ function(module, exports) {

	module.exports = "<news12-button ng-repeat=\"item in vm.items\"\n               ng-class=\"{selected: vm.selectedIndex === $index, 'focusable-first': !$index, 'focusable-last': $index === vm.items.length - 1}\"\n               badge=\"{{item.badge}}\"\n               on-keydown=\"vm.onKeyDown(event, item)\"\n               on-select=\"vm.select($index)\">\n{{item.title}}</news12-button>\n"

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	/*---------------------------------------------------------*\
	 * Imports
	\*---------------------------------------------------------*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _pubsubJs = __webpack_require__(32);
	
	var _pubsubJs2 = _interopRequireDefault(_pubsubJs);
	
	var _keycodeUi = __webpack_require__(33);
	
	var _keycodeUi2 = _interopRequireDefault(_keycodeUi);
	
	var deps = {};
	/*---------------------------------------------------------*\
	 * NavbarController
	\*---------------------------------------------------------*/
	
	var NavbarController = (function () {
	  //-----------------------------------
	  // Constructor
	  //-----------------------------------
	
	  function NavbarController($scope, $element, navigationService, topics) {
	    var _this = this;
	
	    _classCallCheck(this, NavbarController);
	
	    this.name = 'navbar';
	    deps.topics = topics;
	    deps.$element = $element;
	    deps.$scope = $scope;
	    deps.navigationService = navigationService;
	
	    if (this.flex) {
	      deps.$element.addClass('flex');
	    }
	
	    var token1 = _pubsubJs2['default'].subscribe(deps.topics.headerMain.resetSubnav, function () {
	      _this.select(0);
	    });
	
	    deps.$scope.$on('$destroy', function () {
	      _pubsubJs2['default'].unsubscribe(token1);
	    });
	  }
	
	  //-----------------------------------
	  // Methods
	  //-----------------------------------
	
	  _createClass(NavbarController, [{
	    key: 'getCurrentItem',
	    value: function getCurrentItem() {
	      return this.items[this.selectedIndex];
	    }
	  }, {
	    key: 'select',
	    value: function select(index) {
	      var topics = deps.topics.nav;
	      this.selectedIndex = index;
	      this.onSelect({
	        item: this.items[index],
	        index: index
	      });
	      _pubsubJs2['default'].publish(topics.enter, { source: this.name, data: this.getCurrentItem() });
	    }
	
	    //-----------------------------------
	    // Events
	    //-----------------------------------
	  }, {
	    key: 'onKeyDown',
	    value: function onKeyDown(e, item) {
	      var topics = deps.topics.nav;
	      var buttonElements = [].slice.call(deps.$element.children());
	      // parentElement is <news12-button>
	      var buttonIndex = buttonElements.indexOf(e.target.parentElement);
	      switch (true) {
	        case _keycodeUi2['default'].isUp(e):
	          _pubsubJs2['default'].publish(topics.up, 'navbar');
	          break;
	        case _keycodeUi2['default'].isDown(e):
	          _pubsubJs2['default'].publish(topics.down, { source: 'navbar', item: item });
	          break;
	        case _keycodeUi2['default'].isLeft(e):
	          if (!this.cycleNavigation && buttonIndex === 0) {
	            return;
	          }
	          buttonIndex = buttonIndex === 0 ? buttonElements.length - 1 : buttonIndex - 1;
	          deps.navigationService.focusEl('navbar', buttonIndex);
	          e.preventDefault();
	          break;
	        case _keycodeUi2['default'].isRight(e):
	          if (!this.cycleNavigation && buttonIndex === buttonElements.length - 1) {
	            return;
	          }
	          buttonIndex = (buttonIndex + 1) % buttonElements.length;
	          deps.navigationService.focusEl('navbar', buttonIndex);
	          e.preventDefault();
	          break;
	      }
	    }
	  }]);
	
	  return NavbarController;
	})();
	
	NavbarController.$inject = ['$scope', '$element', 'navigationService', 'topics'];
	
	exports['default'] = NavbarController;
	module.exports = exports['default'];

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(144);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/sass-loader/index.js!./navbar.scss", function() {
				var newContent = require("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/sass-loader/index.js!./navbar.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "navbar{white-space:nowrap;overflow:hidden;display:flex}navbar news12-button{font-size:0;height:100%}navbar news12-button button{width:100%;height:100%}navbar news12-button button>div{padding-top:0;padding-bottom:0;height:100%}navbar.flex news12-button{flex:1}", ""]);
	
	// exports


/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _navbarSubMenuComponent = __webpack_require__(146);
	
	var _navbarSubMenuComponent2 = _interopRequireDefault(_navbarSubMenuComponent);
	
	var navbarSubMenuModule = _angular2['default'].module('navbarSubMenu', ['constants']).component('navbarSubMenu', _navbarSubMenuComponent2['default']);
	
	exports['default'] = navbarSubMenuModule;
	module.exports = exports['default'];

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _navbarSubMenuHtml = __webpack_require__(147);
	
	var _navbarSubMenuHtml2 = _interopRequireDefault(_navbarSubMenuHtml);
	
	var _navbarSubMenuController = __webpack_require__(148);
	
	var _navbarSubMenuController2 = _interopRequireDefault(_navbarSubMenuController);
	
	__webpack_require__(149);
	
	exports['default'] = {
	  restrict: 'E',
	  bindings: {
	    items: '<',
	    defaultPosition: '<',
	    onSelect: '&',
	    onFocus: '&',
	    onBlur: '&'
	  },
	  template: _navbarSubMenuHtml2['default'],
	  controller: _navbarSubMenuController2['default'],
	  controllerAs: 'vm'
	};
	module.exports = exports['default'];

/***/ },
/* 147 */
/***/ function(module, exports) {

	module.exports = "<div class=\"wrapper\">\n  <a class=\"focusable sub-nav-item\" href=\"#\" ng-keydown=\"vm.onKeyDown($event)\" ng-blur=\"vm.blur($event)\"></a>\n  <div class=\"left-item\" ng-bind-html=\"vm.rotationMenu[0].title\"></div>\n  <div class=\"center-item selected\" ng-bind-html=\"vm.rotationMenu[1].title\"></div>\n  <div class=\"right-item\" ng-bind-html=\"vm.rotationMenu[2].title\"></div>\n</div>\n"

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	/*---------------------------------------------------------*\
	 * Imports
	\*---------------------------------------------------------*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _pubsubJs = __webpack_require__(32);
	
	var _pubsubJs2 = _interopRequireDefault(_pubsubJs);
	
	var _keycodeUi = __webpack_require__(33);
	
	var _keycodeUi2 = _interopRequireDefault(_keycodeUi);
	
	var TOPICS = new WeakMap();
	var deps = {};
	/*---------------------------------------------------------*\
	 * NavbarSubMenuController
	\*---------------------------------------------------------*/
	
	var NavbarSubMenuController = (function () {
	  //-----------------------------------
	  // Constructor
	  //-----------------------------------
	
	  function NavbarSubMenuController($scope, $timeout, topics) {
	    var _this = this;
	
	    _classCallCheck(this, NavbarSubMenuController);
	
	    TOPICS.set(this, topics);
	    this.name = 'navbarSubMenu';
	    deps.$timeout = $timeout;
	
	    var token = _pubsubJs2['default'].subscribe(TOPICS.get(this).headerMain.resetSubnav, function () {
	      _this.resetSubNav();
	    });
	
	    $scope.$watch('vm.items', function () {
	      _this.resetSubNav();
	    });
	
	    $scope.$on('$destroy', function () {
	      _pubsubJs2['default'].unsubscribe(token);
	    });
	  }
	
	  //-----------------------------------
	  // Methods
	  //-----------------------------------
	
	  _createClass(NavbarSubMenuController, [{
	    key: 'resetSubNav',
	    value: function resetSubNav() {
	      this.position = this.defaultPosition || 0;
	      this.currentSelectedPosition = this.defaultPosition || 0;
	      this.rotationMenu = [];
	      this.generateRotationMenu();
	    }
	  }, {
	    key: 'generateRotationMenu',
	    value: function generateRotationMenu() {
	      if (!this.items) {
	        this.items = [];
	        this.rotationMenu = [];
	        return;
	      }
	
	      var count = this.items.length;
	      var pos = this.position;
	      var previousPos = (count + (pos - 1)) % count;
	      var nextPos = (pos + 1) % count;
	
	      this.rotationMenu = [this.items[previousPos], this.items[pos], this.items[nextPos]];
	      if (count === 1) {
	        this.rotationMenu = [null, this.items[pos], null];
	      } else if (count === 2) {
	        this.rotationMenu = [pos === 0 ? null : this.items[previousPos], this.items[pos], pos === 0 ? this.items[nextPos] : null];
	      } else {
	        this.rotationMenu = [this.items[previousPos], this.items[pos], this.items[nextPos]];
	      }
	    }
	  }, {
	    key: 'focus',
	    value: function focus(event) {
	      this.onFocus({ event: event });
	    }
	  }, {
	    key: 'blur',
	    value: function blur(event) {
	      var _this2 = this;
	
	      this.onBlur({ event: event });
	
	      deps.$timeout(function () {
	        if (!_this2.itemSelected) {
	          // if a submenu item wasnt selected we need to reset the position to the last selected position
	          _this2.position = _this2.currentSelectedPosition || 0;
	          _this2.generateRotationMenu();
	        }
	        // reset item selected flag
	        _this2.itemSelected = false;
	      }, 500);
	    }
	  }, {
	    key: 'navigateLeft',
	    value: function navigateLeft(event) {
	      var count = this.items.length;
	      if (count > 2 || count === 2 && this.position === 1) {
	        this.position = (count + (this.position - 1)) % count;
	      }
	      event.preventDefault();
	    }
	  }, {
	    key: 'navigateRight',
	    value: function navigateRight(event) {
	      var count = this.items.length;
	      if (count > 2 || count === 2 && this.position === 0) {
	        this.position = (this.position + 1) % count;
	      }
	      event.preventDefault();
	    }
	  }, {
	    key: 'getCurrentItem',
	    value: function getCurrentItem() {
	      return this.items[this.position];
	    }
	  }, {
	    key: 'selectCurrent',
	    value: function selectCurrent() {
	      // if a navbar item was selected we record its current selected index so we reset to this position
	      // when a user scrolls through the sub menu and exits but does not select an item
	      this.itemSelected = true;
	      this.currentSelectedPosition = this.position;
	      this.onSelect({
	        item: this.getCurrentItem()
	      });
	    }
	
	    //-----------------------------------
	    // Events
	    //-----------------------------------
	  }, {
	    key: 'onKeyDown',
	    value: function onKeyDown(e) {
	      var topics = TOPICS.get(this).nav;
	      switch (true) {
	        case _keycodeUi2['default'].isLeft(e):
	          // ARROW_LEFT
	          this.navigateLeft(event);
	          this.generateRotationMenu();
	          break;
	        case _keycodeUi2['default'].isRight(e):
	          // ARROW_RIGHT
	          this.navigateRight(event);
	          this.generateRotationMenu();
	          break;
	        case _keycodeUi2['default'].isEnter(e):
	          // ENTER/OK
	          this.selectCurrent();
	          _pubsubJs2['default'].publish(topics.enter, { source: this.name, data: this.getCurrentItem() });
	          break;
	        case _keycodeUi2['default'].isUp(e):
	          // ARROW_UP:
	          _pubsubJs2['default'].publish(topics.up, this.name);
	          break;
	        case _keycodeUi2['default'].isDown(e):
	          // ARROW_DOWN:
	          _pubsubJs2['default'].publish(topics.down, this.name);
	          break;
	      }
	    }
	  }]);
	
	  return NavbarSubMenuController;
	})();
	
	NavbarSubMenuController.$inject = ['$scope', '$timeout', 'topics'];
	
	exports['default'] = NavbarSubMenuController;
	module.exports = exports['default'];

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(150);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/sass-loader/index.js!./navbarSubMenu.scss", function() {
				var newContent = require("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/sass-loader/index.js!./navbarSubMenu.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "navbar-sub-menu{height:100%}navbar-sub-menu a{outline:none;font-size:0}navbar-sub-menu .wrapper{display:flex;align-items:center;height:100%;color:#e8e8e8}navbar-sub-menu .wrapper>div{flex:1;display:flex;align-items:center;justify-content:center;height:100%;margin:0;text-align:center;text-transform:uppercase;font-size:2.7vmin}navbar-sub-menu .wrapper>div.selected{color:#ffac25;background-color:#0f143a;position:relative}navbar-sub-menu .wrapper>div.selected:after,navbar-sub-menu .wrapper>div.selected:before{content:\" \";position:absolute;border-width:1.8vmin 3vmin;border-color:transparent;border-style:solid}navbar-sub-menu .wrapper>div.selected:before{left:-6vmin;border-right-color:#ffac25}navbar-sub-menu .wrapper>div.selected:after{right:-6vmin;border-left-color:#ffac25}", ""]);
	
	// exports


/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _storyListComponent = __webpack_require__(152);
	
	var _storyListComponent2 = _interopRequireDefault(_storyListComponent);
	
	var storyListModule = _angular2['default'].module('storyList', [_angularUiRouter2['default'], 'constants']).component('storyList', _storyListComponent2['default']);
	
	exports['default'] = storyListModule;
	module.exports = exports['default'];

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _storyListHtml = __webpack_require__(153);
	
	var _storyListHtml2 = _interopRequireDefault(_storyListHtml);
	
	var _storyListController = __webpack_require__(154);
	
	var _storyListController2 = _interopRequireDefault(_storyListController);
	
	__webpack_require__(155);
	
	exports['default'] = {
	  restrict: 'E',
	  bindings: {
	    params: '<',
	    pageSize: '<',
	    currentPage: '<',
	    stories: '<',
	    focusItem: '<',
	    onSelect: '&',
	    onKeydown: '&'
	  },
	  template: _storyListHtml2['default'],
	  controller: _storyListController2['default'],
	  controllerAs: 'vm'
	};
	module.exports = exports['default'];

/***/ },
/* 153 */
/***/ function(module, exports) {

	module.exports = "<div class=\"story-list-content\">\n  <ul class=\"story-list\">\n    <li class=\"story-item-container focusable\" ng-class=\"{'focusable-first': $index == 0}\"\n        ng-repeat=\"story in vm.stories | startFrom: vm.pageFirst | limitTo: vm.pageSize\"\n        ng-click=\"vm.select(story, $index)\" tabindex=\"0\" ng-keydown=\"vm.listKeyDown($event, $index)\">\n      <div class=\"story-item\">\n        <div class=\"story-image\" style=\"background-image: url('{{story.image}}'), url('{{vm.fallbackImage}}');\"></div>\n        <div class=\"story-line\" ng-bind-html=\"story.header\">\n        </div>\n      </div>\n    </li>\n  </ul>\n</div>\n\n<div class=\"container-nav\">\n  <div class=\"pagination\">\n    <h2>{{vm.pageFirst + 1}} - {{vm.pageLast + 1}} of {{vm.stories.length}}</h2>\n  </div>\n  <div class=\"btngroup\">\n    <div class=\"directional\" ng-show=\"vm.stories.length > 3\">\n      <news12-button on-select=\"vm.next()\" on-keydown=\"vm.focusNav(event)\">Next</news12-button>\n      <news12-button on-select=\"vm.prev()\" on-keydown=\"vm.focusNav(event)\">Prev</news12-button>\n    </div>\n    <div class=\"main-menu-btn\">\n      <news12-button on-select=\"vm.gotoNewsHome()\" on-keydown=\"vm.focusNav(event)\">Main</news12-button>\n    </div>\n  </div>\n</div>"

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	/*---------------------------------------------------------*\
	 * Imports
	 \*---------------------------------------------------------*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _keycodeUi = __webpack_require__(33);
	
	var _keycodeUi2 = _interopRequireDefault(_keycodeUi);
	
	var _pubsubJs = __webpack_require__(32);
	
	var _pubsubJs2 = _interopRequireDefault(_pubsubJs);
	
	var _lodash = __webpack_require__(35);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var deps = {};
	
	/*---------------------------------------------------------*\
	 * StoryListController
	 \*---------------------------------------------------------*/
	
	var StoryListController = (function () {
	  //-----------------------------------
	  // Constructor
	  //-----------------------------------
	
	  function StoryListController($timeout, $state, states, navigationService, newsService, adProps, topics) {
	    _classCallCheck(this, StoryListController);
	
	    deps.$state = $state;
	    deps.$timeout = $timeout;
	    deps.states = states;
	    deps.navigationService = navigationService;
	    deps.newsService = newsService;
	    deps.adProps = adProps;
	    deps.topics = topics;
	    this.name = 'storyList';
	    this.pageSize = this.pageSize || 3;
	    var page = this.focusItem !== undefined ? Math.floor(this.focusItem / this.pageSize) : 0;
	    this.refreshNav(page || 0);
	  }
	
	  _createClass(StoryListController, [{
	    key: 'loadEmptyImage',
	    value: function loadEmptyImage() {
	      var _this = this;
	
	      // when we paginate through story list. empty out the fallbackimage and delay the load of it by 100ms.
	      // This allows us to not show the empty image after a slight delay.
	      // this approach is significantly better then having to call each image first and
	      // then load into the background image tag thus producing 2 image calls per image.
	      // If image loading is slow then the UI may show the fallback image then the new image once loaded.
	      this.fallbackImage = '';
	      deps.$timeout(function () {
	        _this.fallbackImage = '/assets/images/News12EmptyImage.png';
	      }, 500);
	    }
	
	    //-----------------------------------
	    // Methods
	    //-----------------------------------
	  }, {
	    key: 'refreshNav',
	    value: function refreshNav(page) {
	      this.currentPage = page || 0;
	      this.pageFirst = this.stories.length > 0 ? Math.min(this.currentPage * this.pageSize, this.stories.length - 1) : 0;
	      this.pageLast = this.stories.length > 0 ? Math.min(this.pageFirst + this.pageSize, this.stories.length) - 1 : 0;
	
	      // load empty images if not found. Checking deps.$timeout since this function is called by the ES6 setter function
	      // which runs before our dependencies are wired up
	      if (deps.$timeout) {
	        this.loadEmptyImage();
	      }
	    }
	  }, {
	    key: 'prev',
	    value: function prev() {
	      var totalPages = Math.ceil(this.stories.length / this.pageSize);
	      if (this.currentPage === 0) {
	        this.currentPage = Math.max(0, totalPages - 1);
	      } else {
	        this.currentPage -= 1;
	      }
	      this.refreshNav(this.currentPage);
	    }
	  }, {
	    key: 'next',
	    value: function next() {
	      var totalPages = Math.ceil(this.stories.length / this.pageSize);
	      if (this.currentPage === totalPages - 1) {
	        this.currentPage = 0;
	      } else {
	        this.currentPage++;
	      }
	      this.refreshNav(this.currentPage);
	    }
	  }, {
	    key: 'listKeyDown',
	    value: function listKeyDown(e, index) {
	      switch (true) {
	        case _keycodeUi2['default'].isUp(e):
	          if (index > 0) {
	            _angular2['default'].element(e.target).parent().children()[index - 1].focus();
	            e.preventDefault();
	          } else {
	            this.onKeydown({ event: e });
	          }
	          break;
	        case _keycodeUi2['default'].isDown(e):
	          if (this.stories.length <= this.pageSize) {
	            if (this.stories[index + 1]) {
	              e.preventDefault();
	              _angular2['default'].element(e.target).parent().children()[index + 1].focus();
	            } else {
	              e.preventDefault();
	              deps.navigationService.focusEl('.main-menu-btn');
	            }
	          }
	          break;
	      }
	    }
	  }, {
	    key: 'select',
	    value: function select(story, index) {
	      // focusItem = global index
	      var videoItem = {
	        focusItem: this.currentPage * this.pageSize + index,
	        story: story
	      };
	      this.onSelect(videoItem);
	    }
	  }, {
	    key: 'focusNav',
	    value: function focusNav(event) {
	      if (_keycodeUi2['default'].isDown(event) || _keycodeUi2['default'].isRight(event)) {
	        var previousElement = event.target;
	        _pubsubJs2['default'].publish(deps.adProps.home.previousElement, { previousElement: previousElement });
	      } else if (_keycodeUi2['default'].isLeft(event)) {
	        if (_lodash2['default'].contains(event.target.innerText, 'Prev')) {
	          event.preventDefault();
	          event.stopPropagation();
	        }
	      }
	    }
	  }, {
	    key: 'gotoNewsHome',
	    value: function gotoNewsHome() {
	      _pubsubJs2['default'].publish(deps.topics.headerMain.resetSubnav);
	    }
	  }, {
	    key: 'stories',
	    get: function get() {
	      return this._stories || [];
	    },
	    set: function set(val) {
	      this._stories = val || [];
	      if (this.focusItem !== undefined) {
	        var page = this.focusItem !== undefined ? Math.floor(this.focusItem / this.pageSize) : 0;
	        // this is just an async callback to load data. so preserve the current page
	        this.refreshNav(page);
	        delete this.focusItem;
	      } else {
	        // data has changed from old one. reset current page
	        this.refreshNav(0);
	      }
	    }
	  }]);
	
	  return StoryListController;
	})();
	
	StoryListController.$inject = ['$timeout', '$state', 'states', 'navigationService', 'newsService', 'adProps', 'topics'];
	
	exports['default'] = StoryListController;
	module.exports = exports['default'];

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(156);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/sass-loader/index.js!./storyList.scss", function() {
				var newContent = require("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/sass-loader/index.js!./storyList.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "h1{font-family:Roboto,Helvetica,Arial,sans-serif;font-size:4.3vmin;font-weight:500;line-height:9vmin}h1,h2{margin:0}h2{font-family:Roboto Condensed,Arial Narrow,Helvetica,Arial,sans-serif;font-size:3.5vmin;font-weight:400}.story-list-content{height:86%}.story-list-content .story-list{height:100%;width:100%;list-style:none;padding:0;margin:0}.story-list-content .story-list .story-item-container{height:33.33333%;width:100%}.story-list-content .story-list .story-item-container.selected,.story-list-content .story-list .story-item-container:active,.story-list-content .story-list .story-item-container:focus,.story-list-content .story-list .story-item-container:hover{background-color:hsla(0,0%,100%,.2);outline:none;color:#ffac25}.story-list-content .story-list .story-item-container .story-item{position:relative;height:84.5%;width:87.45%;top:6.25%;margin-left:10%}.story-list-content .story-list .story-item-container .story-item .story-image,.story-list-content .story-list .story-item-container .story-item .story-line{position:relative;display:inline-block}.story-list-content .story-list .story-item-container .story-item .story-image{width:17.5%;height:100%;background-color:#999;background-size:cover;float:left}.story-list-content .story-list .story-item-container .story-item .story-image img{width:100%;position:relative;top:50%;transform:translateY(-50%)}.story-list-content .story-list .story-item-container .story-item .story-line{margin-left:.5%;width:81%;height:100%;float:right;overflow:hidden;font-size:2.7vmin;display:flex;justify-content:center;align-content:center;flex-direction:column}.container-nav{padding:0;height:14%;width:100%;background-color:#122563;box-sizing:border-box;border-top:.25vmin solid #a5b3d3;position:relative}.container-nav .btngroup,.container-nav .pagination{position:absolute;height:72%;display:inline-block;margin:.75%}.container-nav .pagination{right:30%;width:35%}.container-nav .pagination h2{font-size:2.7vmin;text-align:right;line-height:175%}.container-nav .btngroup{width:32%;right:0}.container-nav .btngroup .directional,.container-nav .btngroup .main-menu-btn{display:inline-block;height:100%}.container-nav .btngroup .directional news12-button,.container-nav .btngroup .main-menu-btn news12-button{font-size:0;height:100%}.container-nav .btngroup .directional news12-button button,.container-nav .btngroup .main-menu-btn news12-button button{height:100%}.container-nav .btngroup .directional news12-button button>div,.container-nav .btngroup .main-menu-btn news12-button button>div{padding:0 3%;height:100%}.container-nav .btngroup .directional{list-style:none;display:-webkit-box;display:-ms-flexbox;display:inline-flex;-webkit-flex-flow:row wrap;flex-direction:row-reverse;width:62%;margin-left:0;position:relative}.container-nav .btngroup .directional news12-button button{width:6vw}.container-nav .btngroup .main-menu-btn{width:28%;right:0;float:right}.container-nav .btngroup .main-menu-btn button{width:100%}", ""]);
	
	// exports


/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _newsTickerComponent = __webpack_require__(158);
	
	var _newsTickerComponent2 = _interopRequireDefault(_newsTickerComponent);
	
	var newsTickerModule = _angular2['default'].module('newsTicker', [_angularUiRouter2['default']]).component('newsTicker', _newsTickerComponent2['default']);
	
	exports['default'] = newsTickerModule;
	module.exports = exports['default'];

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _newsTickerHtml = __webpack_require__(159);
	
	var _newsTickerHtml2 = _interopRequireDefault(_newsTickerHtml);
	
	var _newsTickerController = __webpack_require__(160);
	
	var _newsTickerController2 = _interopRequireDefault(_newsTickerController);
	
	__webpack_require__(161);
	
	exports['default'] = {
	  restrict: 'E',
	  bindings: {
	    data: '<',
	    type: '<',
	    speed: '<'
	  },
	  template: _newsTickerHtml2['default'],
	  controller: _newsTickerController2['default'],
	  controllerAs: 'vm'
	};
	module.exports = exports['default'];

/***/ },
/* 159 */
/***/ function(module, exports) {

	module.exports = "<div class=\"ticker-wrapper\">\n  <div class=\"ticker-header\"><div class=\"ticker-header-content\"></div></div>\n</div>"

/***/ },
/* 160 */
/***/ function(module, exports) {

	/*---------------------------------------------------------*\
	 * News12ButtonController
	 \*---------------------------------------------------------*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var deps = {};
	
	var NewsTickerController = (function () {
	  //-----------------------------------
	  // Constructor
	  //-----------------------------------
	
	  function NewsTickerController($timeout, $filter, $document) {
	    _classCallCheck(this, NewsTickerController);
	
	    this.name = 'newsTicker';
	
	    this.pxPerSecond = this.speed || 'default';
	
	    this.texts = [];
	
	    deps.$timeout = $timeout;
	    deps.$filter = $filter;
	    deps.$document = $document;
	
	    this.gap = 150;
	    this.padding = 20;
	
	    this.animFrame = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || null;
	  }
	
	  //-----------------------------------
	  // Properties
	  //-----------------------------------
	
	  _createClass(NewsTickerController, [{
	    key: '$postLink',
	
	    //-----------------------------------
	    // Lifecycle
	    //-----------------------------------
	    value: function $postLink() {
	      window.addEventListener('resize', this.resizeHandler.bind(this));
	
	      this.animFrame.call(window, this.onFrameFirstHandler.bind(this));
	
	      this.resizeHandler();
	    }
	
	    //-----------------------------------
	    // Methods
	    //-----------------------------------
	  }, {
	    key: 'addText',
	    value: function addText() {
	      if (this.wrapper) {
	        this.texts = this.texts || [];
	
	        var element = deps.$document[0].createElement('div');
	
	        element.setAttribute('class', 'data');
	
	        element.innerHTML = deps.$filter('htmlToPlaintext')(this.data);
	
	        this.wrapper.appendChild(element);
	
	        this.texts.push({
	          element: element,
	          width: element.offsetWidth,
	          x: this.wrapper.offsetWidth
	        });
	      }
	    }
	  }, {
	    key: 'removeText',
	    value: function removeText(text) {
	      this.wrapper.removeChild(text.element);
	    }
	
	    //-----------------------------------
	    // Events
	    //-----------------------------------
	  }, {
	    key: 'resizeHandler',
	    value: function resizeHandler() {
	      this.wrapper = this.wrapper || deps.$document[0].getElementsByClassName('ticker-wrapper')[0];
	      this.header = this.header || deps.$document[0].getElementsByClassName('ticker-header')[0];
	      this.headerContent = this.headerContent || deps.$document[0].getElementsByClassName('ticker-header-content')[0];
	
	      if (this._type) {
	        this.header.setAttribute('class', 'ticker-header ticker-header-' + this._type.className);
	        this.wrapper.setAttribute('class', 'ticker-wrapper ticker-wrapper-' + this._type.className);
	      }
	    }
	  }, {
	    key: 'onFrameFirstHandler',
	    value: function onFrameFirstHandler() {
	      this.lastTime = performance.now();
	
	      this.animFrame.call(window, this.onFrameHandler.bind(this));
	    }
	  }, {
	    key: 'onFrameHandler',
	    value: function onFrameHandler() {
	      var _this = this;
	
	      var curTime = performance.now();
	
	      this.elapsed = Math.min(0.5, (curTime - this.lastTime) / 1000);
	      this.lastTime = curTime;
	
	      var pxps = this.pxPerSecond === 'default' ? window.innerWidth / 16 : this.pxPerSecond;
	
	      if (this.type && this.data) {
	        // Display and shift each text item
	        this.texts.forEach(function (text) {
	          text.x -= pxps * _this.elapsed;
	
	          text.element.setAttribute('style', 'left: ' + text.x + 'px;');
	        });
	
	        // Filter out all text items that are off the left edge.
	        this.texts = this.texts.filter(function (text) {
	          var invalid = text.x + text.width + _this.gap < 0;
	
	          if (invalid) {
	            _this.removeText(text);
	          }
	
	          return !invalid;
	        });
	
	        var text = this.texts ? this.texts[this.texts.length - 1] : undefined;
	
	        if (!text || text.x + text.width + this.gap < this.wrapper.offsetWidth) {
	          this.addText();
	        }
	      }
	
	      this.animFrame.call(window, this.onFrameHandler.bind(this));
	    }
	  }, {
	    key: 'type',
	    set: function set(value) {
	      this.types = this.types || {
	        INFOBAR: {
	          className: 'infobar'
	        },
	        'WEATHER ALERT': {
	          className: 'weather-alert'
	        },
	        'TRAFFIC ALERT': {
	          className: 'traffic-alert'
	        },
	        'BREAKING NEWS': {
	          className: 'breaking-news'
	        }
	      };
	
	      this._type = this.types[value];
	
	      if (this.header) {
	        this.resizeHandler();
	      }
	    },
	    get: function get() {
	      return this._type;
	    }
	  }, {
	    key: 'data',
	    set: function set(value) {
	      this._data = value;
	
	      if (this.header) {
	        this.resizeHandler();
	      }
	    },
	    get: function get() {
	      return this._data;
	    }
	  }]);
	
	  return NewsTickerController;
	})();
	
	NewsTickerController.$inject = ['$timeout', '$filter', '$document'];
	
	exports['default'] = NewsTickerController;
	module.exports = exports['default'];

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(162);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/sass-loader/index.js!./newsTicker.scss", function() {
				var newContent = require("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/sass-loader/index.js!./newsTicker.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "news-ticker,news-ticker .ticker-wrapper{position:relative;width:100%;height:100%}news-ticker .ticker-wrapper{transform:translateZ(0);overflow:hidden}news-ticker .ticker-wrapper .ticker-header{position:relative;transform:translateZ(0);display:inline-block;z-index:1000;height:2.9vh;padding:.35vh .6vw;font-size:2.45vmin}news-ticker .ticker-wrapper .ticker-header .ticker-header-content{display:inline-block}news-ticker .ticker-wrapper .ticker-header-infobar{background:linear-gradient(90deg,#6e71c0,#3c40b0);border:.15vw solid #e8e8e8}news-ticker .ticker-wrapper .ticker-header-infobar .ticker-header-content:after{content:'Headlines:'}news-ticker .ticker-wrapper .ticker-header-breaking-news{background:linear-gradient(90deg,#b83d3d,#900);border:.15vw solid #ffaf20}news-ticker .ticker-wrapper .ticker-header-breaking-news .ticker-header-content:before{content:'Breaking News:'}news-ticker .ticker-wrapper .ticker-header-traffic-alert{background:linear-gradient(90deg,#b83d3d,#900);border:.15vw solid #ffaf20}news-ticker .ticker-wrapper .ticker-header-traffic-alert .ticker-header-content:before{content:'Traffic Alert:'}news-ticker .ticker-wrapper .ticker-header-weather-alert{background:linear-gradient(90deg,#b83d3d,#900);border:.15vw solid #ffaf20}news-ticker .ticker-wrapper .ticker-header-weather-alert .ticker-header-content:before{content:'Weather Alert:'}news-ticker .ticker-wrapper .data{transform:translateZ(0);position:absolute;top:0;bottom:0;left:10000px;padding:.8vh .6vw;z-index:100;font-size:2.3vmin;user-select:none;white-space:nowrap}news-ticker .ticker-wrapper-breaking-news{background-color:#900}news-ticker .ticker-wrapper-infobar{background-color:#080c73}news-ticker .ticker-wrapper-traffic-alert,news-ticker .ticker-wrapper-weather-alert{background-color:#900}", ""]);
	
	// exports


/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _logoComponent = __webpack_require__(164);
	
	var _logoComponent2 = _interopRequireDefault(_logoComponent);
	
	var logoModule = _angular2['default'].module('logo', [_angularUiRouter2['default']]).component('logo', _logoComponent2['default']);
	
	exports['default'] = logoModule;
	module.exports = exports['default'];

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _logoHtml = __webpack_require__(165);
	
	var _logoHtml2 = _interopRequireDefault(_logoHtml);
	
	var _logoController = __webpack_require__(166);
	
	var _logoController2 = _interopRequireDefault(_logoController);
	
	__webpack_require__(167);
	
	exports['default'] = {
	  restrict: 'E',
	  bindings: {
	    region: '<'
	  },
	  template: _logoHtml2['default'],
	  controller: _logoController2['default'],
	  controllerAs: 'vm'
	};
	module.exports = exports['default'];

/***/ },
/* 165 */
/***/ function(module, exports) {

	module.exports = "<div ng-style=\"{'background-image': 'url(' + vm.logoPath + ')'}\"></div>\n"

/***/ },
/* 166 */
/***/ function(module, exports) {

	/*---------------------------------------------------------*\
	 * LogoController
	\*---------------------------------------------------------*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var LogoController = (function () {
	  //-----------------------------------
	  // Constructor
	  //-----------------------------------
	
	  function LogoController($timeout) {
	    var _this = this;
	
	    _classCallCheck(this, LogoController);
	
	    this.name = 'logo';
	    this.$timeout = $timeout;
	    this.$timeout(function () {
	      var regionId = _this.region && _this.region.abbr ? _this.region.abbr : 'LI';
	      _this.logoPath = _this.getPath(regionId);
	    });
	  }
	
	  //-----------------------------------
	  // Methods
	  //-----------------------------------
	
	  _createClass(LogoController, [{
	    key: 'getPath',
	    value: function getPath(region) {
	      var prefix = '/assets/images/logos/';
	      return prefix + 'N12' + region + '.png';
	    }
	  }]);
	
	  return LogoController;
	})();
	
	LogoController.$inject = ['$timeout'];
	
	exports['default'] = LogoController;
	module.exports = exports['default'];

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(168);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/sass-loader/index.js!./logo.scss", function() {
				var newContent = require("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/sass-loader/index.js!./logo.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "logo div{background-repeat:no-repeat;background-size:contain;background-position:0;width:100%;height:100%}", ""]);
	
	// exports


/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _otherRegionsComponent = __webpack_require__(170);
	
	var _otherRegionsComponent2 = _interopRequireDefault(_otherRegionsComponent);
	
	var otherRegionsModule = _angular2['default'].module('otherRegions', [_angularUiRouter2['default'], 'constants']).component('otherRegions', _otherRegionsComponent2['default']);
	
	exports['default'] = otherRegionsModule;
	module.exports = exports['default'];

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _otherRegionsHtml = __webpack_require__(171);
	
	var _otherRegionsHtml2 = _interopRequireDefault(_otherRegionsHtml);
	
	var _otherRegionsController = __webpack_require__(172);
	
	var _otherRegionsController2 = _interopRequireDefault(_otherRegionsController);
	
	__webpack_require__(173);
	
	exports['default'] = {
	  restrict: 'E',
	  bindings: {
	    title: '@',
	    onSelect: '&',
	    currentRegion: '<',
	    onKeydown: '&'
	  },
	  template: _otherRegionsHtml2['default'],
	  controller: _otherRegionsController2['default'],
	  controllerAs: 'vm'
	};
	module.exports = exports['default'];

/***/ },
/* 171 */
/***/ function(module, exports) {

	module.exports = "<h2 class=\"subtitle\">{{vm.title}}</h2>\n\n<region-selection\n        selected=\"vm.region\"\n        regions=\"vm.regions\"\n        columns=\"3\"\n        on-select=\"vm.selectRegion(region)\"\n        on-keydown=\"vm.onRegionKeyDown(event, region, index)\"></region-selection>\n"

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _lodash = __webpack_require__(35);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	/*---------------------------------------------------------*\
	 * OtherRegionsController
	\*---------------------------------------------------------*/
	
	var OtherRegionsController = (function () {
	  //-----------------------------------
	  // Constructor
	  //-----------------------------------
	
	  function OtherRegionsController(localService, navigationService, storageKeys) {
	    _classCallCheck(this, OtherRegionsController);
	
	    this.name = 'otherRegions';
	
	    this.title = this.title || 'Select a region:';
	
	    // setting an optional currentRegion property will give flexibility when switching regions on the fly.
	    var region = _lodash2['default'].isUndefined(this.currentRegion) ? localService.get(storageKeys.selectedRegion) : this.currentRegion;
	    var regions = [].concat(localService.get(storageKeys.regions));
	    this.regions = regions.filter(function (r) {
	      return r.abbr !== region.abbr;
	    });
	    navigationService.focusElAsync('.main-content');
	  }
	
	  //-----------------------------------
	  // Methods
	  //-----------------------------------
	
	  _createClass(OtherRegionsController, [{
	    key: 'selectRegion',
	    value: function selectRegion(region) {
	      this.onSelect({ region: region });
	    }
	  }, {
	    key: 'onRegionKeyDown',
	    value: function onRegionKeyDown(event, region, index) {
	      this.onKeydown({
	        event: event,
	        region: region,
	        index: index
	      });
	    }
	  }]);
	
	  return OtherRegionsController;
	})();
	
	OtherRegionsController.$inject = ['localService', 'navigationService', 'storageKeys'];
	
	exports['default'] = OtherRegionsController;
	module.exports = exports['default'];

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(174);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/sass-loader/index.js!./otherRegions.scss", function() {
				var newContent = require("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/sass-loader/index.js!./otherRegions.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "other-regions{display:block;padding-left:10%;padding-top:3%}other-regions h2.subtitle{margin-bottom:2%}", ""]);
	
	// exports


/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _pollComponent = __webpack_require__(176);
	
	var _pollComponent2 = _interopRequireDefault(_pollComponent);
	
	var pollModule = _angular2['default'].module('poll', [_angularUiRouter2['default'], 'constants', 'app.services']).component('poll', _pollComponent2['default']);
	
	exports['default'] = pollModule;
	module.exports = exports['default'];

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _pollHtml = __webpack_require__(177);
	
	var _pollHtml2 = _interopRequireDefault(_pollHtml);
	
	var _pollController = __webpack_require__(178);
	
	var _pollController2 = _interopRequireDefault(_pollController);
	
	__webpack_require__(179);
	
	exports['default'] = {
	  restrict: 'E',
	  bindings: {
	    data: '<',
	    onExit: '&',
	    onKeydown: '&'
	  },
	  template: _pollHtml2['default'],
	  controller: _pollController2['default'],
	  controllerAs: 'vm'
	};
	module.exports = exports['default'];

/***/ },
/* 177 */
/***/ function(module, exports) {

	module.exports = "<div class=\"poll-wrapper\">\n  <div ng-if=\"vm.loading\" class=\"loading\">\n    Loading...\n  </div>\n\n  <div class=\"poll-content\" ng-if=\"!vm.loading\">\n    <div class=\"poll-vote\" ng-if=\"!vm.showResults\">\n      <h1>{{vm.data.polltitle}}</h1>\n      <news12-list items=\"vm.data.options.option\"\n        show-arrows=\"false\"\n        label-field=\"content\"\n        class=\"focusable-first\"\n        item-click-handler=\"vm.onListItemClick\"\n        prev-component-handler=\"vm.listPrevComponentHandler\"\n        next-component-handler=\"vm.listNextComponentHandler\"></news12-list>\n    </div>\n\n    <div class=\"poll-result\" ng-if=\"vm.showResults\">\n      <h1>{{vm.result.polltitle}}</h1>\n      <ul>\n        <li ng-repeat=\"n in vm.result.options.option\">\n          <label class=\"radio\">\n            <i></i>\n            {{n}}\n            <br/>\n          </label>\n        </li>\n      </ul>\n    </div>\n  </div>\n\n  <div class=\"poll-nav\">\n    <div class=\"btngroup\">\n      <div class=\"totalVotes\" ng-if=\"vm.showResults\"><h2>Total Votes: {{vm.result.totalvotes}}</h2></div>\n      <div class=\"main-menu-btn\">\n        <news12-button on-select=\"vm.showMain()\"\n          on-keydown=\"vm.mainBlockLeft(event)\"\n          on-keyup=\"vm.mainBlockLeft(event)\"\n          class=\"focusable-last\">Main</news12-button>\n      </div>\n      <div class=\"results-btn\" ng-if=\"!vm.showResults\">\n        <news12-button on-select=\"vm.resultsSelect()\"\n        on-keydown=\"vm.resultsBlockLeft(event)\"\n        on-keyup=\"vm.resultsBlockLeft(event)\">Results</news12-button>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	/*---------------------------------------------------------*\
	 * Imports
	\*---------------------------------------------------------*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _pubsubJs = __webpack_require__(32);
	
	var _pubsubJs2 = _interopRequireDefault(_pubsubJs);
	
	var _keycodeUi = __webpack_require__(33);
	
	var _keycodeUi2 = _interopRequireDefault(_keycodeUi);
	
	/*---------------------------------------------------------*\
	 * PollController
	\*---------------------------------------------------------*/
	
	var PollController = (function () {
	  //-----------------------------------
	  // Constructor
	  //-----------------------------------
	
	  function PollController($location, topics, navigationService, pollsService, localService, storageKeys, adProps) {
	    var _this = this;
	
	    _classCallCheck(this, PollController);
	
	    this.name = 'poll';
	    this.navigationService = navigationService;
	    this.pollsService = pollsService;
	    this.localService = localService;
	    this.storageKeys = storageKeys;
	    this.adProps = adProps;
	
	    // Todo remove $location ref at some point
	    this._showResults = !!$location.search().pollResults;
	
	    this.loading = true;
	
	    pollsService.getQuestion(this.region).then(function (data) {
	      _this.data = data.data.pollquestion;
	      _this.loading = false;
	
	      _this.navigationService.focusElAsync('.poll-vote');
	    });
	
	    this.onListItemClick = function (event) {
	      _this.loading = true;
	
	      pollsService.postVote(_this.data.pollid, event.item.id).then(function (data) {
	        _this.result = data.data.pollquestion;
	        _this.showResults = true;
	        _this.loading = false;
	      });
	    };
	
	    this.listPrevComponentHandler = function (index, up) {
	      if (up) {
	        _this.onKeydown({
	          isEventUp: up
	        });
	      }
	    };
	
	    this.listNextComponentHandler = function (index, down) {
	      _pubsubJs2['default'].publish(down ? topics.nav.down : topics.nav.right, 'poll-list');
	    };
	
	    this.resultsBlockLeft = function (e) {
	      if (_keycodeUi2['default'].isLeft(e)) {
	        e.preventDefault();
	        e.stopPropagation();
	      } else if (_keycodeUi2['default'].isDown(e)) {
	        var previousElement = e.target;
	        _pubsubJs2['default'].publish(_this.adProps.home.previousElement, { previousElement: previousElement });
	      }
	    };
	
	    this.mainBlockLeft = function (e) {
	      if (_keycodeUi2['default'].isDown(e) || _keycodeUi2['default'].isRight(e)) {
	        var previousElement = e.target;
	        _pubsubJs2['default'].publish(_this.adProps.home.previousElement, { previousElement: previousElement });
	      }
	    };
	  }
	
	  //-----------------------------------
	  // Properties
	  //-----------------------------------
	
	  _createClass(PollController, [{
	    key: 'resultsSelect',
	
	    //-----------------------------------
	    // Methods
	    //-----------------------------------
	    value: function resultsSelect() {
	      var _this2 = this;
	
	      this.loading = true;
	
	      this.pollsService.getResults(this.data.pollid).then(function (data) {
	        _this2.result = data.data.pollquestion;
	        _this2.showResults = true;
	        _this2.loading = false;
	      });
	    }
	  }, {
	    key: 'showMain',
	    value: function showMain() {
	      if (this.onExit) {
	        this.onExit();
	      }
	    }
	  }, {
	    key: 'showResults',
	    set: function set(value) {
	      this._showResults = value;
	
	      if (this._showResults) {
	        this.navigationService.focusElAsync('.main-menu-btn');
	      }
	    },
	    get: function get() {
	      return this._showResults;
	    }
	  }, {
	    key: 'region',
	    get: function get() {
	      var _region = this.localService.get(this.storageKeys.selectedRegion);
	
	      return _region ? _region.abbr : 'LI';
	    }
	  }]);
	
	  return PollController;
	})();
	
	PollController.$inject = ['$location', 'topics', 'navigationService', 'pollsService', 'localService', 'storageKeys', 'adProps'];
	
	exports['default'] = PollController;
	module.exports = exports['default'];

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(180);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/sass-loader/index.js!./poll.scss", function() {
				var newContent = require("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/sass-loader/index.js!./poll.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "h1{font-family:Roboto,Helvetica,Arial,sans-serif;font-size:4.3vmin;font-weight:500;line-height:9vmin}h1,h2{margin:0}h2{font-family:Roboto Condensed,Arial Narrow,Helvetica,Arial,sans-serif;font-size:3.5vmin;font-weight:400}poll{position:absolute;left:0;right:0;top:0;bottom:0}poll .poll-wrapper{width:100%;height:100%}poll .poll-wrapper .poll-content{height:85.2%;display:block}poll .poll-wrapper .poll-content .poll-vote label>i{margin-left:0!important}poll .poll-wrapper .poll-content ul{font-size:3vmin;list-style:none;margin-left:0;padding:0}poll .poll-wrapper .poll-content ul li{font-size:3.5vmin;font-weight:400}poll .poll-wrapper .poll-content ul li:first-child:nth-last-child(1),poll .poll-wrapper .poll-content ul li:first-child:nth-last-child(1)~li{margin-top:1vh}poll .poll-wrapper .poll-content ul li:first-child:nth-last-child(2),poll .poll-wrapper .poll-content ul li:first-child:nth-last-child(2)~li{margin-top:.5vh}poll .poll-wrapper .poll-content ul li:first-child:nth-last-child(3),poll .poll-wrapper .poll-content ul li:first-child:nth-last-child(3)~li{margin-top:.33333vh}poll .poll-wrapper .poll-content ul li:first-child:nth-last-child(4),poll .poll-wrapper .poll-content ul li:first-child:nth-last-child(4)~li{margin-top:.25vh}poll .poll-wrapper .poll-content ul li:focus{outline:none;background-color:#353958}poll .poll-wrapper .poll-content ul li:focus i{background:orange}poll .poll-wrapper .poll-content label{cursor:pointer;user-select:none;-webkit-user-select:none;-webkit-touch-callout:none}poll .poll-wrapper .poll-content label>i{display:inline-block;vertical-align:middle;width:1vw;height:1vw;border-radius:50%;border:.2vw solid #fff;background:#4d48aa;margin-bottom:.4%;margin-right:.75%;margin-left:9%}poll .poll-wrapper .poll-content h1{font-size:4vmin;margin:0;line-height:normal;padding:2vh 2vw 2vh 9%}poll .poll-wrapper .poll-nav{height:14.7%;display:block}poll .poll-wrapper .poll-nav .btngroup{position:absolute;bottom:0;left:0;right:0;background-color:#172663;padding:1vh;border-top:.25vmin solid #a5b3d3}poll .poll-wrapper .poll-nav .btngroup .main-menu-btn,poll .poll-wrapper .poll-nav .btngroup .results-btn{display:inline-block;float:right}poll .poll-wrapper .poll-nav .btngroup .main-menu-btn button,poll .poll-wrapper .poll-nav .btngroup .results-btn button{width:100%}poll .poll-wrapper .poll-nav .btngroup .main-menu-btn button span,poll .poll-wrapper .poll-nav .btngroup .results-btn button span{font-size:2.7vmin}poll .poll-wrapper .poll-nav .btngroup .main-menu-btn{margin-left:2.8%;width:8.5%}poll .poll-wrapper .poll-nav .btngroup .results-btn{width:10.85%}poll .poll-wrapper .poll-nav .btngroup .totalVotes{display:inline-block;height:5vh;margin-top:1vh;padding-left:9%;line-height:5vh}poll .poll-wrapper .poll-nav .btngroup .totalVotes h2{text-align:left;font-size:3.5vmin}poll .poll-wrapper .loading{font-size:3vmin;font-weight:400;position:absolute;top:2vh;left:7.3vw;right:0;text-align:left;background-color:transparent}", ""]);
	
	// exports


/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _weatherIconsComponent = __webpack_require__(182);
	
	var _weatherIconsComponent2 = _interopRequireDefault(_weatherIconsComponent);
	
	var weatherIconsModule = _angular2['default'].module('weatherIcons', [_angularUiRouter2['default']]).component('weatherIcons', _weatherIconsComponent2['default']);
	
	exports['default'] = weatherIconsModule;
	module.exports = exports['default'];

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _weatherIconsHtml = __webpack_require__(183);
	
	var _weatherIconsHtml2 = _interopRequireDefault(_weatherIconsHtml);
	
	var _weatherIconsController = __webpack_require__(184);
	
	var _weatherIconsController2 = _interopRequireDefault(_weatherIconsController);
	
	__webpack_require__(185);
	
	exports['default'] = {
	  restrict: 'E',
	  bindings: {
	    region: '<'
	  },
	  template: _weatherIconsHtml2['default'],
	  controller: _weatherIconsController2['default'],
	  controllerAs: 'vm'
	};
	module.exports = exports['default'];

/***/ },
/* 183 */
/***/ function(module, exports) {

	module.exports = "<div ng-style=\"{'background-image': 'url(' + vm.iconsSrc + ')'}\" />"

/***/ },
/* 184 */
/***/ function(module, exports) {

	/*---------------------------------------------------------*\
	 * WeatherIconsController
	\*---------------------------------------------------------*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var WeatherIconsController =
	//-----------------------------------
	// Constructor
	//-----------------------------------
	function WeatherIconsController(weatherService, $timeout) {
	  var _this = this;
	
	  _classCallCheck(this, WeatherIconsController);
	
	  this.$timeout = $timeout;
	  this.name = 'weatherIconsComponent';
	  this.$timeout(function () {
	    _this.regionId = _this.region && _this.region.abbr || 'LI';
	    _this.iconsSrc = weatherService.getWeatherIconsUrl(_this.regionId);
	  });
	};
	
	WeatherIconsController.$inject = ['weatherService', '$timeout'];
	
	exports['default'] = WeatherIconsController;
	module.exports = exports['default'];

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(186);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/sass-loader/index.js!./weatherIcons.scss", function() {
				var newContent = require("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/sass-loader/index.js!./weatherIcons.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "weather-icons div{background-size:contain!important;background-repeat:no-repeat!important;width:100%;height:9vh}", ""]);
	
	// exports


/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _photoGalleryComponent = __webpack_require__(188);
	
	var _photoGalleryComponent2 = _interopRequireDefault(_photoGalleryComponent);
	
	var photoGalleryModule = _angular2['default'].module('photoGallery', [_angularUiRouter2['default'], 'constants', 'app.services']).component('photoGallery', _photoGalleryComponent2['default']);
	
	exports['default'] = photoGalleryModule;
	module.exports = exports['default'];

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _photoGalleryHtml = __webpack_require__(189);
	
	var _photoGalleryHtml2 = _interopRequireDefault(_photoGalleryHtml);
	
	var _photoGalleryController = __webpack_require__(190);
	
	var _photoGalleryController2 = _interopRequireDefault(_photoGalleryController);
	
	__webpack_require__(191);
	
	exports['default'] = {
	  restrict: 'E',
	  bindings: {
	    modal: '=',
	    slideshowOn: '=',
	    images: '<'
	  },
	  template: _photoGalleryHtml2['default'],
	  controller: _photoGalleryController2['default'],
	  controllerAs: 'vm'
	};
	module.exports = exports['default'];

/***/ },
/* 189 */
/***/ function(module, exports) {

	module.exports = "<div class=\"photo-gallery\" ng-class=\"vm.modal ? 'enlarged-view' : 'small-view'\">\n  <div class=\"back-button\" ng-if=\"vm.modal\">\n    <news12-button on-select=\"vm.goBack()\"\n                   on-keydown=\"vm.keydownHandler(event)\"\n                   on-keyup=\"vm.keyUp(event)\">Back</news12-button>\n  </div>\n  <div class=\"image-wrapper\">\n    <div class=\"nav-arrow-left\">\n      <i class=\"fa fa-angle-left\"\n         aria-hidden=\"true\"\n         ng-show=\"!!vm.photos.selIndex\"></i>\n    </div>\n    <div class=\"image\" ng-style=\"{'background-image': 'url(' + vm.photos.images[vm.photos.selIndex].photoURLHQ + ')' }\">\n      <div class=\"loading\" ng-if=\"vm.loading\">Loading...</div>\n      <div class=\"loading\" ng-if=\"vm.error\">Image file is missing.</div>\n    </div>\n    <div class=\"nav-arrow-right\">\n      <i class=\"fa fa-angle-right\" aria-hidden=\"true\" ng-show=\"vm.photos.selIndex &lt; vm.photos.images.length - 1\"></i>\n    </div>\n  </div>\n  <div class=\"image-description\">\n    <h6>{{vm.photos.images[vm.photos.selIndex].caption}}</h6>\n  </div>\n  <div class=\"gallery-pagination\">\n    <h6>{{vm.photos.selIndex + 1}} / {{vm.photos.images.length}}</h6>\n  </div>\n  <div class=\"enlarge-button\" ng-if=\"!vm.modal\">\n    <news12-button on-keyup=\"vm.enlargeKeyUp(event)\" on-keydown=\"vm.keydownHandler(event)\" ng-class=\"{'focusable-first' : vm.modal}\">Enlarge</news12-button>\n  </div>\n</div>\n"

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	/*---------------------------------------------------------*\
	 * Imports
	\*---------------------------------------------------------*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _keycodeUi = __webpack_require__(33);
	
	var _keycodeUi2 = _interopRequireDefault(_keycodeUi);
	
	var _pubsubJs = __webpack_require__(32);
	
	var _pubsubJs2 = _interopRequireDefault(_pubsubJs);
	
	/*---------------------------------------------------------*\
	 * Constants
	\*---------------------------------------------------------*/
	var deps = {};
	
	/*---------------------------------------------------------*\
	 * PhotoGalleryController
	\*---------------------------------------------------------*/
	
	var PhotoGalleryController = (function () {
	  //-----------------------------------
	  // Constructor
	  //-----------------------------------
	
	  function PhotoGalleryController($scope, $state, $element, $interval, navigationService, topics, states) {
	    var _this = this;
	
	    _classCallCheck(this, PhotoGalleryController);
	
	    this.name = 'photoGallery';
	    this.photos = this.images;
	
	    deps.$scope = $scope;
	    deps.$state = $state;
	    deps.$element = $element;
	    deps.$interval = $interval;
	    deps.navigationService = navigationService;
	    deps.topics = topics;
	    deps.states = states;
	
	    var token = _pubsubJs2['default'].subscribe(deps.topics.component.slideshowToggle, function (msg, data) {
	      if (data.slideshowOn) {
	        // start(this.photos, this.photos.selIndex);
	        _this.resetSlideshow();
	      } else if (!data.slideshowOn) {
	        deps.$interval.cancel(_this.promise);
	      }
	      _this.slideshowOn = data.slideshowOn;
	    });
	
	    deps.$scope.$on('$destroy', function () {
	      deps.$interval.cancel(_this.promise);
	      _pubsubJs2['default'].unsubscribe(token);
	    });
	  }
	
	  //-----------------------------------
	  // Lifecycle
	  //-----------------------------------
	
	  _createClass(PhotoGalleryController, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.selectImage(this.photos.selIndex);
	      var currentClass = this.enlarged ? 'back-button' : 'enlarge-button';
	      deps.navigationService.focusElAsync('.' + currentClass);
	    }
	  }, {
	    key: '$onInit',
	    value: function $onInit() {
	      if (this.slideshowOn) {
	        this.start(this.photos, 0);
	      }
	    }
	
	    //-----------------------------------
	    // Methods
	    //-----------------------------------
	
	  }, {
	    key: 'start',
	    value: function start(array, currentIndex) {
	      var _this2 = this;
	
	      if (this.promise) {
	        deps.$interval.cancel(this.promise);
	      }
	      var nextIndex = currentIndex + 1;
	      this.promise = deps.$interval(function () {
	        _this2.selectImage(nextIndex);
	        nextIndex++;
	      }, 4000, [array.images.length - currentIndex]);
	    }
	  }, {
	    key: 'selectImage',
	    value: function selectImage(index) {
	      var _this3 = this;
	
	      if (index < 0 || index >= this.photos.images.length) {
	        return;
	      }
	
	      // Create temporary image attribute so we can load the image and display
	      // loading while it is coming in.
	      var img = document.createElement('img');
	
	      this.photos.selIndex = index;
	
	      this.loading = true;
	      this.error = false;
	
	      img.addEventListener('load', function () {
	        _this3.loading = false;
	        deps.$scope.$apply();
	      });
	
	      img.addEventListener('error', function () {
	        _this3.error = true;
	        _this3.loading = false;
	        deps.$scope.$apply();
	      });
	
	      img.src = this.photos.images[this.photos.selIndex].photoURLHQ + '?v=' + Math.random();
	
	      // change ads only if image is changed
	      this.changeAds();
	    }
	  }, {
	    key: 'enlargeGallery',
	    value: function enlargeGallery() {
	      this.modal = true;
	      deps.navigationService.focusElAsync('.back-button');
	    }
	  }, {
	    key: 'goBack',
	    value: function goBack() {
	      this.modal = false;
	      deps.navigationService.focusElAsync('.enlarge-button');
	    }
	  }, {
	    key: 'resetSlideshow',
	    value: function resetSlideshow() {
	      if (this.promise) {
	        deps.$interval.cancel(this.promise);
	      }
	      this.start(this.photos, this.photos.selIndex);
	    }
	
	    //-----------------------------------
	    // Events
	    //-----------------------------------
	  }, {
	    key: 'keydownHandler',
	    value: function keydownHandler(e) {
	      if (_keycodeUi2['default'].isLeft(e)) {
	        e.preventDefault();
	
	        var newIndex = this.photos.selIndex - 1;
	        if (newIndex > -1) {
	          this.selectImage(newIndex);
	          if (this.slideshowOn) {
	            this.resetSlideshow();
	          }
	        } else {
	          _pubsubJs2['default'].publish(deps.topics.nav.left, 'photo-gallery');
	        }
	      } else if (_keycodeUi2['default'].isRight(e)) {
	        e.preventDefault();
	        this.selectImage(this.photos.selIndex + 1);
	        if (this.slideshowOn) {
	          this.resetSlideshow();
	        }
	      } else if (_keycodeUi2['default'].isUp(e)) {
	        e.preventDefault();
	        _pubsubJs2['default'].publish(deps.topics.nav.up, 'photo-gallery');
	      } else if (_keycodeUi2['default'].isEnter(e)) {
	        this.enlargeGallery();
	      }
	    }
	  }, {
	    key: 'keyUp',
	    value: function keyUp(e) {
	      e.preventDefault();
	      e.stopImmediatePropagation();
	      if (_keycodeUi2['default'].isBack(e)) {
	        this.goBack();
	      }
	    }
	  }, {
	    key: 'changeAds',
	    value: function changeAds() {
	      // change ads only when in small view
	      if (!this.enlarged) {
	        _pubsubJs2['default'].publish(deps.topics.ads.refreshAd);
	      }
	    }
	  }]);
	
	  return PhotoGalleryController;
	})();
	
	PhotoGalleryController.$inject = ['$scope', '$state', '$element', '$interval', 'navigationService', 'topics', 'states'];
	
	exports['default'] = PhotoGalleryController;
	module.exports = exports['default'];

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(192);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/sass-loader/index.js!./photoGallery.scss", function() {
				var newContent = require("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/sass-loader/index.js!./photoGallery.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "h1{font-family:Roboto,Helvetica,Arial,sans-serif;font-size:4.3vmin;font-weight:500;line-height:9vmin}h1,h2{margin:0}h2{font-family:Roboto Condensed,Arial Narrow,Helvetica,Arial,sans-serif;font-size:3.5vmin;font-weight:400}photo-gallery{display:block;width:100%;height:100%}photo-gallery .photo-gallery{width:90%;padding:0 5%;height:99%}photo-gallery .photo-gallery .image-wrapper{height:100%}photo-gallery .photo-gallery .image-wrapper .image,photo-gallery .photo-gallery .image-wrapper .nav-arrow-left,photo-gallery .photo-gallery .image-wrapper .nav-arrow-right{display:inline-block;float:left;position:relative}photo-gallery .photo-gallery .image-wrapper .image{height:100%;width:70%;max-width:100%;background-size:contain!important;background-position:50%!important;background-repeat:no-repeat!important}photo-gallery .photo-gallery .image-wrapper .image .error,photo-gallery .photo-gallery .image-wrapper .image .loading{position:absolute;width:100%;height:100%;left:0;top:0;background-color:#000;text-align:center;font-size:5.5vmin}photo-gallery .photo-gallery .image-wrapper .nav-arrow-left,photo-gallery .photo-gallery .image-wrapper .nav-arrow-right{width:10%;height:100%}photo-gallery .photo-gallery .image-wrapper .nav-arrow-left i,photo-gallery .photo-gallery .image-wrapper .nav-arrow-right i{text-align:right;line-height:209%;font-size:20vmin;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}photo-gallery .photo-gallery .image-wrapper .nav-arrow-right{padding-left:5%;text-align:left}photo-gallery .photo-gallery .image-wrapper .nav-arrow-left{padding-right:5%;text-align:right}photo-gallery .small-view{position:relative;height:85%}photo-gallery .small-view .image-description{width:100%;margin-top:3%}photo-gallery .small-view .image-description h6{margin:0;font-size:1rem;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}photo-gallery .small-view .enlarge-button{position:absolute;bottom:5%;right:0;width:15%}photo-gallery .small-view .enlarge-button news12-button button{width:6vw}photo-gallery .small-view .enlarge-button news12-button button>div{padding:.5vh 1.5vw}photo-gallery .small-view .gallery-pagination{position:absolute;top:5%;right:0;width:15%}photo-gallery .small-view .gallery-pagination h6{margin:0;font-size:2vmin}photo-gallery .enlarged-view{height:100%;width:75%;padding:0 12.5%;position:relative}photo-gallery .enlarged-view .image-wrapper{width:100%;position:relative;height:70%;top:15.75%}photo-gallery .enlarged-view .nav-arrow-left,photo-gallery .enlarged-view .nav-arrow-right{margin-top:12.5%;height:50%}photo-gallery .enlarged-view .image-description{position:absolute;width:60%;top:8.5%;left:20%}photo-gallery .enlarged-view .image-description h6{margin:2% 0;font-size:2.7vmin;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}photo-gallery .enlarged-view .gallery-pagination{position:absolute;top:10%;right:10%;width:10%;text-align:center}photo-gallery .enlarged-view .gallery-pagination h6{line-height:5vh;margin:0;font-size:2.7vmin}photo-gallery .enlarged-view .back-button{position:absolute;top:10%;height:4.5%;width:10%;left:10%}photo-gallery .enlarged-view .back-button news12-button button>div{padding:.5vh 1.5vw}", ""]);
	
	// exports


/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _news12ListComponent = __webpack_require__(194);
	
	var _news12ListComponent2 = _interopRequireDefault(_news12ListComponent);
	
	var news12ListModule = _angular2['default'].module('news12List', [_angularUiRouter2['default']]).component('news12List', _news12ListComponent2['default']);
	
	exports['default'] = news12ListModule;
	module.exports = exports['default'];

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _news12ListHtml = __webpack_require__(195);
	
	var _news12ListHtml2 = _interopRequireDefault(_news12ListHtml);
	
	var _news12ListController = __webpack_require__(196);
	
	var _news12ListController2 = _interopRequireDefault(_news12ListController);
	
	__webpack_require__(197);
	
	exports['default'] = {
	  restrict: 'E',
	  bindings: {
	    btnClass: '@',
	    items: '<',
	    itemClickHandler: '<',
	    nextComponentHandler: '<',
	    prevComponentHandler: '<',
	    changeHandler: '<',
	    listId: '@',
	    labelField: '@',
	    itemsPerColumn: '@',
	    itemsPerScroll: '@',
	    showPagination: '@',
	    upIsPrev: '@',
	    downIsNext: '@',
	    cancelAllDownKeyEvents: '@',
	    cancelAllUpKeyEvents: '@',
	    focusOnPopulateIx: '<',
	    showIcon: '<',
	    showArrows: '<'
	  },
	  template: _news12ListHtml2['default'],
	  controller: _news12ListController2['default'],
	  controllerAs: 'vm'
	};
	module.exports = exports['default'];

/***/ },
/* 195 */
/***/ function(module, exports) {

	module.exports = "<div class=\"up-arrow\" ng-style=\"{'visibility': vm.showPrev ? 'visible' : 'hidden'}\" ng-if=\"vm.showArrows\">\n  <div class=\"up\"></div>\n</div>\n<ul>\n  <li ng-repeat=\"n in vm.displayItems\"\n      ng-class=\"{focusable: true, 'focusable-first': $index === 0, 'focusable-last': $index === vm.displayItems.length-1}\"\n      id=\"{{vm.listId}}_li_{{vm.startIndex + $index}}\"\n      tabindex=\"0\"\n      autofocus=\"true\"\n      ng-keypress=\"vm.keyPressHandler($index, $event)\"\n      ng-keydown=\"vm.keyDownHandler($index, $event)\"\n      ng-keyup=\"vm.keyUpHandler($index, $event)\"\n      ng-focus=\"vm.focusHandler($index, $event)\">\n    <label class=\"radio\">\n      <i ng-if=\"vm.showIcon\"></i>\n      {{n[vm.labelField]}}\n      <br/>\n    </label>\n  </li>\n</ul>\n<div class=\"down-arrow\" ng-style=\"{'visibility': vm.showNext ? 'visible' : 'hidden'}\" ng-if=\"vm.showArrows\">\n  <div class=\"down\"></div>\n</div>"

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	/*---------------------------------------------------------*\
	 * Imports
	\*---------------------------------------------------------*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _keycodeUi = __webpack_require__(33);
	
	var _keycodeUi2 = _interopRequireDefault(_keycodeUi);
	
	/*---------------------------------------------------------*\
	 * Globals
	\*---------------------------------------------------------*/
	var cancelEvent = function cancelEvent(event) {
	  event.preventDefault();
	  event.stopImmediatePropagation();
	};
	
	/*---------------------------------------------------------*\
	 * The News12List class is designed to manage the navigation of a pageable sequence of items,
	 * like the video list.
	 *
	 * It displays all its elements using the same button classes in a vertical layout. It manages
	 * proper tabbing and arrow key navigation.
	\*---------------------------------------------------------*/
	
	var News12List = (function () {
	  //-----------------------------------
	  // Constructor
	  //-----------------------------------
	
	  function News12List($timeout) {
	    _classCallCheck(this, News12List);
	
	    this.name = 'list';
	
	    this.$timeout = $timeout;
	
	    this._selectedIndex = 0;
	    this._labels = [];
	    this._datas = [];
	    this._item = 7;
	    this._startIndex = 0;
	    this.listId = this.listId || 'NO_LIST_ID_PROVIDED';
	
	    this.itemsPerColumn = this.itemsPerColumn || 7;
	    this.itemsPerScroll = 1;
	
	    this.showIcon = this.showIcon === undefined ? true : this.showIcon;
	    this.showArrows = this.showArrows === undefined ? true : this.showArrows;
	
	    this._upIsPrev = this._upIsPrev === undefined ? true : this._upIsPrev;
	    this._downIsNext = this._downIsNext === undefined ? true : this._downIsNext;
	
	    this.cancelAllDownKeyEvents = this.cancelAllDownKeyEvents === undefined ? false : this.cancelAllDownKeyEvents;
	    this.cancelAllUpKeyEvents = this.cancelAllUpKeyEvents === undefined ? false : this.cancelAllUpKeyEvents;
	
	    this.ignoreNextUp = false;
	
	    this.labelField = this.labelField || 'label';
	  }
	
	  //-----------------------------------
	  // Properties
	  //-----------------------------------
	
	  _createClass(News12List, [{
	    key: 'focus',
	
	    //-----------------------------------
	    // Methods
	    //-----------------------------------
	    value: function focus(index, focusOnPopulate, zeroIndex) {
	      index = index || 0;
	
	      if (focusOnPopulate) {
	        this.focusOnPopulateIx = index;
	        return;
	      }
	
	      this.selectedIndex = (zeroIndex ? 0 : this.startIndex) + index;
	    }
	  }, {
	    key: 'focusSelectedIndex',
	    value: function focusSelectedIndex(ignoreTimeout) {
	      var elId = this.listId + '_li_' + this._selectedIndex;
	      var el = document.getElementById(elId);
	
	      if (el) {
	        el.focus();
	      } else if (!ignoreTimeout) {
	        this.$timeout(this.focusSelectedIndex.bind(this, true));
	      }
	    }
	  }, {
	    key: 'pageDown',
	    value: function pageDown() {
	      var _this = this;
	
	      if (this.items && this.items.length > this.startIndex + this.itemsPerColumn) {
	        this.startIndex += this.itemsPerScroll;
	
	        this.$timeout(function () {
	          _this.selectedIndex += _this.itemsPerScroll;
	        });
	      }
	    }
	  }, {
	    key: 'pageUp',
	    value: function pageUp() {
	      var _this2 = this;
	
	      if (this.startIndex > 0) {
	        this.startIndex -= this.itemsPerScroll;
	
	        if (this.startIndex < 0) {
	          this.startIndex = 0;
	        }
	
	        this.$timeout(function () {
	          _this2.selectedIndex -= _this2.itemsPerScroll;
	        });
	      }
	    }
	
	    //-----------------------------------
	    // Events
	    //-----------------------------------
	  }, {
	    key: 'focusHandler',
	    value: function focusHandler(ix) {
	      this.selectedIndex = this.startIndex + ix;
	    }
	  }, {
	    key: 'keyPressHandler',
	    value: function keyPressHandler($index, event) {
	      if (_keycodeUi2['default'].isEnter(event)) {
	        var index = this.startIndex + $index;
	
	        if (this.itemClickHandler) {
	          this.itemClickHandler({
	            index: index,
	            $index: $index,
	            item: this._items[index],
	            event: event
	          });
	        }
	      }
	    }
	  }, {
	    key: 'keyDownHandler',
	    value: function keyDownHandler($index, event) {
	      var _this3 = this;
	
	      var cancel = function cancel(event) {
	        cancelEvent(event);
	        _this3.ignoreNextUp = true;
	      };
	
	      this.canNext = this.canPrev = false;
	
	      // Down arrow or tab key
	      if (_keycodeUi2['default'].isTab(event) || _keycodeUi2['default'].isDown(event)) {
	        var nextItem = this.selectedIndex + 1;
	
	        if ($index === this.itemsPerColumn - 1 && this.items.length - 1 > this.startIndex + $index) {
	          this.pageDown();
	          cancel(event);
	        } else if (nextItem <= this.items.length) {
	          this.selectedIndex = nextItem === this.items.length ? this.selectedIndex : nextItem;
	          if (nextItem < this.items.length) {
	            cancel(event);
	          }
	        }
	      } else if (_keycodeUi2['default'].isShiftTab(event) || _keycodeUi2['default'].isUp(event)) {
	        // Up arrow or shift tab
	        if ($index % this.itemsPerColumn === 0 && this.startIndex > 0) {
	          this.pageUp();
	          cancel(event);
	        } else if (this.selectedIndex > 0) {
	          this.selectedIndex--;
	          cancel(event);
	        }
	      }
	
	      if ((_keycodeUi2['default'].isTab(event) || _keycodeUi2['default'].isDown(event)) && this.startIndex + $index === this.items.length - 1 || _keycodeUi2['default'].isRight(event)) {
	        if (this.nextComponentHandler) {
	          this.canNext = true;
	          cancelEvent(event);
	        }
	      } else if (_keycodeUi2['default'].isUp(event) && this.selectedIndex === 0 || _keycodeUi2['default'].isLeft(event)) {
	        if (this.prevComponentHandler) {
	          this.canPrev = true;
	          cancelEvent(event);
	        }
	      }
	
	      if (this.cancelAllDownKeyEvents && _keycodeUi2['default'].isDown(event) || this.cancelAllUpKeyEvents && _keycodeUi2['default'].isUp(event)) {
	        cancelEvent(event);
	      }
	    }
	  }, {
	    key: 'keyUpHandler',
	    value: function keyUpHandler($index, event) {
	      if (this.ignoreNextUp) {
	        cancelEvent(event);
	        this.ignoreNextUp = false;
	        return;
	      }
	
	      var nextIndex = undefined;
	
	      var down = _keycodeUi2['default'].isDown(event) && this.selectedIndex === this.items.length - 1;
	      var right = _keycodeUi2['default'].isRight(event);
	      var up = _keycodeUi2['default'].isUp(event) && this.selectedIndex === 0;
	      var left = _keycodeUi2['default'].isLeft(event);
	
	      if (this.canNext && (down && this.downIsNext || right)) {
	        if (this.nextComponentHandler) {
	          nextIndex = _keycodeUi2['default'].isDown(event) ? 0 : this.selectedIndex - this.startIndex;
	
	          this.nextComponentHandler(nextIndex, _keycodeUi2['default'].isDown(event), this.selectedItem);
	        }
	      } else if (this.canPrev && (up && this.upIsPrev || left)) {
	        if (this.prevComponentHandler) {
	          nextIndex = _keycodeUi2['default'].isUp(event) ? this.itemsPerColumn : this.selectedIndex - this.startIndex;
	
	          this.prevComponentHandler(nextIndex, _keycodeUi2['default'].isUp(event), this.selectedItem);
	        }
	      }
	
	      if (this.canNext && (down || right) || this.canPrev && (up || left)) {
	        cancelEvent(event);
	      }
	
	      if (this.cancelAllDownKeyEvents && _keycodeUi2['default'].isDown(event) || this.cancelAllUpKeyEvents && _keycodeUi2['default'].isUp(event)) {
	        cancelEvent(event);
	      }
	    }
	  }, {
	    key: 'upIsPrev',
	    set: function set(value) {
	      this._upIsPrev = value !== 'false' && value !== false;
	    },
	    get: function get() {
	      return this._upIsPrev;
	    }
	  }, {
	    key: 'downIsNext',
	    set: function set(value) {
	      this._downIsNext = value !== 'false' && value !== false;
	    },
	    get: function get() {
	      return this._downIsNext;
	    }
	  }, {
	    key: 'items',
	    set: function set(value) {
	      var _this4 = this;
	
	      if (this._items === value) {
	        return;
	      }
	
	      this._items = value;
	      this._selectedIndex = this._startIndex = 0;
	
	      this._labels = [];
	      this._datas = [];
	
	      if (this._items && this._items.length) {
	        this._items.forEach(function (item) {
	          _this4._labels.push(item.label);
	          _this4._datas.push(item.data);
	        });
	      }
	
	      if (this.focusOnPopulateIx !== undefined) {
	        (function () {
	          var ix = _this4.focusOnPopulateIx;
	
	          _this4.$timeout(function () {
	            return _this4.focus(ix);
	          });
	
	          _this4.focusOnPopulateIx = undefined;
	        })();
	      }
	
	      if (this.changeHandler) {
	        this.changeHandler({
	          list: this
	        });
	      }
	    },
	
	    // -----------------------------------
	    // items
	    // -----------------------------------
	    get: function get() {
	      return this._items;
	    }
	
	    // -----------------------------------
	    // itemsPerColumn
	    // -----------------------------------
	  }, {
	    key: 'itemsPerColumn',
	    set: function set(value) {
	      this._itemsPerColumn = typeof value === 'string' ? parseInt(value, 10) : value;
	    },
	    get: function get() {
	      return this._itemsPerColumn;
	    }
	
	    // -----------------------------------
	    // itemsPerScroll
	    // -----------------------------------
	  }, {
	    key: 'itemsPerScroll',
	    set: function set(value) {
	      this._itemsPerScroll = typeof value === 'string' ? parseInt(value, 10) : value;
	    },
	    get: function get() {
	      return this._itemsPerScroll;
	    }
	
	    // -----------------------------------
	    // displayItems
	    // -----------------------------------
	    /**
	     * Returns only the items that have been determined to be displayable based on the display
	     * startIndex and the itemsPerColumn.
	     *
	     * @returns {*}
	     */
	  }, {
	    key: 'displayItems',
	    get: function get() {
	      return this._items && this._items.length ? this._items.slice(this._startIndex, this._startIndex + this.itemsPerColumn) : [];
	    }
	
	    // -----------------------------------
	    // labels
	    // -----------------------------------
	  }, {
	    key: 'labels',
	    get: function get() {
	      return this._labels;
	    }
	
	    // -----------------------------------
	    // datas
	    // -----------------------------------
	  }, {
	    key: 'datas',
	    get: function get() {
	      return this._datas;
	    }
	
	    // -----------------------------------
	    // item
	    // -----------------------------------
	  }, {
	    key: 'item',
	    set: function set(value) {
	      this._item = value;
	    },
	    get: function get() {
	      return this._item;
	    }
	
	    // -----------------------------------
	    // startIndex
	    // -----------------------------------
	  }, {
	    key: 'startIndex',
	    set: function set(value) {
	      this._startIndex = value;
	    },
	    get: function get() {
	      return this._startIndex;
	    }
	
	    // -----------------------------------
	    // selectedIndex
	    // -----------------------------------
	  }, {
	    key: 'selectedIndex',
	    get: function get() {
	      return this._selectedIndex;
	    },
	    set: function set(index) {
	      if (!this.items || this.items.length === 0) {
	        this._selectedIndex = 0;
	        return;
	      }
	
	      this._selectedIndex = index;
	
	      if (this._selectedIndex < 0) {
	        this._selectedIndex = 0;
	      } else if (this._selectedIndex > this.items.length - 1) {
	        this._selectedIndex = this.items.length - 1;
	      }
	
	      if (this.startIndex > this._selectedIndex || this.startIndex + (this.itemsPerColumn - 1) < this._selectedIndex) {
	        this.startIndex = this._selectedIndex - this._selectedIndex % this.itemsPerColumn;
	      }
	
	      this.focusSelectedIndex();
	
	      if (this.changeHandler) {
	        this.changeHandler({
	          list: this
	        });
	      }
	    }
	
	    // -----------------------------------
	    // selectedItem
	    // -----------------------------------
	  }, {
	    key: 'selectedItem',
	    get: function get() {
	      return this.items[this._selectedIndex];
	    }
	
	    // -----------------------------------
	    // showPrev
	    // -----------------------------------
	  }, {
	    key: 'showPrev',
	    get: function get() {
	      return this.startIndex > 0;
	    }
	
	    // -----------------------------------
	    // showNext
	    // -----------------------------------
	  }, {
	    key: 'showNext',
	    get: function get() {
	      if (!this.items) {
	        return false;
	      }
	
	      return this.startIndex + this.itemsPerColumn < this.items.length;
	    }
	
	    // -----------------------------------
	    // curPage
	    // -----------------------------------
	  }, {
	    key: 'curPage',
	    get: function get() {
	      return Math.floor(this.selectedIndex / this.itemsPerColumn) + 1;
	    }
	
	    // -----------------------------------
	    // totalPages
	    // -----------------------------------
	  }, {
	    key: 'totalPages',
	    get: function get() {
	      if (this.items && this.items.length) {
	        return Math.ceil(this.items.length / this.itemsPerColumn);
	      }
	
	      return 0;
	    }
	  }]);
	
	  return News12List;
	})();
	
	News12List.$inject = ['$timeout'];
	
	exports['default'] = News12List;
	module.exports = exports['default'];

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(198);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/sass-loader/index.js!./news12List.scss", function() {
				var newContent = require("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/sass-loader/index.js!./news12List.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "news12-list{display:block}news12-list .down-arrow,news12-list .up-arrow{width:100%;padding:1vh;margin-left:20%}news12-list .down-arrow .up,news12-list .up-arrow .up{width:0;height:0;border-left:5vw solid transparent;border-right:5vw solid transparent;border-bottom:2vh solid #ffac25}news12-list .down-arrow .down,news12-list .up-arrow .down{width:0;height:0;border-left:5vw solid transparent;border-right:5vw solid transparent;border-top:2vh solid #ffac25}news12-list ul{font-size:3vmin;font-weight:400;list-style:none;margin:0;padding:0}news12-list ul li{padding:.5vh .5vh .75vh;font-size:3.5vmin}news12-list ul li:focus{outline:none;background-color:#353958}news12-list ul li:focus i{background:orange}news12-list label{display:block;cursor:pointer;user-select:none;-webkit-user-select:none;-webkit-touch-callout:none;margin-left:9%;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}news12-list label>i{display:inline-block;vertical-align:middle;width:1vw;height:1vw;border-radius:50%;border:.2vw solid #fff;background:#4d48aa;margin-bottom:.4%;margin-right:.75%}", ""]);
	
	// exports


/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _photoListComponent = __webpack_require__(200);
	
	var _photoListComponent2 = _interopRequireDefault(_photoListComponent);
	
	var photoListModule = _angular2['default'].module('photoList', [_angularUiRouter2['default'], 'constants', 'app.services']).component('photoList', _photoListComponent2['default']);
	
	exports['default'] = photoListModule;
	module.exports = exports['default'];

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _photoListHtml = __webpack_require__(201);
	
	var _photoListHtml2 = _interopRequireDefault(_photoListHtml);
	
	var _photoListController = __webpack_require__(202);
	
	var _photoListController2 = _interopRequireDefault(_photoListController);
	
	__webpack_require__(203);
	
	exports['default'] = {
	  restrict: 'E',
	  bindings: {
	    subRegion: '<'
	  },
	  template: _photoListHtml2['default'],
	  controller: _photoListController2['default'],
	  controllerAs: 'vm'
	};
	module.exports = exports['default'];

/***/ },
/* 201 */
/***/ function(module, exports) {

	module.exports = "<news12-list items=\"vm.items\"\n             label-field=\"label\"\n             items-per-column=\"6\"\n             items-per-scroll=\"1\"\n             item-click-handler=\"vm.onListItemClick\"\n             focus-on-populate-ix=\"vm.focusOnPopulateIx\"\n             change-handler=\"vm.onListChange\"\n             prev-component-handler=\"vm.onListPrevComponent\"></news12-list>\n<div class=\"footer\" ng-if=\"!vm.loading\">\n  Photo Gallery {{vm.selectedIndex}} of {{vm.total}}\n</div>\n"

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	/*---------------------------------------------------------*\
	 * Imports
	\*---------------------------------------------------------*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _pubsubJs = __webpack_require__(32);
	
	var _pubsubJs2 = _interopRequireDefault(_pubsubJs);
	
	var _lodash = __webpack_require__(35);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var deps = {};
	/*---------------------------------------------------------*\
	 * PhotoListController
	\*---------------------------------------------------------*/
	
	var PhotoListController = (function () {
	  //-----------------------------------
	  // Constructor
	  //-----------------------------------
	
	  function PhotoListController(photosService, photos, topics, $timeout, localService, storageKeys) {
	    var _this = this;
	
	    _classCallCheck(this, PhotoListController);
	
	    deps.photosService = photosService;
	    deps.photos = photos;
	    deps.localService = localService;
	    deps.$timeout = $timeout;
	    deps.topics = topics;
	    this.region = _lodash2['default'].isUndefined(this.subRegion) ? deps.localService.get(storageKeys.selectedRegion) : this.subRegion;
	    this.name = 'photoList';
	    this.total = 0;
	    //---------------------------------
	    // Get Photos
	    //---------------------------------
	    if (_lodash2['default'].isUndefined(deps.photos.images) || deps.photos.region !== this.region.abbr) {
	      this.loadRegions(this.region.abbr);
	    } else {
	      this.applyPhotos(deps.photos.images);
	    }
	
	    //---------------------------------
	    // List Event Handlers
	    //
	    // Note: placed here so we do not have to bind to this
	    //---------------------------------
	    this.onListPrevComponent = function (index, up) {
	      if (up) {
	        _pubsubJs2['default'].publish(topics.nav.up, 'photo-list');
	      } else {
	        _pubsubJs2['default'].publish(topics.nav.left, 'photo-list');
	      }
	    };
	
	    this.onListItemClick = function (event) {
	      var currentGallery = {
	        images: event.item.photos,
	        region: _this.region,
	        selIndex: 0,
	        showImages: true
	      };
	      // deps.photos.selIndex = 0;
	      // deps.photos.images = event.item.photos;
	      // deps.photos.region = this.region;
	      _pubsubJs2['default'].publish(topics.component.selectPhotos, currentGallery);
	    };
	
	    this.onListChange = function (event) {
	      _this.selectedIndex = event.list.selectedIndex + 1;
	      _this.total = event.list.items.length;
	    };
	  }
	
	  //-----------------------------------
	  // Methods
	  //-----------------------------------
	  /**
	   * This method takes the raw images JSON from the service and converts it into
	   * an array that makes sense for our list component on the page.
	   *
	   * @param items
	   */
	
	  _createClass(PhotoListController, [{
	    key: 'applyPhotos',
	    value: function applyPhotos(items) {
	      var _this2 = this;
	
	      deps.photos.images = items;
	      deps.photos.region = this.region;
	      var groups = _lodash2['default'].groupBy(items.SubregionType, function (subgroup) {
	        return subgroup.name;
	      });
	      var arr = [];
	
	      for (var key in groups) {
	        if (({}).hasOwnProperty.call(groups, key)) {
	          arr.push({
	            label: key,
	            photos: !_angular2['default'].isArray(groups[key][0].Cameras.Camera) ? [groups[key][0].Cameras.Camera] : groups[key][0].Cameras.Camera
	          });
	        }
	      }
	
	      this.focusOnPopulateIx = 0;
	
	      deps.$timeout(function () {
	        _this2.items = arr;
	        _this2.loading = false;
	      });
	    }
	  }, {
	    key: 'loadRegions',
	    value: function loadRegions(region) {
	      var _this3 = this;
	
	      this.loading = true;
	      this.items = [{
	        label: 'Loading...'
	      }];
	      deps.photosService.getPhotoList(region).then(function (data) {
	        _this3.applyPhotos(data.rss.channel.item['amg:passthru']);
	      });
	    }
	  }]);
	
	  return PhotoListController;
	})();
	
	PhotoListController.$inject = ['photosService', 'photos', 'topics', '$timeout', 'localService', 'storageKeys'];
	
	exports['default'] = PhotoListController;
	module.exports = exports['default'];

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(204);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/sass-loader/index.js!./photoList.scss", function() {
				var newContent = require("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/sass-loader/index.js!./photoList.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "photo-list{width:90%;height:88%;display:block;padding:2vh 12vh}photo-list .footer{position:absolute;bottom:3%;right:20%;font-size:3vmin}photo-list news12-list .up-arrow .up{border-left:1.44vw solid transparent;border-right:1.44vw solid transparent;border-bottom:2vh solid #ffac25}photo-list news12-list .down-arrow .down{border-left:1.44vw solid transparent;border-right:1.44vw solid transparent;border-top:2vh solid #ffac25}photo-list news12-list ul{font-size:4vmin}photo-list news12-list label{margin-left:0}", ""]);
	
	// exports


/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _incidentListComponent = __webpack_require__(206);
	
	var _incidentListComponent2 = _interopRequireDefault(_incidentListComponent);
	
	var incidentListmodule = _angular2['default'].module('incidentList', [_angularUiRouter2['default'], 'constants', 'app.services']).component('incidentList', _incidentListComponent2['default']);
	
	exports['default'] = incidentListmodule;
	module.exports = exports['default'];

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _incidentListHtml = __webpack_require__(207);
	
	var _incidentListHtml2 = _interopRequireDefault(_incidentListHtml);
	
	var _incidentListController = __webpack_require__(208);
	
	var _incidentListController2 = _interopRequireDefault(_incidentListController);
	
	__webpack_require__(209);
	
	exports['default'] = {
	  restrict: 'E',
	  bindings: {
	    enlarged: '=',
	    slideshowOn: '=',
	    subRegion: '<'
	  },
	  template: _incidentListHtml2['default'],
	  controller: _incidentListController2['default'],
	  controllerAs: 'vm'
	};
	module.exports = exports['default'];

/***/ },
/* 207 */
/***/ function(module, exports) {

	module.exports = "<news12-list ng-if=\"vm.showIncidentLabel == true\"\n             items=\"vm.items\"\n             label-field=\"label\"\n             items-per-column=\"6\"\n             items-per-scroll=\"1\"\n             item-click-handler=\"vm.onListItemClick\"\n             focus-on-populate-ix=\"vm.focusOnPopulateIx\"\n             change-handler=\"vm.onListChange\"\n             prev-component-handler=\"vm.onListPrevComponent\"></news12-list>\n<news12-list ng-if=\"vm.showNoIncidents == true\"\n             items=\"vm.items\"\n             label-field=\"label\"\n             items-per-column=\"6\"\n             items-per-scroll=\"1\"\n             focus-on-populate-ix=\"vm.focusOnPopulateIx\"\n             change-handler=\"vm.onListChange\"\n             prev-component-handler=\"vm.onListPrevComponent\"></news12-list>\n<p id=\"incident_description\" ng-show=\"vm.showIncidentDescription\"></p>\n<div class=\"back-button\" ng-show=\"vm.showIncidentDescription\">\n  <news12-button on-select=\"vm.goBack()\"\n                 class=\"focusable\"\n                 ng-keydown=\"vm.keydownHandler($event)\">Back</news12-button>\n</div>\n<div class=\"footer\" ng-if=\"!vm.loading\" ng-show=\"vm.showIncidentLabel\">\n  Delay {{vm.clicklistindex + 1}} of {{vm.total}}\n</div>\n"

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	/*---------------------------------------------------------*\
	 * Imports
	\*---------------------------------------------------------*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _pubsubJs = __webpack_require__(32);
	
	var _pubsubJs2 = _interopRequireDefault(_pubsubJs);
	
	var _lodash = __webpack_require__(35);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var deps = {};
	
	/*---------------------------------------------------------*\
	 * Weakmaps
	 \*---------------------------------------------------------*/
	var TIMEOUT = new WeakMap();
	var NAVIGATION = new WeakMap();
	
	/*---------------------------------------------------------*\
	 * IncidentList
	\*---------------------------------------------------------*/
	
	var IncidentListController = (function () {
	  //-----------------------------------
	  // Constructor
	  //-----------------------------------
	
	  function IncidentListController(trafficService, topics, $timeout, localService, storageKeys, navigationService) {
	    var _this = this;
	
	    _classCallCheck(this, IncidentListController);
	
	    TIMEOUT.set(this, $timeout);
	    deps.trafficService = trafficService;
	    deps.localService = localService;
	    deps.$timeout = $timeout;
	    deps.topics = topics;
	    var region = _lodash2['default'].isUndefined(this.subRegion) ? deps.localService.get(storageKeys.selectedRegion) : this.subRegion;
	    this.name = 'incidentList';
	    this.total = 0;
	    this.clicklistindex = 0;
	    NAVIGATION.set(this, navigationService);
	
	    this.showIncidentLabel = true;
	    this.showIncidentDescription = false;
	    this.showNoIncidents = false;
	    //---------------------------------
	    // Get Incidents
	    //---------------------------------
	    this.loading = true;
	    this.items = [{
	      label: 'Loading...'
	    }];
	    trafficService.getTrafficDelays(region.abbr).then(this.applyIncidents.bind(this));
	    //---------------------------------
	    // List Event Handlers
	    //
	    // Note: placed here so we do not have to bind to this
	    //---------------------------------
	    this.onListPrevComponent = function (index, up) {
	      if (up) {
	        _pubsubJs2['default'].publish(topics.nav.up, 'incident-list');
	      } else {
	        _pubsubJs2['default'].publish(topics.nav.left, 'incident-list');
	      }
	    };
	
	    this.onListItemClick = function () {
	      var el = document.getElementById('incident_description');
	      _this.showIncidentLabel = false;
	      _this.showIncidentDescription = true;
	      el.innerHTML = _this.items[_this.clicklistindex].description;
	      NAVIGATION.get(_this).focusElAsync('.main-content news12-button');
	    };
	
	    this.onListChange = function (event) {
	      _this.clicklistindex = event.list.selectedIndex;
	      _this.total = event.list.items.length;
	    };
	  }
	
	  //-----------------------------------
	  // Methods
	  //-----------------------------------
	  /**
	   * This method takes the raw images JSON from the service and converts it into
	   * an array that makes sense for our list component on the page.
	   *
	   * @param items
	   */
	
	  _createClass(IncidentListController, [{
	    key: 'applyIncidents',
	    value: function applyIncidents(item) {
	      var _this2 = this;
	
	      var incidentsArray = [];
	      var feed = item.data;
	      if (_lodash2['default'].isUndefined(feed.rss.channel.item)) {
	        this.items = [{
	          label: 'No Delays at this time'
	        }];
	        this.showNoIncidents = true;
	        this.showIncidentLabel = false;
	        TIMEOUT.get(this)(function () {
	          _this2.loading = false;
	          NAVIGATION.get(_this2).focusElAsync('.main-content');
	        });
	      } else {
	        if (!_lodash2['default'].isUndefined(feed.rss.channel.item.title)) {
	          incidentsArray.push({
	            label: feed.rss.channel.item.title,
	            description: feed.rss.channel.item.description
	          });
	        } else {
	          var groups = _lodash2['default'].groupBy(feed.rss.channel.item, function (subgroup) {
	            return subgroup.title;
	          });
	          for (var key in groups) {
	            if (({}).hasOwnProperty.call(groups, key)) {
	              incidentsArray.push({
	                label: key,
	                description: groups[key][0].description
	              });
	            }
	          }
	        }
	        TIMEOUT.get(this)(function () {
	          _this2.items = incidentsArray;
	          _this2.loading = false;
	          NAVIGATION.get(_this2).focusElAsync('.main-content');
	        });
	      }
	    }
	  }, {
	    key: 'goBack',
	    value: function goBack() {
	      this.showIncidentLabel = true;
	      this.showIncidentDescription = false;
	      NAVIGATION.get(this).focusElAsync('.main-content');
	    }
	  }]);
	
	  return IncidentListController;
	})();
	
	IncidentListController.$inject = ['trafficService', 'topics', '$timeout', 'localService', 'storageKeys', 'navigationService'];
	
	exports['default'] = IncidentListController;
	module.exports = exports['default'];

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(210);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/sass-loader/index.js!./incidentList.scss", function() {
				var newContent = require("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/sass-loader/index.js!./incidentList.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "incident-list div.footer{display:block;position:absolute;right:2%;bottom:0}incident-list #incident_description{padding:0 2%;font-size:2.7vmin}incident-list news12-list .up-arrow .up{border-left:1.44vw solid transparent;border-right:1.44vw solid transparent;border-bottom:2vh solid #ffac25}incident-list news12-list .down-arrow .down{border-left:1.44vw solid transparent;border-right:1.44vw solid transparent;border-top:2vh solid #ffac25}incident-list .back-button{display:block;position:absolute;bottom:2%;right:50%}incident-list .back-button button{margin:0 auto}", ""]);
	
	// exports


/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _archivesComponent = __webpack_require__(212);
	
	var _archivesComponent2 = _interopRequireDefault(_archivesComponent);
	
	var archivesModule = _angular2['default'].module('archives', [_angularUiRouter2['default'], 'constants']).component('archives', _archivesComponent2['default']);
	
	exports['default'] = archivesModule;
	module.exports = exports['default'];

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _archivesHtml = __webpack_require__(213);
	
	var _archivesHtml2 = _interopRequireDefault(_archivesHtml);
	
	var _archivesController = __webpack_require__(214);
	
	var _archivesController2 = _interopRequireDefault(_archivesController);
	
	__webpack_require__(215);
	
	exports['default'] = {
	  restrict: 'E',
	  bindings: {
	    archives: '<',
	    pageSize: '<',
	    focusItem: '<',
	    onSelect: '&'
	  },
	  template: _archivesHtml2['default'],
	  controller: _archivesController2['default'],
	  controllerAs: 'vm'
	};
	module.exports = exports['default'];

/***/ },
/* 213 */
/***/ function(module, exports) {

	module.exports = "<story-list stories=\"vm.archives\"\n            on-select=\"vm.selectArchive(story, focusItem)\"\n            page-size=\"vm.pageSize\"\n            focus-item=\"vm.focusItem\"\n>\n</story-list>\n"

/***/ },
/* 214 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var deps = {};
	
	/*---------------------------------------------------------*\
	 * ArchivesController
	\*---------------------------------------------------------*/
	
	var ArchivesController = (function () {
	  //-----------------------------------
	  // Constructor
	  //-----------------------------------
	
	  function ArchivesController($timeout, navigationService, archiveService, localService, storageKeys) {
	    var _this = this;
	
	    _classCallCheck(this, ArchivesController);
	
	    deps.$timeout = $timeout;
	    deps.navigationService = navigationService;
	    deps.archiveService = archiveService;
	    deps.localService = localService;
	    deps.storageKeys = storageKeys;
	    this.name = 'archives';
	
	    this.updateArchives().then(function () {
	      deps.$timeout(function () {
	        if (_this.currentStory) {
	          // restore focus when coming back to home page
	          deps.navigationService.focusElAsync('.main-content .story-list', _this.currentStory.focusItem % _this.storyPageSize);
	          delete _this.currentStory;
	        } else {
	          deps.navigationService.focusElAsync('.main-content');
	        }
	      });
	    });
	  }
	
	  //-----------------------------------
	  // Properties
	  //-----------------------------------
	
	  _createClass(ArchivesController, [{
	    key: 'selectArchive',
	
	    //-----------------------------------
	    // Methods
	    //-----------------------------------
	    value: function selectArchive(story, focusItem) {
	      this.onSelect({ story: story, focusItem: focusItem });
	    }
	  }, {
	    key: 'updateArchives',
	    value: function updateArchives() {
	      var _this2 = this;
	
	      return deps.archiveService.getArchives(this.region).then(function (data) {
	        deps.$timeout(function () {
	          _this2.archives = data;
	        });
	      });
	    }
	  }, {
	    key: 'region',
	    get: function get() {
	      var _region = deps.localService.get(deps.storageKeys.selectedRegion);
	      return _region ? _region.abbr : 'LI';
	    }
	  }]);
	
	  return ArchivesController;
	})();
	
	ArchivesController.$inject = ['$timeout', 'navigationService', 'archiveService', 'localService', 'storageKeys'];
	
	exports['default'] = ArchivesController;
	module.exports = exports['default'];

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(216);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/sass-loader/index.js!./archives.scss", function() {
				var newContent = require("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/sass-loader/index.js!./archives.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _news12AdComponent = __webpack_require__(218);
	
	var _news12AdComponent2 = _interopRequireDefault(_news12AdComponent);
	
	var _module = _angular2['default'].module('news12Ad', [_angularUiRouter2['default']]).component('news12Ad', _news12AdComponent2['default']);
	
	exports['default'] = _module;
	module.exports = exports['default'];

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _news12AdHtml = __webpack_require__(219);
	
	var _news12AdHtml2 = _interopRequireDefault(_news12AdHtml);
	
	var _news12AdController = __webpack_require__(220);
	
	var _news12AdController2 = _interopRequireDefault(_news12AdController);
	
	__webpack_require__(221);
	
	exports['default'] = {
	  restrict: 'E',
	  bindings: {
	    region: '<',
	    section: '<',
	    adLocation: '<',
	    onAdSelect: '&'
	  },
	  template: _news12AdHtml2['default'],
	  controller: _news12AdController2['default'],
	  controllerAs: 'vm'
	};
	module.exports = exports['default'];

/***/ },
/* 219 */
/***/ function(module, exports) {

	module.exports = "<div class=\"{{ vm.adLocation }}\" ng-if=\"vm.ad\">\n    <button class=\"focusable\" ng-keydown=\"vm.select($event, vm.adLocation)\">\n        <img ng-src=\"{{ vm.ad.imageUrl }}\"/>\n    </button>\n</div>\n"

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	/*---------------------------------------------------------*\
	 * Imports
	\*---------------------------------------------------------*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _pubsubJs = __webpack_require__(32);
	
	var _pubsubJs2 = _interopRequireDefault(_pubsubJs);
	
	var _keycodeUi = __webpack_require__(33);
	
	var _keycodeUi2 = _interopRequireDefault(_keycodeUi);
	
	var deps = {};
	/*---------------------------------------------------------*\
	 * News12Ad
	\*---------------------------------------------------------*/
	
	var News12AdController = (function () {
	  //-----------------------------------
	  // Constructor
	  //-----------------------------------
	
	  function News12AdController($scope, $timeout, $state, $stateParams, states, topics, adService) {
	    var _this = this;
	
	    _classCallCheck(this, News12AdController);
	
	    this.name = 'news12Ad';
	    deps.adService = adService;
	    deps.$timeout = $timeout;
	    deps.$state = $state;
	    deps.$stateParams = $stateParams;
	    deps.states = states;
	    deps.topics = topics;
	    deps.$scope = $scope;
	
	    this.init();
	    this.ad = {};
	
	    var token1 = _pubsubJs2['default'].subscribe(deps.topics.ads.refreshAd, function () {
	      // on menu select, re-intialize ads again
	      _this.init();
	    });
	
	    deps.$scope.$on('$destroy', function () {
	      _pubsubJs2['default'].unsubscribe(token1);
	    });
	  }
	
	  //-----------------------------------
	  // Properties
	  //-----------------------------------
	
	  //-----------------------------------
	  // Methods
	  //-----------------------------------
	
	  _createClass(News12AdController, [{
	    key: 'init',
	    value: function init() {
	      var _this2 = this;
	
	      deps.adService.getAd(this.section, this.adLocation, this.region.abbr).then(function (data) {
	        deps.$timeout(function () {
	          _this2.ad = data;
	        });
	      });
	    }
	  }, {
	    key: 'showAd',
	    value: function showAd() {
	      if (this.ad && this.ad.onclick && this.ad.onclick.vod) {
	        var ad = {
	          src: this.ad.onclick.vod
	        };
	        deps.$state.go(deps.states.videoplayer, { ad: ad }, { location: true });
	      }
	    }
	
	    //-----------------------------------
	    // Events
	    //-----------------------------------
	  }, {
	    key: 'select',
	    value: function select(e, item) {
	      if (_keycodeUi2['default'].isEnter(e)) {
	        this.showAd(this);
	      } else {
	        this.onAdSelect({
	          event: e,
	          location: item
	        });
	      }
	    }
	  }]);
	
	  return News12AdController;
	})();
	
	News12AdController.$inject = ['$scope', '$timeout', '$state', '$stateParams', 'states', 'topics', 'adService'];
	
	exports['default'] = News12AdController;
	module.exports = exports['default'];

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(222);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/sass-loader/index.js!./news12Ad.scss", function() {
				var newContent = require("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/sass-loader/index.js!./news12Ad.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "news12-ad button{padding:.3vh;background-color:transparent;border:0;height:inherit}news12-ad button.selected,news12-ad button:focus,news12-ad button:hover{outline:none;border:.3vh solid #ffac25;padding:0}news12-ad img{display:inline-block;vertical-align:middle;width:100%;height:100%;object-fit:cover;overflow:hidden}", ""]);
	
	// exports


/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _cameraListComponent = __webpack_require__(224);
	
	var _cameraListComponent2 = _interopRequireDefault(_cameraListComponent);
	
	var cameraListmodule = _angular2['default'].module('cameraList', [_angularUiRouter2['default'], 'constants', 'app.services']).component('cameraList', _cameraListComponent2['default']);
	
	exports['default'] = cameraListmodule;
	module.exports = exports['default'];

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _cameraListHtml = __webpack_require__(225);
	
	var _cameraListHtml2 = _interopRequireDefault(_cameraListHtml);
	
	var _cameraListController = __webpack_require__(226);
	
	var _cameraListController2 = _interopRequireDefault(_cameraListController);
	
	__webpack_require__(227);
	
	exports['default'] = {
	  restrict: 'E',
	  bindings: {
	    subRegion: '<'
	  },
	  template: _cameraListHtml2['default'],
	  controller: _cameraListController2['default'],
	  controllerAs: 'vm'
	};
	module.exports = exports['default'];

/***/ },
/* 225 */
/***/ function(module, exports) {

	module.exports = "<news12-list ng-if=\"vm.showCameras == true\"\n             items=\"vm.items\"\n             label-field=\"label\"\n             items-per-column=\"6\"\n             items-per-scroll=\"1\"\n             item-click-handler=\"vm.onListItemClick\"\n             focus-on-populate-ix=\"vm.focusOnPopulateIx\"\n             change-handler=\"vm.onListChange\"\n             prev-component-handler=\"vm.onListPrevComponent\"></news12-list>\n<news12-list ng-if=\"vm.showCamerasSub == true\"\n             id=\"showCamerasSub\"\n             items=\"vm.itemsSub\"\n             label-field=\"labelSub\"\n             items-per-column=\"6\"\n             items-per-scroll=\"1\"\n             item-click-handler=\"vm.onListItemClickSub\"\n             focus-on-populate-ix=\"vm.focusOnPopulateIx\"\n             change-handler=\"vm.onListChangeSub\"\n             prev-component-handler=\"vm.onListPrevComponent\"></news12-list>\n<div class=\"back-button\">\n</div>\n<div class=\"footer\" ng-if=\"!vm.loading\" ng-show=\"vm.showCameras\">\n  Camera Area {{vm.clicklistindex + 1}} of {{vm.total}}\n</div>\n<div class=\"footer\" ng-if=\"!vm.loading\" ng-show=\"vm.showCamerasSub\">\n  Camera {{vm.clicklistindexSub + 1}} of {{vm.totalSub}}\n</div>\n"

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	/*---------------------------------------------------------*\
	 * Imports
	 \*---------------------------------------------------------*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _pubsubJs = __webpack_require__(32);
	
	var _pubsubJs2 = _interopRequireDefault(_pubsubJs);
	
	var _lodash = __webpack_require__(35);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var deps = {};
	
	/*---------------------------------------------------------*\
	 * Weakmaps
	 \*---------------------------------------------------------*/
	var TIMEOUT = new WeakMap();
	var NAVIGATION = new WeakMap();
	
	/*---------------------------------------------------------*\
	 * CameraList
	\*---------------------------------------------------------*/
	
	var CameraListController = (function () {
	  //-----------------------------------
	  // Constructor
	  //-----------------------------------
	
	  function CameraListController(trafficService, topics, $timeout, localService, storageKeys, navigationService) {
	    var _this = this;
	
	    _classCallCheck(this, CameraListController);
	
	    TIMEOUT.set(this, $timeout);
	    deps.trafficService = trafficService;
	    deps.localService = localService;
	    deps.$timeout = $timeout;
	    deps.topics = topics;
	    var region = _lodash2['default'].isUndefined(this.subRegion) ? deps.localService.get(storageKeys.selectedRegion) : this.subRegion;
	    this.name = 'cameraList';
	    this.total = 0;
	    this.totalSub = 0;
	    this.clicklistindex = 0;
	    this.clicklistindexSub = 0;
	    NAVIGATION.set(this, navigationService);
	    this.showCameras = true;
	    this.showCamerasSub = false;
	    this.showCamerasPhotos = false;
	    this.camerasArray = [];
	    this.camerasArraySub = [];
	
	    //---------------------------------
	    // Get Cameras
	    //---------------------------------
	    this.loading = true;
	    this.items = [{
	      label: 'Loading...'
	    }];
	    this.itemsSub = [{
	      label: 'Loading...'
	    }];
	    trafficService.getTrafficCameras(region.abbr).then(this.applyCameras.bind(this));
	
	    //---------------------------------
	    // List Event Handlers
	    //
	    // Note: placed here so we do not have to bind to this
	    //---------------------------------
	    this.onListPrevComponent = function (index, up) {
	      if (up) {
	        _pubsubJs2['default'].publish(topics.nav.up, 'camera-list');
	      } else {
	        _pubsubJs2['default'].publish(topics.nav.left, 'camera-list');
	      }
	    };
	
	    this.onListItemClick = function () {
	      _this.itemsSub = _this.camerasArray[_this.clicklistindex].cameras;
	      _this.applyCamerasSub(_this.itemsSub);
	      _this.showCameras = false;
	      _this.showCamerasSub = true;
	      _this.showCamerasPhotos = false;
	    };
	
	    this.onListItemClickSub = function () {
	      _this.showCameras = false;
	      _this.showCamerasSub = false;
	      _this.showCamerasPhotos = true;
	      _this.cameras = _this.camerasArraySub;
	      _this.cameras.index = _this.clicklistindexSub;
	      _this.cameras.showCamerasPhotos = true;
	      _pubsubJs2['default'].publish(topics.component.selectPhotos, _this.cameras);
	    };
	
	    this.onListChange = function (event) {
	      _this.clicklistindex = event.list.selectedIndex;
	      _this.total = event.list.items.length;
	    };
	
	    this.onListChangeSub = function (event) {
	      _this.clicklistindexSub = event.list.selectedIndex;
	      _this.totalSub = event.list.items.length;
	    };
	  }
	
	  //-----------------------------------
	  // Methods
	  //-----------------------------------
	  /**
	   * This method takes the raw images JSON from the service and converts it into
	   * an array that makes sense for our list component on the page.
	   *
	   * @param items
	   */
	
	  _createClass(CameraListController, [{
	    key: 'applyCameras',
	    value: function applyCameras(item) {
	      var _this2 = this;
	
	      var feed = item.data.Region.Subregions;
	
	      var groups = _lodash2['default'].groupBy(feed.Subregion, function (subgroup) {
	        return subgroup.SubregionType.name;
	      });
	
	      for (var key in groups) {
	        if (({}).hasOwnProperty.call(groups, key)) {
	          this.camerasArray.push({
	            label: key,
	            cameras: !_angular2['default'].isArray(groups[key][0].SubregionType.Cameras.Camera) ? [groups[key][0].SubregionType.Cameras.Camera] : groups[key][0].SubregionType.Cameras.Camera
	          });
	        }
	      }
	      deps.$timeout(function () {
	        _this2.items = _this2.camerasArray;
	        _this2.loading = false;
	        NAVIGATION.get(_this2).focusElAsync('.main-content');
	      });
	    }
	  }, {
	    key: 'applyCamerasSub',
	    value: function applyCamerasSub(item) {
	      var _this3 = this;
	
	      var feed = item;
	      var groups = _lodash2['default'].groupBy(feed, function (subgroup) {
	        return subgroup.CameraName;
	      });
	
	      for (var key in groups) {
	        if (({}).hasOwnProperty.call(groups, key)) {
	          this.camerasArraySub.push({
	            labelSub: key,
	            CameraURL: groups[key][0].CameraURL,
	            logo: groups[key][0].logo
	          });
	        }
	      }
	      deps.$timeout(function () {
	        _this3.itemsSub = _this3.camerasArraySub;
	        _this3.loading = false;
	        NAVIGATION.get(_this3).focusElAsync('.main-content #showCamerasSub');
	      });
	    }
	  }, {
	    key: 'goBack',
	    value: function goBack() {
	      NAVIGATION.get(this).focusElAsync('.main-content');
	    }
	  }]);
	
	  return CameraListController;
	})();
	
	CameraListController.$inject = ['trafficService', 'topics', '$timeout', 'localService', 'storageKeys', 'navigationService'];
	
	exports['default'] = CameraListController;
	module.exports = exports['default'];

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(228);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/sass-loader/index.js!./cameraList.scss", function() {
				var newContent = require("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/sass-loader/index.js!./cameraList.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "camera-list div.footer{display:block;position:absolute;right:2%;bottom:0}camera-list news12-list .up-arrow .up{border-left:1.44vw solid transparent;border-right:1.44vw solid transparent;border-bottom:2vh solid #ffac25}camera-list news12-list .down-arrow .down{border-left:1.44vw solid transparent;border-right:1.44vw solid transparent;border-top:2vh solid #ffac25}", ""]);
	
	// exports


/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _cameraGalleryComponent = __webpack_require__(230);
	
	var _cameraGalleryComponent2 = _interopRequireDefault(_cameraGalleryComponent);
	
	var _module = _angular2['default'].module('cameraGallery', [_angularUiRouter2['default']]).component('cameraGallery', _cameraGalleryComponent2['default']);
	
	exports['default'] = _module;
	module.exports = exports['default'];

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _cameraGalleryHtml = __webpack_require__(231);
	
	var _cameraGalleryHtml2 = _interopRequireDefault(_cameraGalleryHtml);
	
	var _cameraGalleryController = __webpack_require__(232);
	
	var _cameraGalleryController2 = _interopRequireDefault(_cameraGalleryController);
	
	__webpack_require__(233);
	
	exports['default'] = {
	  restrict: 'E',
	  bindings: {
	    modal: '=',
	    slideshowOn: '=',
	    cameras: '<'
	  },
	  template: _cameraGalleryHtml2['default'],
	  controller: _cameraGalleryController2['default'],
	  controllerAs: 'vm'
	};
	module.exports = exports['default'];

/***/ },
/* 231 */
/***/ function(module, exports) {

	module.exports = "<div class=\"camera-gallery\" ng-class=\"vm.modal ? 'enlarged-view' : 'small-view'\">\n  <div class=\"image-wrapper\">\n    <div class=\"image-description\">\n      <h6>{{vm.cameras[vm.cameras.selIndex].labelSub}}</h6>\n    </div>\n    <div class=\"nav-arrow-left\">\n      <i class=\"fa fa-angle-left\"\n         aria-hidden=\"true\"\n         ng-show=\"!!vm.cameras.selIndex\"></i>\n    </div>\n    <div class=\"water-mark\" ng-style=\"{'background-image': 'url(' + vm.cameras[vm.cameras.selIndex].logo + ')' }\"></div>\n    <div class=\"image\" id=\"imgrefresh\" ng-style=\"{'background-image': 'url(' + vm.cameras[vm.cameras.selIndex].CameraURL + ')' }\">\n      <div class=\"loading\" ng-if=\"vm.loading\">Loading...</div>\n      <div class=\"loading\" ng-if=\"vm.error\">Image file is missing.</div>\n    </div>\n    <div class=\"nav-arrow-right\">\n      <i class=\"fa fa-angle-right\" aria-hidden=\"true\" ng-show=\"vm.cameras.selIndex &lt; vm.cameras.length - 1\"></i>\n    </div>\n  </div>\n  <div class=\"gallery-pagination\">\n    <h6>{{vm.cameras.selIndex + 1}} / {{vm.cameras.length}}</h6>\n  </div>\n  <div class=\"back-button\" ng-if=\"!vm.modal\">\n    <news12-button on-keyup=\"vm.enlargeKeyUp(event)\" ng-class=\"{'focusable-first' : vm.modal}\" on-keydown=\"vm.keydownHandler(event)\">Back</news12-button>\n  </div>\n</div>\n"

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	/*---------------------------------------------------------*\
	 * Imports
	\*---------------------------------------------------------*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _keycodeUi = __webpack_require__(33);
	
	var _keycodeUi2 = _interopRequireDefault(_keycodeUi);
	
	var _pubsubJs = __webpack_require__(32);
	
	var _pubsubJs2 = _interopRequireDefault(_pubsubJs);
	
	/*---------------------------------------------------------*\
	 * Constants
	\*---------------------------------------------------------*/
	var deps = {};
	
	/*---------------------------------------------------------*\
	 * CameraGallery
	\*---------------------------------------------------------*/
	
	var CameraGalleryController = (function () {
	  //-----------------------------------
	  // Constructor
	  //-----------------------------------
	
	  function CameraGalleryController($scope, $state, $element, $interval, navigationService, topics, states) {
	    var _this = this;
	
	    _classCallCheck(this, CameraGalleryController);
	
	    this.name = 'cameraGallery';
	
	    deps.$scope = $scope;
	    deps.$state = $state;
	    deps.$element = $element;
	    deps.$interval = $interval;
	    deps.navigationService = navigationService;
	    deps.topics = topics;
	    deps.states = states;
	    deps.$scope.$on('$destroy', function () {
	      deps.$interval.cancel(_this.promise);
	    });
	  }
	
	  //-----------------------------------
	  // Lifecycle
	  //-----------------------------------
	
	  _createClass(CameraGalleryController, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.selectImage(this.cameras.index);
	      var currentClass = this.enlarged ? 'back-button' : 'enlarge-button';
	      deps.navigationService.focusElAsync('.' + currentClass);
	    }
	
	    //-----------------------------------
	    // Methods
	    //-----------------------------------
	
	  }, {
	    key: 'selectImage',
	    value: function selectImage(index) {
	      var _this2 = this;
	
	      if (index < 0 || index >= this.cameras.length) {
	        return;
	      }
	
	      // Create temporary image attribute so we can load the image and display
	      // loading while it is coming in.
	      var img = document.createElement('img');
	
	      this.cameras.selIndex = index;
	      this.loading = true;
	      this.error = false;
	
	      img.addEventListener('load', function () {
	        _this2.loading = false;
	        deps.$scope.$apply();
	      });
	
	      img.addEventListener('error', function () {
	        _this2.error = true;
	        _this2.loading = false;
	        deps.$scope.$apply();
	      });
	      this.promise = deps.$interval(function () {
	        _this2.refreshImage(_this2.cameras.selIndex);
	      }, 10000);
	      img.src = this.cameras[this.cameras.selIndex].CameraURL;
	      deps.navigationService.focusElAsync('.main-content');
	    }
	  }, {
	    key: 'enlargeGallery',
	    value: function enlargeGallery() {
	      this.modal = false;
	      this.cameras.showCamerasPhotos = false;
	      this.cameras.showCameras = true;
	      _pubsubJs2['default'].publish(deps.topics.component.selectPhotos, this.cameras);
	      // this.modal = true;
	      // deps.navigationService.focusElAsync('.back-button');
	    }
	  }, {
	    key: 'goBack',
	    value: function goBack() {
	      this.modal = false;
	      deps.navigationService.focusElAsync('navbar');
	    }
	  }, {
	    key: 'refreshImage',
	    value: function refreshImage(index) {
	      this.updatetime = new Date().getTime();
	      var imgrefresh = 'background-image: url(' + this.cameras[index].CameraURL + '&' + this.updatetime + ')';
	      document.getElementById('imgrefresh').setAttribute('style', imgrefresh);
	    }
	
	    //-----------------------------------
	    // Events
	    //-----------------------------------
	  }, {
	    key: 'keydownHandler',
	    value: function keydownHandler(e) {
	      if (_keycodeUi2['default'].isLeft(e)) {
	        e.preventDefault();
	
	        var newIndex = this.cameras.selIndex - 1;
	        if (newIndex > -1) {
	          deps.$interval.cancel(this.promise);
	          this.selectImage(newIndex);
	          // change ads
	          this.changeAds();
	        } else {
	          _pubsubJs2['default'].publish(deps.topics.nav.left, 'camera-gallery');
	        }
	      } else if (_keycodeUi2['default'].isRight(e)) {
	        e.preventDefault();
	        var newIndex = this.cameras.selIndex + 1;
	        if (newIndex === this.cameras.length) {
	          this.selectImage(this.cameras.selIndex + 1);
	        } else {
	          deps.$interval.cancel(this.promise);
	          this.selectImage(this.cameras.selIndex + 1);
	
	          // change ads
	          this.changeAds();
	        }
	      } else if (_keycodeUi2['default'].isUp(e)) {
	        e.preventDefault();
	        _pubsubJs2['default'].publish(deps.topics.nav.up, 'camera-gallery');
	      } else if (_keycodeUi2['default'].isEnter(e)) {
	        this.enlargeGallery();
	      }
	    }
	  }, {
	    key: 'keyUp',
	    value: function keyUp(e) {
	      e.preventDefault();
	      e.stopImmediatePropagation();
	      if (_keycodeUi2['default'].isBack(e)) {
	        this.goBack();
	      }
	    }
	  }, {
	    key: 'changeAds',
	    value: function changeAds() {
	      // change ads only when in small view
	      if (!this.enlarged) {
	        _pubsubJs2['default'].publish(deps.topics.ads.refreshAd);
	      }
	    }
	  }]);
	
	  return CameraGalleryController;
	})();
	
	CameraGalleryController.$inject = ['$scope', '$state', '$element', '$interval', 'navigationService', 'topics', 'states'];
	
	exports['default'] = CameraGalleryController;
	module.exports = exports['default'];

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(234);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/sass-loader/index.js!./cameraGallery.scss", function() {
				var newContent = require("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/sass-loader/index.js!./cameraGallery.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "h1{font-family:Roboto,Helvetica,Arial,sans-serif;font-size:4.3vmin;font-weight:500;line-height:9vmin}h1,h2{margin:0}h2{font-family:Roboto Condensed,Arial Narrow,Helvetica,Arial,sans-serif;font-size:3.5vmin;font-weight:400}camera-gallery{display:block;width:100%;height:100%}camera-gallery .camera-gallery{width:90%;padding:0 5%;height:99%}camera-gallery .camera-gallery .image-wrapper{height:100%}camera-gallery .camera-gallery .image-wrapper .image,camera-gallery .camera-gallery .image-wrapper .nav-arrow-left,camera-gallery .camera-gallery .image-wrapper .nav-arrow-right{display:inline-block;float:left;position:relative}camera-gallery .camera-gallery .image-wrapper .image{height:100%;width:70%;max-width:100%;background-size:contain!important;background-position:50%!important;background-repeat:no-repeat!important}camera-gallery .camera-gallery .image-wrapper .image .error,camera-gallery .camera-gallery .image-wrapper .image .loading{position:absolute;width:100%;height:100%;left:0;top:0;background-color:#000;text-align:center;font-size:5.5vmin}camera-gallery .camera-gallery .image-wrapper .water-mark{position:absolute;width:50%;height:50%;background-repeat:no-repeat;left:30%;bottom:34%;z-index:100}camera-gallery .camera-gallery .image-wrapper .nav-arrow-left,camera-gallery .camera-gallery .image-wrapper .nav-arrow-right{width:10%;height:100%}camera-gallery .camera-gallery .image-wrapper .nav-arrow-left i,camera-gallery .camera-gallery .image-wrapper .nav-arrow-right i{text-align:right;line-height:209%;font-size:20vmin;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}camera-gallery .camera-gallery .image-wrapper .nav-arrow-right{padding-left:5%;text-align:left}camera-gallery .camera-gallery .image-wrapper .nav-arrow-left{padding-right:5%;text-align:right}camera-gallery .small-view{position:relative;height:85%}camera-gallery .small-view .image-description{width:100%;margin-top:1%}camera-gallery .small-view .image-description h6{margin:0;font-size:1.2rem;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}camera-gallery .small-view .back-button{position:absolute;bottom:5%;right:0;width:15%}camera-gallery .small-view .back-button news12-button button{width:6vw}camera-gallery .small-view .back-button news12-button button>div{padding:.5vh 1.5vw}camera-gallery .small-view .gallery-pagination{position:absolute;top:5%;right:0;width:15%}camera-gallery .small-view .gallery-pagination h6{margin:0;font-size:2vmin}camera-gallery .enlarged-view{height:100%;width:75%;padding:0 12.5%;position:relative}camera-gallery .enlarged-view .image-wrapper{width:100%;position:relative;height:70%;top:15.75%}camera-gallery .enlarged-view .nav-arrow-left,camera-gallery .enlarged-view .nav-arrow-right{margin-top:12.5%;height:50%}camera-gallery .enlarged-view .image-description{position:absolute;width:60%;top:8.5%;left:20%}camera-gallery .enlarged-view .image-description h6{margin:2% 0;font-size:2.7vmin;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}camera-gallery .enlarged-view .gallery-pagination{position:absolute;top:10%;right:10%;width:10%;text-align:center}camera-gallery .enlarged-view .gallery-pagination h6{line-height:5vh;margin:0;font-size:2.7vmin}", ""]);
	
	// exports


/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _mapGalleryComponent = __webpack_require__(236);
	
	var _mapGalleryComponent2 = _interopRequireDefault(_mapGalleryComponent);
	
	var mapGalleryModule = _angular2['default'].module('mapGallery', [_angularUiRouter2['default'], 'constants', 'app.services']).component('mapGallery', _mapGalleryComponent2['default']);
	
	exports['default'] = mapGalleryModule;
	module.exports = exports['default'];

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _mapGalleryHtml = __webpack_require__(237);
	
	var _mapGalleryHtml2 = _interopRequireDefault(_mapGalleryHtml);
	
	var _mapGalleryController = __webpack_require__(238);
	
	var _mapGalleryController2 = _interopRequireDefault(_mapGalleryController);
	
	__webpack_require__(239);
	
	exports['default'] = {
	  restrict: 'E',
	  bindings: {
	    pausemapOn: '=',
	    maps: '<'
	  },
	  template: _mapGalleryHtml2['default'],
	  controller: _mapGalleryController2['default'],
	  controllerAs: 'vm'
	};
	module.exports = exports['default'];

/***/ },
/* 237 */
/***/ function(module, exports) {

	module.exports = "<div class=\"map-gallery\">\n  <div class=\"image-wrapper\">\n    <div class=\"image\" style=\"background: url('{{vm.photos.images[vm.photos.selIndex].photoURLHQ}}');\">\n      <div class=\"content\">\n        <img src={{vm.mapimage}}>\n      </div>\n      <div class=\"loading\" ng-if=\"vm.loading\">Loading...</div>\n      <div class=\"loading\" ng-if=\"vm.error\">Image file is missing.</div>\n    </div>\n  </div>\n</div>\n"

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	/*---------------------------------------------------------*\
	 * Imports
	 \*---------------------------------------------------------*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _pubsubJs = __webpack_require__(32);
	
	var _pubsubJs2 = _interopRequireDefault(_pubsubJs);
	
	var _lodash = __webpack_require__(35);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	/*---------------------------------------------------------*\
	 * Constants
	 \*---------------------------------------------------------*/
	var TOPICS = new WeakMap();
	var TIMEOUT = new WeakMap();
	
	/*---------------------------------------------------------*\
	 * MapGalleryController
	 \*---------------------------------------------------------*/
	
	var MapGalleryController = (function () {
	  //-----------------------------------
	  // Constructor
	  //-----------------------------------
	
	  function MapGalleryController($scope, $interval, topics, $timeout) {
	    var _this = this;
	
	    _classCallCheck(this, MapGalleryController);
	
	    TOPICS.set(this, topics);
	    TIMEOUT.set(this, $timeout);
	
	    this.name = 'mapGallery';
	    this.$interval = $interval;
	    this.$scope = $scope;
	    this.url = 'http://images.itv.traffic.news12.com/';
	
	    var promise = undefined;
	    var start = function start(array, currentIndex) {
	      if (promise) {
	        _this.$interval.cancel(promise);
	      }
	      var nextIndex = currentIndex + 1;
	      promise = _this.$interval(function () {
	        _this.selectImage(nextIndex);
	        nextIndex++;
	      }, 6000);
	    };
	
	    this.$onInit = function () {
	      TIMEOUT.get(_this)(function () {
	        _this.selectImage(0);
	        start(_this.maps, 0);
	      }, 100);
	    };
	
	    _pubsubJs2['default'].subscribe(TOPICS.get(this).component.slideshowToggle, function (msg, data) {
	      if (!data.pausemapOn) {
	        _this.resetSlideshow();
	      } else if (data.pausemapOn) {
	        _this.$interval.cancel(promise);
	      }
	      _this.pausemapOn = data.pausemapOn;
	    });
	
	    this.resetSlideshow = function () {
	      _this.$interval.cancel(promise);
	      start(_this.maps, _this.selIndex);
	    };
	
	    this.$scope.$on('$destroy', function () {
	      _this.$interval.cancel(promise);
	    });
	  }
	
	  //-----------------------------------
	  // Lifecycle
	  //-----------------------------------
	
	  _createClass(MapGalleryController, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.selectImage(0);
	    }
	
	    //-----------------------------------
	    // Methods
	    //-----------------------------------
	
	  }, {
	    key: 'selectImage',
	    value: function selectImage(index) {
	      var _this2 = this;
	
	      if (index < 0) {
	        return;
	      }
	
	      // Create temporary image attribute so we can load the image and display
	      // loading while it is coming in.
	      var img = document.createElement('img');
	
	      this.selIndex = index;
	
	      this.loading = true;
	      this.error = false;
	
	      img.addEventListener('load', function () {
	        _this2.loading = false;
	        _this2.$scope.$apply();
	      });
	
	      img.addEventListener('error', function () {
	        _this2.error = true;
	        _this2.loading = false;
	        _this2.$scope.$apply();
	      });
	
	      if (!_lodash2['default'].isUndefined(this.maps)) {
	        img.src = this.url + this.maps[this.selIndex % this.maps.length].csign + '.jpg';
	      }
	      this.mapimage = img.src;
	    }
	  }, {
	    key: 'resetSlideshow',
	    value: function resetSlideshow() {
	      this.$interval.cancel(this.promise);
	      this.start(this.maps, this.selIndex);
	    }
	  }]);
	
	  return MapGalleryController;
	})();
	
	MapGalleryController.$inject = ['$scope', '$interval', 'topics', '$timeout'];
	
	exports['default'] = MapGalleryController;
	module.exports = exports['default'];

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(240);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/sass-loader/index.js!./mapGallery.scss", function() {
				var newContent = require("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/sass-loader/index.js!./mapGallery.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "h1{font-family:Roboto,Helvetica,Arial,sans-serif;font-size:4.3vmin;font-weight:500;line-height:9vmin}h1,h2{margin:0}h2{font-family:Roboto Condensed,Arial Narrow,Helvetica,Arial,sans-serif;font-size:3.5vmin;font-weight:400}map-gallery{display:block;width:100%;height:100%}map-gallery .map-gallery{width:90%;padding:0 5%;height:99%}map-gallery .map-gallery .image-wrapper{height:100%}map-gallery .map-gallery .image-wrapper .image{display:inline-block;float:left;position:relative;height:100%;width:70%;max-width:100%;background-size:contain!important;background-position:50%!important;background-repeat:no-repeat!important}map-gallery .map-gallery .image-wrapper .image .content{position:absolute;width:100%;height:100%}map-gallery .map-gallery .image-wrapper .image .error,map-gallery .map-gallery .image-wrapper .image .loading{position:absolute;width:100%;height:100%;left:0;top:0;background-color:#000;text-align:center;font-size:5.5vmin}", ""]);
	
	// exports


/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _prerollComponent = __webpack_require__(242);
	
	var _prerollComponent2 = _interopRequireDefault(_prerollComponent);
	
	var _module = _angular2['default'].module('vgPreroll', []).component('vgPreroll', _prerollComponent2['default']);
	
	exports['default'] = _module;
	module.exports = exports['default'];

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _prerollHtml = __webpack_require__(243);
	
	var _prerollHtml2 = _interopRequireDefault(_prerollHtml);
	
	var _prerollController = __webpack_require__(244);
	
	var _prerollController2 = _interopRequireDefault(_prerollController);
	
	__webpack_require__(245);
	
	exports['default'] = {
	  require: {
	    API: '^videogular'
	  },
	  restrict: 'E',
	  bindings: {
	    lockControls: '=',
	    region: '<',
	    category: '<',
	    onComplete: '&',
	    onSkipped: '&'
	  },
	  template: _prerollHtml2['default'],
	  controller: _prerollController2['default'],
	  controllerAs: 'vm'
	};
	module.exports = exports['default'];

/***/ },
/* 243 */
/***/ function(module, exports) {

	module.exports = "<video>\n    <source type=\"video/mp4\" />\n</video>\n"

/***/ },
/* 244 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var deps = {};
	
	var PrerollController = (function () {
	  function PrerollController($element, $scope, adService, VG_STATES) {
	    var _this = this;
	
	    _classCallCheck(this, PrerollController);
	
	    deps.$element = $element;
	    deps.$scope = $scope;
	    deps.adService = adService;
	    deps.VG_STATES = VG_STATES;
	
	    this.name = 'vgPreroll';
	    this.lockControls = false;
	    this.adLoading = false;
	    this.adLoaded = false;
	
	    $scope.$watch(function () {
	      return _this.API.isReady;
	    }, function (newVal, oldVal) {
	      if (_this.API.isReady || newVal !== oldVal) {
	        _this.onPlayerReady(newVal);
	      }
	    });
	
	    $scope.$watch(function () {
	      return _this.API.currentState;
	    }, function (newVal, oldVal) {
	      if (newVal !== oldVal) {
	        _this.onUpdateState(newVal);
	      }
	    });
	  }
	
	  _createClass(PrerollController, [{
	    key: 'initializeContainer',
	    value: function initializeContainer() {
	      this.videoElement = deps.$element.find('video');
	      this.sourceElement = deps.$element.find('source');
	      this.videoElement[0].addEventListener('ended', this.onAdEnded.bind(this));
	      this.videoElement[0].addEventListener('error', this.onAdSkipped.bind(this));
	    }
	  }, {
	    key: 'onPlayerReady',
	    value: function onPlayerReady(isReady) {
	      if (isReady) {
	        this.initializeContainer();
	      }
	    }
	  }, {
	    key: 'onAdEnded',
	    value: function onAdEnded() {
	      deps.$element.addClass('ng-hide');
	      this.lockControls = false;
	      this.adLoaded = true;
	      this.onComplete();
	      this.API.play();
	    }
	  }, {
	    key: 'onAdSkipped',
	    value: function onAdSkipped() {
	      deps.$element.addClass('ng-hide');
	      this.lockControls = false;
	      this.adLoaded = true;
	      this.onSkipped();
	      this.API.play();
	    }
	  }, {
	    key: 'onUpdateState',
	    value: function onUpdateState(newState) {
	      if (newState === deps.VG_STATES.PLAY && !this.adLoaded) {
	        this.lockControls = true;
	        this.API.pause();
	        if (!this.adLoading) {
	          this.requestAd(this.region, this.category);
	          this.adLoading = true;
	        }
	      }
	    }
	  }, {
	    key: 'requestAd',
	    value: function requestAd(region, section) {
	      var _this2 = this;
	
	      return deps.adService.getAd('preroll', section, region).then(function (data) {
	        _this2.adData = data;
	        if (data.vod) {
	          _this2.loadVideo(data.vod);
	        } else {
	          // in case the response has no ad src url
	          _this2.onAdSkipped();
	        }
	      }, function () {
	        console.error('[Preroll] Could not load ad. Resuming video.');
	        _this2.onAdSkipped();
	      });
	    }
	  }, {
	    key: 'loadVideo',
	    value: function loadVideo(src) {
	      var d = new Date();
	      var video = this.videoElement[0];
	      var source = this.sourceElement[0];
	      source.src = src + '?' + d.getTime();
	      video.load();
	      video.play();
	    }
	  }]);
	
	  return PrerollController;
	})();
	
	PrerollController.$inject = ['$element', '$scope', 'adService', 'VG_STATES'];
	
	exports['default'] = PrerollController;
	module.exports = exports['default'];

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(246);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/sass-loader/index.js!./preroll.scss", function() {
				var newContent = require("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/sass-loader/index.js!./preroll.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "vg-preroll{position:absolute;top:0;background:#000}vg-preroll,vg-preroll video{width:100%;height:100%}", ""]);
	
	// exports


/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _navigationNavigation = __webpack_require__(248);
	
	var _navigationNavigation2 = _interopRequireDefault(_navigationNavigation);
	
	var _apisApi = __webpack_require__(249);
	
	var _apisApi2 = _interopRequireDefault(_apisApi);
	
	var _apisRegions = __webpack_require__(252);
	
	var _apisRegions2 = _interopRequireDefault(_apisRegions);
	
	var _apisLivefeed = __webpack_require__(253);
	
	var _apisLivefeed2 = _interopRequireDefault(_apisLivefeed);
	
	var _apisCategories = __webpack_require__(254);
	
	var _apisCategories2 = _interopRequireDefault(_apisCategories);
	
	var _apisWeather = __webpack_require__(255);
	
	var _apisWeather2 = _interopRequireDefault(_apisWeather);
	
	var _apisPhotos = __webpack_require__(256);
	
	var _apisPhotos2 = _interopRequireDefault(_apisPhotos);
	
	var _apisAds = __webpack_require__(257);
	
	var _apisAds2 = _interopRequireDefault(_apisAds);
	
	var _apisTickerService = __webpack_require__(258);
	
	var _apisTickerService2 = _interopRequireDefault(_apisTickerService);
	
	var _apisWeatherVideoService = __webpack_require__(259);
	
	var _apisWeatherVideoService2 = _interopRequireDefault(_apisWeatherVideoService);
	
	var _apisClosingsAndDelays = __webpack_require__(260);
	
	var _apisClosingsAndDelays2 = _interopRequireDefault(_apisClosingsAndDelays);
	
	var _apisProfile = __webpack_require__(261);
	
	var _apisProfile2 = _interopRequireDefault(_apisProfile);
	
	var _apisNews = __webpack_require__(262);
	
	var _apisNews2 = _interopRequireDefault(_apisNews);
	
	var _apisArchives = __webpack_require__(263);
	
	var _apisArchives2 = _interopRequireDefault(_apisArchives);
	
	var _apisPolls = __webpack_require__(264);
	
	var _apisPolls2 = _interopRequireDefault(_apisPolls);
	
	__webpack_require__(265);
	
	var _localServiceLocalService = __webpack_require__(266);
	
	var _localServiceLocalService2 = _interopRequireDefault(_localServiceLocalService);
	
	var _apisWeatherCurrent = __webpack_require__(267);
	
	var _apisWeatherCurrent2 = _interopRequireDefault(_apisWeatherCurrent);
	
	var _apisTrafficService = __webpack_require__(268);
	
	var _apisTrafficService2 = _interopRequireDefault(_apisTrafficService);
	
	// Auth module
	
	__webpack_require__(269);
	
	__webpack_require__(270);
	
	var _authAuth = __webpack_require__(271);
	
	var _authAuth2 = _interopRequireDefault(_authAuth);
	
	var serviceModule = _angular2['default'].module('app.services', [_navigationNavigation2['default'].name, _apisApi2['default'].name, _apisRegions2['default'].name, _apisLivefeed2['default'].name, _apisCategories2['default'].name, _apisWeather2['default'].name, _apisPhotos2['default'].name, _localServiceLocalService2['default'].name, _authAuth2['default'].name, _apisClosingsAndDelays2['default'].name, _apisProfile2['default'].name, _apisTickerService2['default'].name, _apisNews2['default'].name, _apisArchives2['default'].name, _apisPolls2['default'].name, _apisArchives2['default'].name, _apisAds2['default'].name, _apisWeatherVideoService2['default'].name, _apisWeatherCurrent2['default'].name, _apisTrafficService2['default'].name]);
	
	exports['default'] = serviceModule;
	module.exports = exports['default'];

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @ngdoc service
	 * @name app.navigationService
	 * @description
	 * # Navigation Service.
	 * Manages key navigation across components using a pubsub for messaging.
	 *
	 * When to use the navigation service:
	 * - When the component has focus and is ready to lose focus.
	 * - If the component hosts multiple `.focusable` elements, it will needs to handle its internal navigation,
	 *   and only publish key events to notify the navigation service when it has reached the first / last row or column
	 *   and it ready to loose focus.
	 *
	 * There are 3 steps to incorporate navigation across components:
	 * - Use the css classes `.focusable` and the extra `.focusable-first`, `.focusable-last` elements
	 *   to allow the service to find elements to focus on within specific containers
	 * - Define cross component navigation behavior in navigation.js service, in `processKeyAction()` function.
	 * - New components should handle navigation internally and only publish events when ready to loose focus.
	 *   Message structure is: 'navigation.key.{name}' where {name} is the key name.
	 *
	 * ## Example
	 * ``` js
	 *      onKeyDown(e) {
	 *        switch (true) {
	 *          case keyboard.isEnter(e):
	 *            // perform some internal action
	 *            break;
	 *          case keyboard.isUp(e):
	 *            PubSub.publish('navigation.key.up', 'nameOfSourceComponent');
	 *            break;
	 *          case keyboard.isDown(e):
	 *            PubSub.publish('navigation.key.down', 'nameOfSourceComponent');
	 *            break;
	 *        }
	 *      }
	 * ```
	 * @requires ng:$document
	 * @requires ng:$state
	 * @requires ng:$timeout
	 * @requires constants.topics
	 * @requires constants.states
	 **/
	/*---------------------------------------------------------*\
	 * Imports
	\*---------------------------------------------------------*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _pubsubJs = __webpack_require__(32);
	
	var _pubsubJs2 = _interopRequireDefault(_pubsubJs);
	
	var _lodash = __webpack_require__(35);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	/*---------------------------------------------------------*\
	 * WeakMap
	\*---------------------------------------------------------*/
	var deps = {};
	
	var KEY_UP = 'up';
	var KEY_DOWN = 'down';
	var KEY_LEFT = 'left';
	var KEY_RIGHT = 'right';
	// const KEY_BACK = 'back';
	var KEY_ENTER = 'enter';
	
	var NavigationService = (function () {
	  //-----------------------------------
	  // Constructor
	  //-----------------------------------
	
	  function NavigationService($document, $state, $timeout, topics, states) {
	    _classCallCheck(this, NavigationService);
	
	    deps.$document = $document;
	    deps.$state = $state;
	    deps.$timeout = $timeout;
	    deps.topics = topics;
	    deps.states = states;
	
	    this.digestCounter = 0;
	    _pubsubJs2['default'].subscribe(deps.topics.nav.allKeys, this.onKeyMessage.bind(this));
	    _pubsubJs2['default'].subscribe(deps.topics.headerMain.selectTab, this.onTabMessage.bind(this));
	  }
	
	  //-----------------------------------
	  // Events
	  //-----------------------------------
	  /**
	   * @private
	   */
	
	  /**
	   * @ngdoc
	   * @name app.navigationService#onKeyMessage
	   * @methodOf app.navigationService
	   * @example
	   * ``` js
	   * onKeyMessage(msg, data);
	   * PubSub.subscribe(deps.topics.nav.allKeys, this.onKeyMessage.bind(this));
	   * ```
	   * @param {string} msg The string used for communicating on PubSub.
	   * @param {object} data The data being passed on the PubSub.
	   * @description
	   * Private service method to manage the flow of data for navigation pubsub events.
	   * if data is passed in, it will generate a source from that data and it will call
	   * {@link app.navigationService#processKeyAction processKeyAction} method.
	   * @returns {boolean} it will allways return true.
	   **/
	
	  _createClass(NavigationService, [{
	    key: 'onKeyMessage',
	    value: function onKeyMessage(msg, data) {
	      if (!data) {
	        return true;
	      }
	      var source = typeof data === 'string' ? data : data.source;
	      var key = msg.substr(deps.topics.nav.allKeys.length + 1);
	      this.processKeyAction(source, key, data);
	      return true;
	    }
	
	    /**
	     * @ngdoc
	     * @name app.navigationService#onTabMessage
	     * @methodOf app.navigationService
	     * @example
	     * ``` js
	     * onTabMessage('nav-message', {item{state: 'home'}});
	     * PubSub.subscribe(deps.topics.nav.allKeys, this.onTabMessage.bind(this));
	     * ```
	     * @param {string} msg The string used for communicating on PubSub.
	     * @param {object} data The data being passed on the PubSub.
	     * @description
	     * Private service method to manage $state changes for navigation PubSub events.
	     * It will check the data param for the presence of 'data.item.state', if it exists it will call $state.go with it
	     * as a param. if it does not exist, it will not do anything.
	     **/
	  }, {
	    key: 'onTabMessage',
	    value: function onTabMessage(msg, data) {
	      // if item doesnt have state don't go anywhere. This is used for traffic and weather tabs.
	      if (data.item.state) {
	        deps.$state.go(data.item.state);
	      }
	    }
	
	    //-----------------------------------
	    // Methods
	    //-----------------------------------
	    /**
	     * @ngdoc
	     * @name app.navigationService#getFocusableEl
	     * @methodOf app.navigationService
	     * @example
	     * ``` js
	     * navigationService.getFocusableEl('.class-name');
	     * navigationService.getFocusableEl('.class-name', 'first');
	     * navigationService.getFocusableEl('.class-name', 5);
	     * ```
	     * @param {string} inParentNode parent element containing the 'focusable' elements.
	     * @param {(string|number)=} index  The position of the element. Values: first, last. Defaults to 'first' if no
	     * index is passed.
	     * @description
	     * Service method to manage focus navigation.
	     * @returns {element} element where focus will be added;
	     **/
	  }, {
	    key: 'getFocusableEl',
	    value: function getFocusableEl(inParentNode, index) {
	      var posClasses = {
	        first: '.focusable-first',
	        last: '.focusable-last'
	      };
	      if (typeof index === 'number') {
	        return deps.$document[0].querySelectorAll(inParentNode + ' .focusable')[index];
	      }
	      var pos = posClasses[index || 'first'];
	      // .focusable-first may be assigned to a parent element
	      var el = deps.$document[0].querySelector(inParentNode + (' ' + pos + ' .focusable'));
	      if (!el) {
	        // .focusable-first may be assigned to the focus element
	        el = deps.$document[0].querySelector(inParentNode + (' ' + pos + '.focusable'));
	      }
	      if (!el) {
	        el = deps.$document[0].querySelector(inParentNode + ' .focusable');
	      }
	      return el;
	    }
	
	    /**
	     * @ngdoc
	     * @name app.navigationService#focusEl
	     * @methodOf app.navigationService
	     * @example
	     * ``` js
	     * navigationService.focusEl('.class-name');
	     * navigationService.focusEl('.class-name', 'first');
	     * navigationService.focusEl('.class-name', 5);
	     * ```
	     * @param {string} inParentNode parent element containing the 'focusable' elements.
	     * @param {(string|number)=} index  The position of the element. Values: first, last. Defaults to 'first'
	     * @description
	     * Set focus to an element belonging to the specified parent container.
	     * It calls {@link api.navigationService#getFocusableEl getFocusableEl}
	     * method with the passed in params.
	     * if the element returned by the called function exists, it gives it focus.
	     **/
	
	  }, {
	    key: 'focusEl',
	    value: function focusEl(inParentNode, atIndex) {
	      var el = this.getFocusableEl(inParentNode, atIndex);
	      if (el) {
	        el.focus();
	      }
	    }
	
	    /**
	     * @ngdoc
	     * @name app.navigationService#focusElAsync
	     * @methodOf app.navigationService
	     * @example
	     * ``` js
	     * navigationService.focusElAsync('.class-name');
	     * navigationService.focusElAsync('.class-name', 'first');
	     * navigationService.focusElAsync('.class-name', 5);
	     * ```
	     * @param {string} inParentNode parent element containing the 'focusable' elements.
	     * @param {(string|number)=} index  The position of the element. Values: first, last. Defaults to 'first'
	     * @description
	     * Async version of focusEl
	     * if the element returned by the called function exists, it gives it focus.
	     **/
	  }, {
	    key: 'focusElAsync',
	    value: function focusElAsync(inParentNode, atIndex) {
	      var _this = this;
	
	      deps.$timeout(function () {
	        var el = _this.getFocusableEl(inParentNode, atIndex);
	        if (!el) {
	          _this.digestCounter++;
	
	          if (_this.digestCounter > 5) {
	            _this.digestCounter = 0;
	          } else {
	            _this.focusElAsync(inParentNode, atIndex);
	          }
	        } else {
	          _this.digestCounter = 0;
	          el.focus();
	        }
	      });
	    }
	
	    /**
	     * @ngdoc
	     * @name app.navigationService#processKeyAction
	     * @methodOf app.navigationService
	     * @example
	     * ``` js
	     * navigationService.processKeyAction('navbar, 'down', {item: {id: ''}})
	     * ```
	     * @param {string} source The source component.
	     * @param {string} key The code for the event fired on the passed in component element.
	     * @param {object} data The data to be passed in.
	     * @description
	     * Private method to direct focus flow between components.
	     **/
	
	  }, {
	    key: 'processKeyAction',
	    value: function processKeyAction(source, key, data) {
	      // currentState can be used to further customize component navigation for specific pages
	      var currentState = deps.$state.current.name;
	      switch (source) {
	        case 'navbarSubMenu':
	          if (key === KEY_UP) {
	            this.focusEl('navbar .selected');
	          } else if (key === KEY_DOWN) {
	            this.focusEl('.main-content');
	          }
	          break;
	        case 'navbar':
	          if (key === KEY_DOWN) {
	            // if below sections are selected we should send focus to live feed enlarge button
	            // instead of story main-content
	            var sections = ['weather', 'features', 'traffic'];
	            if (data.item && _lodash2['default'].includes(sections, data.item.id) && currentState !== deps.states.closingsAndDelays) {
	              this.focusEl('live-feed-video');
	            } else {
	              this.focusEl('.main-content');
	            }
	          }
	          break;
	        case 'poll-list':
	          if (key === KEY_UP) {
	            this.focusEl('navbar');
	          } else if (key === KEY_DOWN) {
	            this.focusEl('.btngroup', 1);
	          } else if (key === KEY_ENTER) {
	            this.focusEl('.main-content');
	          } else if (key === KEY_RIGHT) {
	            this.focusEl('live-feed-video');
	          }
	          break;
	        case 'photo-list':
	          if (key === KEY_UP) {
	            this.focusEl('navbar');
	          } else if (key === KEY_LEFT) {
	            this.focusEl('.left-navbar');
	          }
	          break;
	        case 'photo-gallery':
	          if (key === KEY_UP) {
	            this.focusEl('navbar');
	          } else if (key === KEY_LEFT) {
	            this.focusEl('.left-aside-promo-banner');
	          }
	          break;
	        case 'home.closings':
	          if (key === KEY_UP) {
	            this.focusEl('navbar .selected');
	          } else if (key === KEY_DOWN) {
	            if (data.pollResultVisible) {
	              this.focusEl('.main-menu-btn');
	            } else {
	              this.focusEl('.main-content');
	            }
	          }
	          break;
	        case 'incident-list':
	          if (key === KEY_UP) {
	            this.focusEl('navbar .selected');
	          } else if (key === KEY_LEFT) {
	            this.focusEl('.left-navbar');
	          }
	          break;
	        case 'camera-gallery':
	          if (key === KEY_UP) {
	            this.focusEl('navbar');
	          } else if (key === KEY_LEFT) {
	            this.focusEl('.left-aside-promo-banner');
	          }
	          break;
	        case 'camera-list':
	          if (key === KEY_UP) {
	            this.focusEl('navbar .selected');
	          } else if (key === KEY_LEFT) {
	            this.focusEl('.left-navbar');
	          }
	          break;
	        default:
	          console.warn('NavigationService: Navigation for source \'' + source + '\' not defined');
	      }
	    }
	
	    //-----------------------------------
	    // Static
	    //-----------------------------------
	  }], [{
	    key: 'factory',
	    value: function factory($document, $state, $timeout, topics, states) {
	      return new NavigationService($document, $state, $timeout, topics, states);
	    }
	  }]);
	
	  return NavigationService;
	})();
	
	NavigationService.factory.$inject = ['$document', '$state', '$timeout', 'topics', 'states'];
	
	var Module = _angular2['default'].module('navigationService', ['constants']).factory('navigationService', NavigationService.factory);
	
	exports['default'] = Module;
	module.exports = exports['default'];

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @ngdoc service
	 * @name app.apiService
	 * @description
	 * # API Service
	 * Main service to manage API communication.
	 * It provides standarization for network calls.
	 * @requires constants:config
	 * @requires constants:cacheExpiry
	 * @requires app:localService
	 * @requires ng.$http
	 **/
	/*---------------------------------------------------------*\
	 * Imports
	\*---------------------------------------------------------*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _uuid = __webpack_require__(250);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _lodash = __webpack_require__(35);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	/*---------------------------------------------------------*\
	 * apiService
	\*---------------------------------------------------------*/
	
	var ApiService = (function () {
	  function ApiService($http, localService, cacheExpiry, config, storageKeys) {
	    var _this = this;
	
	    _classCallCheck(this, ApiService);
	
	    // get cache expiration from config service. If not set then resort to default constant
	    var cacheExpiryValMs = config.sessionStorageCacheExpiryMs ? config.sessionStorageCacheExpiryMs : cacheExpiry['default'];
	    var defaultCache = localService.createCache('$http', {
	      deleteOnExpire: true,
	      maxAge: cacheExpiryValMs,
	      storeOnResolve: true
	    });
	
	    var GET = 'get';
	    var POST = 'post';
	
	    var _wrap = function _wrap(url, config, resultName, cachebuster, method, data) {
	      var promise = undefined;
	      var mockData = localService.get(storageKeys.mockData);
	
	      if (cachebuster) {
	        url = _this.addQueryParamToUrl(url, 'cachebuster', _uuid2['default'].v4());
	      } else {
	        // if cachebuster flag is set we will not only bust the cache in the url
	        // but also make sure it's not locally cached
	        config.cache = config.cache || defaultCache;
	      }
	
	      if (mockData) {
	        url = _this.addQueryParamToUrl(url, 'mockdata', mockData);
	      }
	
	      if (method.toLowerCase() === GET) {
	        promise = $http.get(url, config);
	      } else if (method.toLowerCase() === POST) {
	        promise = $http.post(url, data, config);
	      }
	
	      if (resultName) {
	        promise.then(function (result) {
	          _this[resultName + 'Result'] = result;
	        });
	      }
	
	      promise['catch'](function (error) {
	        console.error('## DATA ## API ERROR ' + resultName, url, error);
	
	        if (resultName) {
	          _this[resultName + 'Error'] = error;
	        }
	      });
	
	      return promise;
	    };
	
	    this.addQueryParamToUrl = function (url, param, paramValue) {
	      var prefix = _lodash2['default'].contains(url, '?') ? '&' : '?';
	      return url + prefix + param + '=' + paramValue;
	    };
	
	    /**
	     * @ngdoc
	     * @name app.apiService#wrap
	     * @methodOf app.apiService
	     * @description
	     * apiService.wrap
	     * Wraps a GET API call, providing standard methodology to handle
	     *
	     * - Console logging
	     * - Callbacks
	     *
	     * See waitFor for information on listening for when a call has been completed.
	     *
	     * @param {string} url to hit with a GET request.
	     * @param {object} config Configuration to pass to the $http.get() method.
	     * @param {string} resultName The name used to store the result, it's promise, or it's error.
	     * @param {boolean} cachebuster Whether to append a cachebuster query param or not.
	     *
	     * @returns {httpPromise} Promise
	     */
	    this.wrap = function (url, config, resultName, cachebuster) {
	      return _wrap(url, config, resultName, cachebuster, GET);
	    };
	
	    /**
	     * @ngdoc
	     * @name app.apiService#wrapPost
	     * @methodOf app.apiService
	     * @description
	     * apiService.wrapPost
	     * Wraps a POST API call, providing standard methodology to handle
	     *
	     * - Console logging
	     * - Callbacks
	     *
	     * See waitFor for information on listening for when a call has been completed.
	     *
	     * @param {string} url The url to hit with a GET request.
	     * @param {object} data The data to send to the backend
	     * @param {object} config Configuration to pass to the $http.get() method.
	     * @param {string} resultName The name used to store the result, it's promise, or it's error.
	     * @param {boolean} cachebuster Whether to append a cachebuster query param or not.
	     *
	     * @returns {httpPromise} Promise
	     */
	    this.wrapPost = function (url, data, config, resultName, cachebuster) {
	      return _wrap(url, config, resultName, cachebuster, POST, data);
	    };
	  }
	
	  //-----------------------------------
	  // Static
	  //-----------------------------------
	
	  _createClass(ApiService, null, [{
	    key: 'factory',
	    value: function factory($http, localService, cacheExpiry, config, storageKeys) {
	      return new ApiService($http, localService, cacheExpiry, config, storageKeys);
	    }
	  }]);
	
	  return ApiService;
	})();
	
	ApiService.factory.$inject = ['$http', 'localService', 'cacheExpiry', 'config', 'storageKeys'];
	
	var api = _angular2['default'].module('apiService', ['constants', 'localService', 'config']).factory('apiService', ApiService.factory);
	
	exports['default'] = api;
	module.exports = exports['default'];

/***/ },
/* 250 */,
/* 251 */,
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @ngdoc service
	 * @name app.regionService
	 * @description
	 * # regionService
	 * Service to talk with backend api.
	 * Get current region data as well as all regions.
	 * @requires app.apiService
	 * @requires constants:config
	 **/
	/*---------------------------------------------------------*\
	 * Imports
	\*---------------------------------------------------------*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	/*---------------------------------------------------------*\
	 * regionService
	\*---------------------------------------------------------*/
	/* @ngInject */
	function regionService(apiService, config) {
	  // APIs
	  /**
	   * @ngdoc
	   * @name app.regionService#getRegions
	   * @methodOf app.regionService
	   * @example
	   * ``` js
	   * regionService.getRegions();
	   * ```
	   * @description
	   * Service to talk with backend api.
	   * It forms a string url using config relative base url, '/region/info' string.
	   * It will call apiService.wrap function with the string formed as a param.
	   * @returns {httpPromise} Promise that will resolve into an object with all available regions.
	   **/
	  this.getRegions = function () {
	    return apiService.wrap(config.relBaseUrlAPi + '/region/info', {}, 'regions');
	  };
	
	  /**
	   * @ngdoc
	   * @name app.regionService#getCities
	   * @methodOf app.regionService
	   * @example
	   * ``` js
	   * regionService.getCities('CT');
	   * ```
	   * @param {string} region selected region abbreviation, case 'Bronx' => 'BX',
	   * 'New Jersey' => 'NJ', max of two characters.
	   * @description
	   * Service to talk with backend api.
	   * It forms a string url using config relative base url, '/region/info' string.
	   * It will call apiService.wrap function with the string formed as a param.
	   * @returns {httpPromise} Promise that will resolve into a string url, or it
	   * Will throw an error if region code is not a string or is the incorrect length.
	  **/
	  this.getCities = function (regionCode) {
	    if (!_angular2['default'].isString(regionCode) || regionCode.length !== 2) {
	      throw new Error('A two-character region code is required');
	    }
	    return apiService.wrap(config.relBaseUrlAPi + '/schools/cities/' + regionCode, {}, 'regions');
	  };
	}
	
	regionService.$inject = ['apiService', 'config'];
	
	var api = _angular2['default'].module('regionService', ['config', 'apiService']).service('regionService', regionService);
	
	exports['default'] = api;
	module.exports = exports['default'];

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @ngdoc service
	 * @name app.livefeedService
	 * @description
	 * # livefeedService
	 * Service to talk with backend api.
	 * @requires app.apiService
	 * @requires app.localService
	 * @requires constants:config
	 * @requires constants:storageKeys
	 **/
	
	/*---------------------------------------------------------*\
	 * Imports
	\*---------------------------------------------------------*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	/*---------------------------------------------------------*\
	 * livefeedService
	\*---------------------------------------------------------*/
	/* @ngInject */
	
	var livefeedService = (function () {
	  //-----------------------------------
	  // Constructor
	  //-----------------------------------
	
	  livefeedService.$inject = ["config", "localService", "storageKeys"];
	  function livefeedService(config, localService, storageKeys) {
	    _classCallCheck(this, livefeedService);
	
	    this.config = config;
	    this.localService = localService;
	    this.storageKeys = storageKeys;
	    /**
	     * @ngdoc property
	     * @name app.livefeedService#allRegions
	     * @propertyOf app.livefeedService
	     * @example
	     * ``` js
	     * livefeedService.allRegions;
	     * ```
	     * @description
	     * It calls the localService with all available as param.
	     * @returns {array} Array containing all available regions.
	     **/
	    this.allRegions = this.localService.get(this.storageKeys.regions);
	    this.getCurrentRegion();
	  }
	
	  //-----------------------------------
	  // Properties
	  //-----------------------------------
	  /**
	   * @ngdoc
	   * @name app.livefeedService#getCurrentRegion
	   * @methodOf app.livefeedService
	   * @example
	   * ``` js
	   * livefeedService.getCurrentRegion();
	   * ```
	   * @description
	   * Service to talk with backend api.
	   * It calls the localService with the selected regions as a param.
	   * @returns {object} it returns the region object. This regions object can be the either the one returned from
	   * {@link app.localService localService} or the default one which is:
	   * ``` js
	   * {
	   *  abbr: 'LI',
	   *  name: 'Long Island',
	   *  callSign: 'N12LI_WEST',
	   *  twCallSign: 'N12TW_LI'
	   * }
	   * ```
	   **/
	
	  _createClass(livefeedService, [{
	    key: 'getCurrentRegion',
	    value: function getCurrentRegion() {
	      var region = this.localService.get(this.storageKeys.selectedRegion);
	      return region || { abbr: 'LI', name: 'Long Island', callSign: 'N12LI_WEST', twCallSign: 'N12TW_LI' };
	    }
	
	    //-----------------------------------
	    // Methods
	    //-----------------------------------
	    /**
	     * @ngdoc
	     * @name app.livefeedService#getLivefeed
	     * @methodOf app.livefeedService
	     * @example
	     * ``` js
	     * livefeedService.getLivefeed();
	     * ```
	     * @description
	     * calls {@link app.livefeedService#getCurrentRegion getCurrentRegion} method.
	     * calls {@link app.livefeedService#cachebust cachebust} method with params absolute url and current region callsign.
	     * @returns {httpPromise} Promise that will resolve into a string url for livefeed video.
	     **/
	  }, {
	    key: 'getLivefeed',
	    value: function getLivefeed() {
	      var region = this.getCurrentRegion();
	      return this.cachebust(this.config.absBaseUrlLiveFeed.replace('{callSign}', region.callSign));
	    }
	
	    /**
	     * @ngdoc
	     * @name app.livefeedService#getTWLivefeed
	     * @methodOf app.livefeedService
	     * @example
	     * ``` js
	     * livefeedService.getTWLivefeed(callSign);
	     * ```
	     * @param {string} callSign string passed showing current region callSign.
	     * @description
	     * calls {@link app.livefeedService#cachebust cachebust} method with params absolute url and current region callsign.
	     * @returns {httpPromise} Promise that will resolve into a string url for livefeed video for traffic and weather.
	     **/
	  }, {
	    key: 'getTWLivefeed',
	    value: function getTWLivefeed(twCallSign) {
	      return this.cachebust(this.config.absBaseUrlLiveFeed.replace('{callSign}', twCallSign));
	    }
	
	    /**
	     * @ngdoc
	     * @name app.livefeedService#cachebust
	     * @methodOf app.livefeedService
	     * @example
	     * ``` js
	     * livefeedService.cachebust('http://www.randomurl.com/');
	     * ```
	     * @param {string} url string passed in.
	     * @description
	     * transforms the string url by adding a timestamp as a parameter
	     * @returns {string} converted string with added timestamp.
	     **/
	  }, {
	    key: 'cachebust',
	    value: function cachebust(url) {
	      return url + '&' + Math.round(new Date().getTime() / 1000);
	    }
	  }]);
	
	  return livefeedService;
	})();
	
	livefeedService.$inject = ['config', 'localService', 'storageKeys'];
	
	var api = _angular2['default'].module('livefeedService', ['config', 'constants', 'regionService', 'localService']).service('livefeedService', livefeedService);
	
	exports['default'] = api;
	module.exports = exports['default'];

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @ngdoc service
	 * @name app.categoryService
	 * @description
	 * # Categories Service
	 * Service to talk with backend api to get categories information.
	 * @requires app.apiService
	 * @requires app.weatherService
	 * @requires app.livefeedService
	 * @requires app.localService
	 * @requires constants:config
	 * @requires constants:states
	 * @requires constants:storageKeys
	 * @requires ng:$q
	**/
	/*---------------------------------------------------------*\
	 * Imports
	\*---------------------------------------------------------*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(35);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	/*---------------------------------------------------------*\
	 * categoryService
	\*---------------------------------------------------------*/
	/* @ngInject */
	function categoryService(apiService, config, states, weatherService, $q, livefeedService, localService, storageKeys) {
	  var _this = this;
	
	  var tw = {
	    nj: {
	      id: 't&w_nj',
	      title: 'NJ CH 61 T&W',
	      type: 'component',
	      state: {
	        name: states.enlargedLiveFeed,
	        params: {
	          feedType: 'T&W',
	          region: 'NJ'
	        }
	      }
	    },
	    wc: {
	      id: 't&w_wc',
	      title: 'WC CH 61 T&W',
	      type: 'component',
	      state: {
	        name: states.enlargedLiveFeed,
	        params: {
	          feedType: 'T&W',
	          region: 'WC'
	        }
	      }
	    },
	    ct: {
	      id: 't&w_ct',
	      title: 'CT CH 61 T&W',
	      type: 'component',
	      state: {
	        name: states.enlargedLiveFeed,
	        params: {
	          feedType: 'T&W',
	          region: 'CT'
	        }
	      }
	    },
	    nyc: {
	      id: 't&w_nyc',
	      title: 'NYC CH 61 T&W',
	      type: 'component',
	      state: {
	        name: states.enlargedLiveFeed,
	        params: {
	          feedType: 'T&W',
	          region: 'NYC'
	        }
	      }
	    },
	    li: {
	      id: 't&w_li',
	      title: 'LI CH 61 T&W',
	      type: 'component',
	      state: {
	        name: states.enlargedLiveFeed,
	        params: {
	          feedType: 'T&W',
	          region: 'LI'
	        }
	      }
	    }
	  };
	  var menu = [{ id: 'news', title: 'News', state: states.home }, { id: 'io_extra', title: 'Extra', state: states.io_extra }, { id: 'photos', title: 'Photos', state: states.photos }, { id: 'in_depth', title: 'In Depth', state: states.in_depth }, { id: 'features', title: 'Features', state: states.features }, { id: 'weather', title: 'Weather' }, { id: 'traffic', title: 'Traffic' }];
	  var staticSections = {
	    news: [
	    // {
	    //   id: 'poll',
	    //   title: 'News 12 Poll',
	    //   type: 'component'
	    // },
	    {
	      id: 'archives',
	      title: 'Archives',
	      type: 'component'
	    }, {
	      id: 'other_regions',
	      title: 'Other Regions',
	      type: 'component'
	    }],
	    weather: [{
	      id: 'weather_center',
	      title: 'Weather Center',
	      type: 'component',
	      state: {
	        name: states.weather_center
	      }
	    }, tw.nj, tw.wc, tw.ct, tw.nyc, tw.li, {
	      id: 'forecast',
	      title: 'Forecast Video',
	      type: 'component',
	      state: {
	        name: states.videoplayer
	      }
	    }],
	    traffic: [{
	      id: 'traffic_center',
	      title: 'Traffic Center',
	      type: 'component',
	      state: {
	        name: states.traffic_center
	      }
	    }, tw.nj, tw.wc, tw.ct, tw.nyc, tw.li]
	  };
	  var allRegions = localService.get(storageKeys.regions);
	  // APIs
	  /**
	   * @ngdoc
	   * @name app.categoryService#getCategories
	   * @methodOf app.categoryService
	   * @param {string} regionId selected region abbreviation, case 'Bronx' => 'BX',
	   * 'New Jersey' => 'NJ', max of two characters..
	   * @example
	   * ``` js
	   * categoryService.getCategories('LI');
	   * ```
	   * @description
	   * calls {@link app.apiService#wrap apiService.wrap()} method with current base url,
	   * '/news/categories/' and regionId'.
	   * @returns {httpPromise} Promise that will resolve into an array or categories for
	   * current region.
	   **/
	  this.getCategories = function (regionId) {
	    return apiService.wrap(config.relBaseUrlAPi + '/news/categories/' + regionId, {}, 'categories').then(function (res) {
	      if (!res.data) {
	        return [];
	      }
	      return _this.buildMenu(res.data, regionId).then(function (menu) {
	        return menu;
	      });
	    });
	  };
	
	  /**
	   * @ngdoc
	   * @name app.categoryService#buildMenu
	   * @methodOf app.categoryService
	   * @param {array} data array of all available categories.
	   * @param {string} region selected region abbreviation, case 'Bronx' => 'BX',
	   * 'New Jersey' => 'NJ', max of two characters.
	   * @example
	   * ``` js
	   * let categories = [
	   *   {
	   *     hasStories:true,
	   *     id:'news',
	   *     sections: [],
	   *     state:'app.home.news',
	   *     title:"News"
	   *   },
	   *   {
	   *     hasStories:false,
	   *     id:'extra',
	   *     sections: [],
	   *     state:'app.home.extra',
	   *     title:"Extra"
	   *   }
	   * ]
	   * categoryService.buildMenu(categories,'LI');
	   * ```
	   * @description
	   * It takes {@link app.categoryService#menu} and Builds menu items accordingly.
	   * calls {@link app.apiService#wrap apiService.wrap()} method with current base url,
	   * '/news/categories/' and regionId'.
	   * @returns {httpPromise} Promise that will resolve into an array or categories for current region.
	   **/
	  this.buildMenu = function (data, region) {
	    var promises = [];
	    var defer = $q.defer();
	    menu.forEach(function (category) {
	      promises.push(_this.appendSections(category, data[category.id] || {}, region));
	    });
	
	    $q.all(promises).then(function () {
	      defer.resolve(menu);
	    });
	    return defer.promise;
	  };
	
	  /**
	   * @ngdoc
	   * @name app.categoryService#appendSections
	   * @methodOf app.categoryService
	   * @param {object} category array of all available categories.
	   * @param {array} stories Stories object to form the navbar link items.
	   * @param {region} region selected region abbreviation, case 'Bronx' => 'BX',
	   * 'New Jersey' => 'NJ', max of two characters.
	   * @example
	   * ``` js
	   * let stories = {
	   *   crime:"Crime",
	   *   local: "Top &apos;Stories&apos;",
	   *   tsnw: "World News"
	   * }
	   * let category = {
	   *   hasStories:true,
	   *   id:'news',
	   *   sections: [],
	   *   state:'app.home.news',
	   *   title:"News"
	   * }
	   * categoryService.appendSections(category, stories,'LI');
	   * ```
	   * @description
	   * It takes {@link app.categoryService#menu} and Builds menu items accordingly.
	   * calls {@link app.apiService#wrap apiService.wrap()} method with current base url,
	   * '/news/categories/' and regionId'.
	   * It is called inside of {@link app.categoryService#buildMenu} to get url information for the navbar
	   * @returns {httpPromise} Promise that will resolve into an array or categories for current region.
	   **/
	  this.appendSections = function (category, stories, region) {
	    var defer = $q.defer();
	    var promises = [];
	    stories = Object.keys(stories).map(function (k) {
	      return {
	        id: k,
	        title: stories[k],
	        type: 'storylist'
	      };
	    });
	    category.hasStories = stories.length > 0;
	    category.sections = stories.concat(staticSections[category.id] || []);
	    category.sections.forEach(function (section) {
	      var innerDefer = $q.defer();
	      if (section.id === 'forecast') {
	        weatherService.getWeatherForecast(region).then(function (data) {
	          var currentItem = {};
	          if (data && data.rss && data.rss.channel) {
	            currentItem.videoUrl = data.rss.channel.item['media:content'].url;
	          } else {
	            // TODO setup a default video error image instead
	            currentItem.videoUrl = '';
	          }
	          section.state.params = { currentStory: { story: currentItem } };
	          innerDefer.resolve();
	        })['catch'](function () {
	          // if forecast video fails then we shouldnt stop the whole menu from building. So make video empty.
	          // TODO setup a default video error image instead
	          var currentItem = {};
	          currentItem.videoUrl = '';
	          section.state.params = { currentStory: { story: currentItem } };
	          innerDefer.resolve();
	        });
	      } else if (_lodash2['default'].contains(section.id, 't&w')) {
	        // TODO, check this filter, NYC forecast is not being displayed.
	        var currentRegion = _lodash2['default'].filter(allRegions, function (region) {
	          var ID = section.id.substring(section.id.indexOf('_') + 1, section.id.length).toUpperCase();
	          ID = ID === 'NYC' ? 'BX' : ID;
	          return region.abbr === ID;
	        });
	        var currentItem = {
	          story: {
	            videoUrl: _lodash2['default'].isUndefined(currentRegion[0]) ? currentRegion[0] : livefeedService.getTWLivefeed(currentRegion[0].twCallSign)
	          }
	        };
	        section.state.params = { currentStory: currentItem };
	        innerDefer.resolve();
	      } else {
	        innerDefer.resolve();
	      }
	      promises.push(innerDefer.promise);
	    });
	
	    $q.all(promises).then(function () {
	      defer.resolve();
	    });
	
	    return defer.promise;
	  };
	}
	
	categoryService.$inject = ['apiService', 'config', 'states', 'weatherService', '$q', 'livefeedService', 'localService', 'storageKeys'];
	
	var api = _angular2['default'].module('categoryService', ['config', 'apiService', 'constants']).service('categoryService', categoryService);
	
	exports['default'] = api;
	module.exports = exports['default'];

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @ngdoc service
	 * @name app.weatherService
	 * @description
	 * # weatherService
	 * Service to talk with backend api.
	 * @requires app.apiService#wrap
	 * @requires constants:config
	 **/
	
	/*---------------------------------------------------------*\
	 * Imports
	\*---------------------------------------------------------*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	// TODO move to config
	var WEATHER_ICON_PREFIX_URL = 'http://images.itv.weather.news12.com/weather/images/612_36H_';
	
	/*---------------------------------------------------------*\
	 * weatherService
	\*---------------------------------------------------------*/
	/* @ngInject */
	function weatherService(apiService, config) {
	  /**
	   * @ngdoc
	   * @name app.weatherService#getWeatherIconsUrl
	   * @methodOf app.weatherService
	   * @example
	   * ``` js
	   * weatherService.getWeatherIconsUrl('WC');
	   * ```
	   * @param {string} region selected region abbreviation, case 'Bronx' => 'BX',
	   * 'New Jersey' => 'NJ', max of three characters.
	   * @description
	   * Service to form url for weather icons.
	   * @returns {string} String url referencing an image file (.png format), this url
	   * will include a timestamp query.
	   **/
	  this.getWeatherIconsUrl = function (region) {
	    var timestamp = new Date().getTime();
	    if (region === 'BK' || region === 'BX') {
	      region = 'NYC';
	    } else if (region === 'WC') {
	      region = 'HV';
	    }
	    return WEATHER_ICON_PREFIX_URL + region + '.png?timestamp=' + timestamp;
	  };
	
	  /**
	   * @ngdoc
	   * @name app.weatherService#getWeatherForecast
	   * @methodOf app.weatherService
	   * @example
	   * weatherService.getWeatherForecast(region)
	   * @param {string} region selected region abbreviation, case 'Bronx' => 'BX',
	   * 'New Jersey' => 'NJ', max of three characters.
	   * @description
	   * Service to call apiService to get string url for weatherForecast livestream;
	   * @returns {htmlPromise} promise to resolve to string url referencing a livestream video,
	   * or Will throw an error if region code is not a string or is the incorrect length.
	   **/
	  this.getWeatherForecast = function (region) {
	    if (_angular2['default'].isString(region) && region.length < 3) {
	      return apiService.wrap(config.relBaseUrlAPi + '/forecastvideo/' + region, {}, 'forecast').then(function (data) {
	        if (data && data.data) {
	          return data.data;
	        }
	        return false;
	      });
	    }
	    return new Error('Invalid Region Code');
	  };
	}
	
	weatherService.$inject = ['apiService', 'config'];
	
	var api = _angular2['default'].module('weatherService', ['apiService']).service('weatherService', weatherService);
	
	exports['default'] = api;
	module.exports = exports['default'];

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @ngdoc service
	 * @name app.photosService
	 * @description
	 * # photosService
	 * Service to talk with backend api.
	 * @requires app.apiService
	 * @requires constants:config
	 * @requires ng.$q
	 * @requires ng.$timeout
	 **/
	
	/*---------------------------------------------------------*\
	 * Imports
	\*---------------------------------------------------------*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	/*---------------------------------------------------------*\
	 * CONSTANTS
	\*---------------------------------------------------------*/
	var deps = {};
	/*---------------------------------------------------------*\
	 * photosService
	\*---------------------------------------------------------*/
	/* @ngInject */
	function photosService(apiService, config, $q, $timeout) {
	  deps.apiService = apiService;
	  deps.config = config;
	  deps.$q = $q;
	  deps.$timeout = $timeout;
	
	  /**
	   * @ngdoc
	   * @name app.photosService#getPhotoList
	   * @methodOf app.photosService
	   * @example
	   * ``` js
	   * photosService.getPhotoList('LI');
	   * ```
	   * @param {string} region selected region abbreviation, case 'Bronx' => 'BX',
	   * 'New Jersey' => 'NJ', max of three characters.
	   * @description
	   * Service to talk with backend api. It calls the apiService.wrap function,
	   * passing a relative url, the string '/photos/list/', and the passed in region code.
	   * @returns {httpPromise} Promise that will resolve into an array of photos
	   * objects or an empty one;
	   **/
	  this.getPhotoList = function (regionId) {
	    return deps.apiService.wrap(deps.config.relBaseUrlAPi + '/photos/list/' + regionId, {}, 'photos').then(function (res) {
	      return res.data || [];
	    });
	  };
	}
	
	photosService.$inject = ['apiService', 'config', '$q', '$timeout'];
	
	var api = _angular2['default'].module('photosService', ['config', 'apiService']).service('photosService', photosService);
	
	exports['default'] = api;
	module.exports = exports['default'];

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	/*---------------------------------------------------------*\
	 * Imports
	 \*---------------------------------------------------------*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	/*---------------------------------------------------------*\
	 * regionService
	 \*---------------------------------------------------------*/
	/* @ngInject */
	function adService(apiService, config) {
	  this.getAd = function (section, adLocation, regionCode) {
	    if (!_angular2['default'].isString(regionCode) || regionCode.length !== 2) {
	      throw new Error('A two-character region code is required');
	    }
	    if (!_angular2['default'].isString(section)) {
	      throw new Error('A section is required. i.e. home, photos');
	    }
	    if (!_angular2['default'].isString(adLocation)) {
	      throw new Error('adLocation is required. i.e. footer_center');
	    }
	    return apiService.wrap(config.relBaseUrlAPi + '/ads/' + section + '/' + adLocation + '/' + regionCode, {}, 'ads', true).then(function (res) {
	      if (!res.data) {
	        return {};
	      }
	      return res.data;
	    });
	  };
	}
	
	adService.$inject = ['apiService', 'config'];
	
	var api = _angular2['default'].module('adService', ['config', 'apiService']).service('adService', adService);
	
	exports['default'] = api;
	module.exports = exports['default'];

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @ngdoc service
	 * @name app.tickerService
	 * @description
	 * # tickerService
	 * Service to talk with backend api.
	 * @requires app:apiService
	 * @requires constants:config
	 **/
	
	/*---------------------------------------------------------*\
	 * Imports
	\*---------------------------------------------------------*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	/*---------------------------------------------------------*\
	 * tickerService
	\*---------------------------------------------------------*/
	/* @ngInject */
	function tickerService(apiService, config) {
	  /**
	   * @ngdoc
	   * @name app.tickerService#getTicker
	   * @methodOf app.tickerService
	   * @example
	   * ``` js
	   * tickerService.getTicker('LI');
	   * ```
	   * @param {string} region selected region abbreviation, case 'Bronx' => 'BX',
	   * 'New Jersey' => 'NJ', max of three characters.
	   * @description
	   * Service to talk with backend api.
	   * It forms a string url using config relative base url, 'news/ticker' string
	   * and the region param entered.
	   * It will call apiService.wrap function with the string formed as a param.
	   * @returns {httpPromise} Promise that will resolve into a string url, or it Will
	   * throw an error if region code is not a string or is the incorrect length.
	   **/
	  this.getTicker = function (regionCode) {
	    if (_angular2['default'].isString(regionCode) && regionCode.length < 3) {
	      return apiService.wrap(config.relBaseUrlAPi + '/news/ticker/' + regionCode, {}, 'regions');
	    }
	    return new Error('Invalid Region Code');
	  };
	}
	
	tickerService.$inject = ['apiService', 'config'];
	
	var api = _angular2['default'].module('tickerService', []).service('tickerService', tickerService);
	
	exports['default'] = api;
	module.exports = exports['default'];

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @ngdoc service
	 * @name app.weatherVideoService
	 * @description
	 * # WeatherVideoService
	 * Service to talk with backend api.
	 * @requires app:apiService
	**/
	
	/*---------------------------------------------------------*\
	 * Imports
	\*---------------------------------------------------------*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	/*---------------------------------------------------------*\
	 * tickerService
	\*---------------------------------------------------------*/
	/* @ngInject */
	function weatherVideoService(apiService) {
	  /**
	   * @ngdoc
	   * @name app.weatherVideoService#getweatherVideo
	   * @methodOf app.weatherVideoService
	   * @example
	   * ```js
	   * const currentRegion = {id: 1, abbr: 'BX', name: 'Bronx'};
	   * weatherVideoService.getWeatherVideo(currentRegion.abbr);
	   * ```
	   * @param {string} region selected region abbreviation, case 'Bronx' => 'BX',
	   * 'New Jersey' => 'NJ' ...
	   * @description
	   * Service to talk with backend api. It calls the apiService.wrap function, passing a region code.
	   * @returns {httpPromise} Promise that will resolve into a string url, or it
	   * Will throw an error if region code is not a string or is the incorrect length.
	   **/
	  this.getweatherVideo = function (regionCode) {
	    if (_angular2['default'].isString(regionCode) && regionCode.length < 3) {
	      return apiService.wrap('/api/v1/forecastvideo/' + regionCode, {});
	    }
	    return new Error('Invalid Region Code');
	  };
	}
	
	weatherVideoService.$inject = ['apiService'];
	
	var api = _angular2['default'].module('weatherVideoService', []).service('weatherVideoService', weatherVideoService);
	
	exports['default'] = api;
	module.exports = exports['default'];

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @ngdoc service
	 * @name app.closingsAndDelaysService
	 * @description
	 * # closingsAndDelaysService
	 * Service to talk with backend api.
	 * @requires app.apiService
	 * @requires constants:config
	 **/
	
	/*---------------------------------------------------------*\
	 * Imports
	 \*---------------------------------------------------------*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	/*---------------------------------------------------------*\
	 * closingsAndDelaysService
	 \*---------------------------------------------------------*/
	/* @ngInject */
	function closingsAndDelaysService(apiService, config, $q) {
	  /**
	   * @ngdoc
	   * @name app.closingsAndDelaysService#getClosings
	   * @methodOf app.closingsAndDelaysService
	   * @example
	   * ``` js
	   * closingsAndDelaysService.getClosings('CT', 'Hartford');
	   * ```
	   * @param {string} regionCode passes the id for current poll.
	   * @param {string} city passes the current selection.
	   * @description
	   * Service method to talk with backend api. It calls the apiService.wrap function,
	   * passing the string formed from relative base Url, the '/schools/closing/' string,
	   * the regionCode, and city string.
	   * @returns {httpPromise} Promise that will resolve with the closings and delays object.
	   **/
	  this.getClosings = function (regionCode, city) {
	    return apiService.wrap(config.relBaseUrlAPi + '/schools/closing/' + regionCode + '/' + city, {}, 'regions');
	  };
	
	  /**
	   * @ngdoc
	   * @name app.closingsAndDelaysService#hasClosings
	   * @methodOf app.closingsAndDelaysService
	   * @example
	   * ``` js
	   * closingsAndDelaysService.getClosings('LI');
	   * ```
	   * @param {string} regionCode passes the id for current poll.
	   * @description
	   * Service method to talk with backend api. It calls the apiService.wrap function, passing
	   * the string formed from relative base Url, the '/schools/closing/' string, the regionCode,
	   * and '/all' string.
	   * @returns {httpPromise} Promise that will resolve a boolean to check if the passed in region has cosings.
	   **/
	  this.hasClosings = function (regionCode) {
	    var defer = $q.defer();
	
	    apiService.wrap(config.relBaseUrlAPi + '/schools/closing/' + regionCode + '/All', {}, 'regions').then(function (data) {
	      try {
	        if (data.data.DataSet.NewDataSet.closings && data.data.DataSet.NewDataSet.closings.length > 0) {
	          defer.resolve(true);
	          return;
	        }
	      } catch (err) {
	        console.error('Closings & Delays does not have any closings ' + err);
	      }
	
	      defer.resolve(false);
	    })['catch'](defer.reject);
	
	    return defer.promise;
	  };
	}
	
	closingsAndDelaysService.$inject = ['apiService', 'config', '$q'];
	
	var api = _angular2['default'].module('closingsAndDelaysService', []).service('closingsAndDelaysService', closingsAndDelaysService);
	
	exports['default'] = api;
	module.exports = exports['default'];

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @ngdoc service
	 * @name app.profileService
	 * @description
	 * # profileService
	 * Service to talk with backend api.
	 * @requires app.apiService
	 * @requires constants:config
	 **/
	
	/*---------------------------------------------------------*\
	 * Imports
	\*---------------------------------------------------------*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	/*---------------------------------------------------------*\
	 * regionService
	\*---------------------------------------------------------*/
	/* @ngInject */
	function profileService(apiService, config) {
	  // APIs
	  /**
	   * @ngdoc
	   * @name app.profileService#getprofile
	   * @methodOf app.profileService
	   * @example
	   * ``` js
	   * profileService.getprofile();
	   * ```
	   * @description
	   * Service to talk with backend api.
	   * It forms a string url using config relative base url, '/profile/info' string.
	   * It will call apiService.wrap function with the string formed as a param.
	   * @returns {httpPromise} Promise that will resolve into an object with the user profile information.
	   **/
	  this.getProfile = function () {
	    return apiService.wrap(config.relBaseUrlAPi + '/profile/info', {}, 'profile');
	  };
	}
	
	profileService.$inject = ['apiService', 'config'];
	
	var api = _angular2['default'].module('profileService', ['config', 'apiService']).service('profileService', profileService);
	
	exports['default'] = api;
	module.exports = exports['default'];

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @ngdoc service
	 * @name app.newsService
	 * @description
	 * # newsService
	 * Service to talk with backend api.
	 * @requires app.apiService
	 * @requires constants:config
	 **/
	/*---------------------------------------------------------*\
	 * Imports
	\*---------------------------------------------------------*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	/*---------------------------------------------------------*\
	 * regionService
	 \*---------------------------------------------------------*/
	/* @ngInject */
	function newsService(apiService, config) {
	  // APIs
	  /**
	   * @ngdoc
	   * @name app.newsService#getDataFeed
	   * @methodOf app.newsService
	   * @example
	   * ``` js
	   * newsService.getDataFeed('CT', 'local');
	   * ```
	   * @param {string} region selected region abbreviation, case 'Bronx' => 'BX',
	   * 'New Jersey' => 'NJ', max of two characters.
	   * @param {string} category string passed showing current category.
	   * @description
	   * Service to talk with backend api. It calls the apiService.wrap function,
	   * passing a relative url, the string '/news/datafeed/', and the passed in region code.
	   * @returns {array} it will return an array ob objects with the properties 'image',
	   * 'header', 'videoUrl', or  just an empty array, it will return an error if either
	   * region or category are not entered, or entered incorrectly;;
	   **/
	  this.getDataFeed = function (regionCode, category) {
	    if (!_angular2['default'].isString(regionCode) || regionCode.length !== 2) {
	      throw new Error('A two-character region code is required');
	    }
	    if (!_angular2['default'].isString(category) || !category.length) {
	      throw new Error('category is required');
	    }
	    return apiService.wrap(config.relBaseUrlAPi + '/news/datafeed/' + regionCode + '/' + category, {}, 'news').then(function (res) {
	      if (!res.data) {
	        return [];
	      }
	      var data = res.data.rss.channel.item;
	      return data.map(function (s) {
	        return {
	          image: s['media:content']['media:thumbnail'].url,
	          header: s.title,
	          videoUrl: s['media:content'].url
	        };
	      });
	    });
	  };
	}
	
	newsService.$inject = ['apiService', 'config'];
	
	var api = _angular2['default'].module('newsService', ['config', 'apiService']).service('newsService', newsService);
	
	exports['default'] = api;
	module.exports = exports['default'];

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @ngdoc service
	 * @name app.archivesService
	 * @description
	 * # Categories Service
	 * Service to talk with backend api to get archives information.
	 * @requires app.apiService
	 * @requires constants:config
	 **/
	
	/*---------------------------------------------------------*\
	 * Imports
	\*---------------------------------------------------------*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	/*---------------------------------------------------------*\
	 * regionService
	 \*---------------------------------------------------------*/
	/* @ngInject */
	function archiveService(apiService, config) {
	  // APIs
	  /**
	   * @ngdoc
	   * @name app.archivesService#getArchives
	   * @methodOf app.archivesService
	   * @param {string} regionCode selected region abbreviation, case 'Bronx' => 'BX',
	   * 'New Jersey' => 'NJ', max of two characters..
	   * @example
	   * ``` js
	   * archivesService.getArchives('LI');
	   * ```
	   * @description
	   * calls {@link app.apiService#wrap apiService.wrap} method with current base url,
	   * '/news/categories/' and regionId'.
	   * @returns {httpPromise} Promise that will resolve into an array or archives for
	   * current region. each archive will have a tumbnail, a header, and a url to its video.
	   **/
	  this.getArchives = function (regionCode) {
	    if (!_angular2['default'].isString(regionCode) || regionCode.length !== 2) {
	      throw new Error('A two-character region code is required');
	    }
	    return apiService.wrap(config.relBaseUrlAPi + '/news/archives/' + regionCode, {}, 'archives').then(function (res) {
	      if (!res.data) {
	        return [];
	      }
	      var data = res.data.rss.channel.item;
	      return data.map(function (s) {
	        return {
	          image: s['media:thumbnail'].url,
	          header: s.title,
	          videoUrl: s['media:content'].url
	        };
	      });
	    });
	  };
	}
	
	archiveService.$inject = ['apiService', 'config'];
	
	var api = _angular2['default'].module('archiveService', ['config', 'apiService']).service('archiveService', archiveService);
	
	exports['default'] = api;
	module.exports = exports['default'];

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @ngdoc service
	 * @name app.pollsService
	 * @description
	 * # pollsService
	 * Service to talk with backend api.
	 * @requires app.apiService
	 * @requires constants:config
	 **/
	
	/*---------------------------------------------------------*\
	 * Imports
	\*---------------------------------------------------------*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	/*---------------------------------------------------------*\
	 * pollsService
	\*---------------------------------------------------------*/
	/* @ngInject */
	function pollsService(apiService, config) {
	  /**
	   * @ngdoc
	   * @name app.pollsService#getQuestion
	   * @methodOf app.pollsService
	   * @example
	   * ``` js
	   * pollsService.getQuestion('LI);
	   * ```
	   * @param {string} region selected region abbreviation, case 'Bronx' => 'BX',
	   * 'New Jersey' => 'NJ', max of three characters.
	   * @description
	   * Service to talk with backend api. It calls the apiService.wrap function,
	   * passing the string formed from relative base Url, the '/polls/question/'
	   * string, and the region passed in.
	   * @returns {httpPromise} Promise that will resolve with the questionf or poll.
	   **/
	  this.getQuestion = function (regionCode) {
	    return apiService.wrap(config.relBaseUrlAPi + '/polls/question/' + regionCode, {}, 'polls.getQuestion');
	  };
	
	  /**
	   * @ngdoc
	   * @name app.pollsService#postVote
	   * @methodOf app.pollsService
	   * @example
	   * ``` js
	   * pollsService.postVote('id1', 1);
	   * ```
	   * @param {string} pollId passes the id for current poll.
	   * @param {number} choice passes the current selection.
	   * @description
	   * Service to talk with backend api. It calls the apiService.wrapPost function,
	   * passing the string formed from relative base Url, the '/polls/vote' string,
	   * the pollId, and choice passed in.
	   * @returns {httpPromise} Promise that will resolve with the question or poll.
	   **/
	  this.postVote = function (pollId, choice) {
	    return apiService.wrapPost(config.relBaseUrlAPi + '/polls/vote', {
	      pollId: pollId,
	      choice: choice.toString()
	    }, {}, 'polls.postVote');
	  };
	
	  /**
	   * @ngdoc
	   * @name app.pollsService#getResults
	   * @methodOf app.pollsService
	   * @example
	   * ``` js
	   * pollsService.getResults('id1');
	   * ```
	   * @param {string} pollId passes the id for current poll.
	   * @description
	   * Service to talk with backend api. It calls the apiService.wrapPost function,
	   * passing the string formed from relative base Url, the '/polls/results/' string,
	   * and the passed in pollId.
	   * @returns {httpPromise} Promise that will resolve with the poll results object.
	   **/
	  this.getResults = function (pollId) {
	    return apiService.wrap(config.relBaseUrlAPi + '/polls/results/' + pollId, {}, 'polls.getResults');
	  };
	}
	
	pollsService.$inject = ['apiService', 'config'];
	
	var api = _angular2['default'].module('pollsService', []).service('pollsService', pollsService);
	
	exports['default'] = api;
	module.exports = exports['default'];

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @ngdoc service
	 * @name app.photosFactory
	 * @description Photos factory.
	 * It works as local storage to carry images around the app.
	 * its structure is as follows:
	 * ``` js
	 * {
	 *  images: [],
	 *  selIndex: 0,
	 *  showImages: false,
	 *  region: undefined
	 * }
	 * ```
	 */
	
	/*---------------------------------------------------------*\
	 * Imports
	\*---------------------------------------------------------*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	exports['default'] = _angular2['default'].module('photosService').factory('photos', function () {
	  return {
	    images: [],
	    selIndex: 0,
	    showImages: false,
	    region: undefined
	  };
	});
	module.exports = exports['default'];

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var defaults = {
	  maxAge: Number.MAX_VALUE,
	  deleteOnExpire: false,
	  onExpire: null,
	  storageMode: 'sessionStorage',
	  storagePrefix: 'cachefactory.caches.',
	  storeOnResolve: false,
	  storeOnReject: false
	};
	var caches = {};
	var deps = {};
	
	// TODO move to common utils
	function isObject(obj) {
	  return obj === Object(obj);
	}
	
	function isNumber(value) {
	  return typeof value === 'number';
	}
	
	function isPromise(value) {
	  return value && typeof value.then === 'function';
	}
	// endof TODO
	
	var LocalService = (function () {
	  function LocalService($q) {
	    _classCallCheck(this, LocalService);
	
	    deps.$q = $q;
	    this.storage = this.defaults.storageMode;
	  }
	
	  _createClass(LocalService, [{
	    key: 'createCache',
	    value: function createCache(cacheId, options) {
	      if (cacheId in caches) {
	        return caches[cacheId];
	      } else if (!cacheId) {
	        throw new Error('cacheId must be a string!');
	      }
	
	      var $$promises = {};
	      var $$storage = null;
	      var $$expiresHeap = [];
	
	      var cache = caches[cacheId] = Object.defineProperties({
	
	        $$id: cacheId,
	
	        destroy: function destroy() {
	          this.removeAll();
	          $$storage.remove(this.$$prefix + '.keys');
	          $$storage.remove(this.$$prefix);
	          $$storage = null;
	          $$expiresHeap = null;
	          this.$$prefix = null;
	          delete caches[this.$$id];
	        },
	        get: function get(key, options) {
	          options = options || {};
	          if (!key) {
	            throw new Error('key must be a string');
	          }
	          if ($$promises[key]) {
	            return $$promises[key];
	          }
	          var item = $$storage.get(this.$$prefix + '.data.' + key);
	          if (!item) {
	            return undefined;
	          }
	          var value = item.value;
	          var now = new Date().getTime();
	          item.accessed = now;
	          if (this.$$deleteOnExpire && 'expires' in item && item.expires < now) {
	            this.remove(key);
	
	            if (this.$$onExpire) {
	              this.$$onExpire(key, item.value, options.onExpire);
	            } else if (options.onExpire) {
	              options.onExpire.call(this, key, item.value);
	            }
	            value = undefined;
	          } else {
	            $$storage.set(this.$$prefix + '.data.' + key, item);
	          }
	          return value;
	        },
	        keys: function keys() {
	          return $$storage.get(this.$$prefix + '.keys') || [];
	        },
	        put: function put(key, value, options) {
	          var me = this;
	
	          options = options || {};
	
	          var storeOnResolve = 'storeOnResolve' in options ? !!options.storeOnResolve : this.$$storeOnResolve;
	          var storeOnReject = 'storeOnReject' in options ? !!options.storeOnReject : this.$$storeOnReject;
	
	          var getHandler = function getHandler(store, isError) {
	            return function (v) {
	              if (store) {
	                delete $$promises[key];
	                if (isObject(v) && 'status' in v && 'data' in v) {
	                  v = [v.status, v.data, v.headers(), v.statusText];
	                  me.put(key, v);
	                } else {
	                  me.put(key, v);
	                }
	              }
	              if (isError) {
	                return deps.$q.reject(v);
	              }
	              return v;
	            };
	          };
	
	          if (value === null || value === undefined) {
	            return value;
	          }
	          if (!key) {
	            throw new Error('key must contain a string!');
	          }
	
	          var now = new Date().getTime();
	          var item = {
	            key: key,
	            value: isPromise(value) ? value.then(getHandler(storeOnResolve, false), getHandler(storeOnReject, true)) : value,
	            created: options.created === undefined ? now : options.created,
	            accessed: options.accessed === undefined ? now : options.accessed
	          };
	          if (options.maxAge) {
	            item.maxAge = options.maxAge;
	          }
	
	          if (options.expires === undefined) {
	            item.expires = item.created + (item.maxAge || this.$$maxAge);
	          } else {
	            item.expires = options.expires;
	          }
	
	          if (isPromise(item.value)) {
	            $$promises[key] = item.value;
	            return item.value;
	          }
	
	          // Remove existing
	          if ($$storage.get(this.$$prefix + '.data.' + key)) {
	            this.remove(key);
	          }
	          // Add to expires heap
	          $$expiresHeap.push({
	            key: key,
	            expires: item.expires
	          });
	
	          var keys = this.keys();
	
	          // Set item
	          $$storage.set(this.$$prefix + '.data.' + key, item);
	          var exists = false;
	          for (var i = 0; i < keys.length; i++) {
	            if (keys[i] === key) {
	              exists = true;
	              break;
	            }
	          }
	          if (!exists) {
	            keys.push(key);
	          }
	          $$storage.set(this.$$prefix + '.keys', keys);
	          return value;
	        },
	        remove: function remove(key) {
	          key += ''; // convert number keys to string
	          delete $$promises[key];
	          var item = $$storage.get(this.$$prefix + '.data.' + key);
	          if (!item) {
	            return null;
	          }
	
	          // search and remove element based on key
	          for (var i = 0, len = $$expiresHeap.length; i < len; i++) {
	            if (key === $$expiresHeap[i].key) {
	              $$expiresHeap.splice(i, 1);
	              break;
	            }
	          }
	          $$storage.remove(this.$$prefix + '.data.' + key);
	          var keys = $$storage.get(this.$$prefix + '.keys') || [];
	          var index = keys.indexOf(key);
	
	          if (index >= 0) {
	            keys.splice(index, 1);
	          }
	          $$storage.set(this.$$prefix + '.keys', keys);
	          return item.value;
	        },
	        removeAll: function removeAll() {
	          $$expiresHeap = [];
	          var keys = $$storage.get(this.$$prefix + '.keys');
	
	          if (keys) {
	            for (var i = 0; i < keys.length; i++) {
	              this.remove(keys[i]);
	            }
	          }
	          $$storage.set(this.$$prefix + '.keys', []);
	          $$promises = {};
	        },
	        removeExpired: function removeExpired() {
	          var now = new Date().getTime();
	          var expired = {};
	          var key = undefined;
	
	          // search and remove elements that expired
	          for (var i = 0, len = $$expiresHeap.length; i < len; i++) {
	            var expiredItem = $$expiresHeap[i];
	            if (expiredItem.expires <= now) {
	              expired[expiredItem.key] = expiredItem.value || null;
	            }
	          }
	
	          for (key in expired) {
	            if (({}).hasOwnProperty.call(expired, key)) {
	              var item = $$storage.get(this.$$prefix + '.data.' + key);
	              if (item) {
	                expired[key] = item.value;
	                this.remove(key);
	              }
	            }
	          }
	
	          if (this.$$onExpire) {
	            for (key in expired) {
	              if (({}).hasOwnProperty.call(expired, key)) {
	                this.$$onExpire(key, expired[key]);
	              }
	            }
	          }
	
	          return expired;
	        },
	
	        setOptions: function setOptions(cacheOptions) {
	          cacheOptions = cacheOptions || {};
	          if (!isObject(cacheOptions)) {
	            throw new Error('cacheOptions must be an object!');
	          }
	
	          $$storage = new LocalService(deps.$q);
	
	          this.$$storagePrefix = defaults.storagePrefix;
	          if ('storagePrefix' in cacheOptions) {
	            this.$$storagePrefix = cacheOptions.storagePrefix;
	          }
	
	          this.$$prefix = this.$$storagePrefix + this.$$id;
	
	          this.storageMode = defaults.storageMode;
	          if ('storageMode' in cacheOptions) {
	            this.storageMode = cacheOptions.storageMode || defaults.storageMode;
	          }
	
	          this.$$deleteOnExpire = defaults.deleteOnExpire;
	          if ('deleteOnExpire' in cacheOptions) {
	            this.$$deleteOnExpire = cacheOptions.deleteOnExpire;
	          }
	
	          this.maxAge = defaults.maxAge;
	          if ('maxAge' in cacheOptions) {
	            this.maxAge = cacheOptions.maxAge;
	          }
	
	          this.$$storeOnResolve = defaults.storeOnResolve;
	          if ('storeOnResolve' in cacheOptions) {
	            this.$$storeOnResolve = !!cacheOptions.storeOnResolve;
	          }
	
	          this.$$storeOnReject = defaults.storeOnReject;
	          if ('storeOnReject' in cacheOptions) {
	            this.$$storeOnReject = !!cacheOptions.storeOnReject;
	          }
	
	          this.$$onExpire = defaults.onExpire;
	          if ('onExpire' in cacheOptions) {
	            this.$$onExpire = cacheOptions.onExpire;
	          }
	        },
	
	        values: function values() {
	          var keys = this.keys();
	          var items = [];
	          for (var i = 0; i < keys.length; i++) {
	            items.push(this.get(keys[i]));
	          }
	          return items;
	        }
	      }, {
	        maxAge: {
	          get: function get() {
	            return this.$$maxAge;
	          },
	          set: function set(maxAge) {
	            if (maxAge === null) {
	              this.$$maxAge = Number.MAX_VALUE;
	            }
	            if (!isNumber(maxAge)) {
	              throw new Error('maxAge must be a number');
	            }
	            if (maxAge < 0) {
	              throw new Error('maxAge must be greater than zero');
	            }
	            this.$$maxAge = maxAge;
	            var i = undefined;
	            var key = undefined;
	
	            $$expiresHeap = [];
	
	            var keys = $$storage.get(this.$$prefix + '.keys') || [];
	
	            for (i = 0; i < keys.length; i++) {
	              key = keys[i];
	              var item = $$storage.get(this.$$prefix + '.data.' + key);
	
	              if (item) {
	                if (this.$$maxAge === Number.MAX_VALUE) {
	                  item.expires = Number.MAX_VALUE;
	                } else {
	                  item.expires = item.created + (item.maxAge || this.$$maxAge);
	                }
	                $$expiresHeap.push({
	                  key: key,
	                  expires: item.expires
	                });
	              }
	            }
	
	            if (this.$$deleteOnExpire) {
	              return this.removeExpired();
	            }
	            return {};
	          },
	          configurable: true,
	          enumerable: true
	        },
	        storageMode: {
	          get: function get() {
	            return $$storage.storage;
	          },
	          set: function set(storageMode) {
	            if (!storageMode) {
	              throw new Error('storageMode must be a string!');
	            }
	            if (storageMode !== 'localStorage' && storageMode !== 'sessionStorage') {
	              throw new Error('storageMode must be "localStorage" or "sessionStorage"!');
	            }
	            $$storage.storage = storageMode;
	          },
	          configurable: true,
	          enumerable: true
	        }
	      });
	
	      cache.setOptions(options);
	
	      return cache;
	    }
	  }, {
	    key: 'get',
	    value: function get(key) {
	      try {
	        var val = this.storage.getItem(key);
	        return val ? JSON.parse(val) : null;
	      } catch (e) {
	        return undefined;
	      }
	    }
	  }, {
	    key: 'set',
	    value: function set(key, val) {
	      if (val !== undefined) {
	        this.storage.setItem(key, JSON.stringify(val));
	      }
	    }
	  }, {
	    key: 'remove',
	    value: function remove(key) {
	      return this.storage.removeItem(key);
	    }
	  }, {
	    key: 'defaults',
	    get: function get() {
	      return this.constructor.defaults;
	    }
	  }, {
	    key: 'storage',
	    get: function get() {
	      return this._storage;
	    },
	    set: function set(type) {
	      var storageTypes = {
	        localStorage: localStorage,
	        sessionStorage: sessionStorage
	      };
	      this._storage = storageTypes[type];
	    }
	  }], [{
	    key: 'factory',
	    value: function factory($q) {
	      return new LocalService($q);
	    }
	  }]);
	
	  return LocalService;
	})();
	
	LocalService.defaults = defaults;
	
	LocalService.factory.$inject = ['$q'];
	
	var _module = _angular2['default'].module('localService', []).factory('localService', LocalService.factory);
	
	exports['default'] = _module;
	module.exports = exports['default'];

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @ngdoc service
	 * @name app.weatherCurrentService
	 * @description
	 * # WeatherCurrentService
	 * Service to talk with backend api.
	 * @requires app.apiService
	**/
	
	/*---------------------------------------------------------*\
	 * Imports
	\*---------------------------------------------------------*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	/*---------------------------------------------------------*\
	 * photosService
	\*---------------------------------------------------------*/
	/* @ngInject */
	function weatherCurrentService(apiService) {
	  /**
	   * @ngdoc
	   * @name app.weatherCurrentService#getWeatherSubMenu
	   * @methodOf app.weatherCurrentService
	   * @example
	   * ``` js
	   * weatherCurrentService.getWeatherSubMenu('LI')
	   * ```
	   * @param {string} region selected region abbreviation, case 'Bronx' => 'BX',
	   * 'New Jersey' => 'NJ', max of three characters.
	   * @description
	   * Service to talk with backend api. It calls the apiService.wrap function,
	   * passing a region code.
	   * @returns {httpPromise} Promise that will resolve into a string url, or it
	   * Will throw an error if region code is not a string or is the incorrect length.
	   **/
	  this.getWeatherSubMenu = function (region) {
	    if (_angular2['default'].isString(region) && region.length < 3) {
	      return apiService.wrap('/api/v1/weather/' + region, {});
	      // return apiService.wrap('http://localhost:6080/api/v1/weather/' + region, {});
	    }
	    return new Error('Invalid Region Code');
	  };
	}
	
	weatherCurrentService.$inject = ['apiService'];
	
	var api = _angular2['default'].module('weatherCurrentService', []).service('weatherCurrentService', weatherCurrentService);
	
	exports['default'] = api;
	module.exports = exports['default'];

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	/*---------------------------------------------------------*\
	 * Imports
	\*---------------------------------------------------------*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	/*---------------------------------------------------------*\
	 * photosService
	\*---------------------------------------------------------*/
	/* @ngInject */
	function trafficService(apiService) {
	  this.getTrafficDelays = function (region) {
	    if (_angular2['default'].isString(region) && region.length < 3) {
	      return apiService.wrap('/api/v1/traffic/incidents/' + region, {});
	    }
	    return new Error('Invalid Region Code');
	  };
	  this.getTrafficCameras = function (region) {
	    if (_angular2['default'].isString(region) && region.length < 3) {
	      return apiService.wrap('/api/v1/traffic/camera/' + region, {}, 'cameras');
	    }
	    return new Error('Invalid Region Code');
	  };
	  this.getTrafficPlaypauseMaps = function (region) {
	    if (_angular2['default'].isString(region) && region.length < 3) {
	      return apiService.wrap('/api/v1/traffic/playpause/' + region, {});
	    }
	    return new Error('Invalid Region Code');
	  };
	}
	
	trafficService.$inject = ['apiService'];
	
	var api = _angular2['default'].module('trafficService', []).service('trafficService', trafficService);
	
	exports['default'] = api;
	module.exports = exports['default'];

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * AuthHelper
	 *
	 * JWT Token helper functions
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var WINDOW = new WeakMap();
	
	var AuthHelper = (function () {
	  /* ----------------------------------- *\
	   * Constructor
	   \* ----------------------------------- */
	
	  function AuthHelper($window) {
	    _classCallCheck(this, AuthHelper);
	
	    WINDOW.set(this, $window);
	  }
	
	  _createClass(AuthHelper, [{
	    key: 'urlBase64Decode',
	    value: function urlBase64Decode(str) {
	      var output = str.replace(/-/g, '+').replace(/_/g, '/');
	      switch (output.length % 4) {
	        case 0:
	          {
	            break;
	          }
	        case 2:
	          {
	            output += '==';break;
	          }
	        case 3:
	          {
	            output += '=';break;
	          }
	        default:
	          {
	            throw new Error('Illegal base64url string!');
	          }
	      }
	      // polyfill https://github.com/davidchambers/Base64.js
	      return WINDOW.get(this).decodeURIComponent(WINDOW.get(this).escape(WINDOW.get(this).atob(output)));
	    }
	  }, {
	    key: 'decodeToken',
	    value: function decodeToken(token) {
	      var parts = token.split('.');
	      if (parts.length !== 3) {
	        throw new Error('JWT must have 3 parts');
	      }
	      var decoded = this.urlBase64Decode(parts[1]);
	      if (!decoded) {
	        throw new Error('Cannot decode the token');
	      }
	      return _angular2['default'].fromJson(decoded);
	    }
	  }, {
	    key: 'getTokenExpirationDate',
	    value: function getTokenExpirationDate(token) {
	      var decoded = this.decodeToken(token);
	      if (typeof decoded.exp === 'undefined') {
	        return null;
	      }
	      var d = new Date(0); // The 0 here is the key, which sets the date to the epoch
	      d.setUTCSeconds(decoded.exp);
	      return d;
	    }
	  }, {
	    key: 'isTokenExpired',
	    value: function isTokenExpired(token, offsetSeconds) {
	      if (!token) {
	        return true;
	      }
	      var d = undefined;
	      if (token === Object(token) && token.ttl) {
	        d = new Date(0); // The 0 here is the key, which sets the date to the epoch
	        d.setUTCSeconds(token.ttl);
	      } else {
	        d = this.getTokenExpirationDate(token);
	      }
	      offsetSeconds = offsetSeconds || 0;
	      if (d === null) {
	        return false;
	      }
	      // Token expired?
	      var exp = d.getTime() > new Date().getTime() + offsetSeconds * 1000;
	      return !exp;
	    }
	  }], [{
	    key: 'factory',
	    value: function factory($window) {
	      return new AuthHelper($window);
	    }
	  }]);
	
	  return AuthHelper;
	})();
	
	AuthHelper.factory.$inject = ['$window'];
	
	var _module = _angular2['default'].module('auth.authHelper', []).factory('authHelper', AuthHelper.factory);
	
	exports['default'] = _module;
	module.exports = exports['default'];

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * authInterceptor
	 *
	 * Interceptor hooks up to all http requests and plugs authorization header from cached jwt token.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _pubsubJs = __webpack_require__(32);
	
	var _pubsubJs2 = _interopRequireDefault(_pubsubJs);
	
	var tokenName = 'jwt_token';
	
	var _module = _angular2['default'].module('auth.authInterceptor', ['constants', 'config']).factory('authInterceptor', ['$q', 'config', 'topics', 'localService', function ($q, config, topics, localService) {
	  return {
	    request: function request(_request) {
	      if (_request.skipAuthorization || _request.url.indexOf(config.relBaseUrlAPi) !== 0) {
	        return _request;
	      }
	
	      var token = undefined;
	      if (localService.get(tokenName)) {
	        token = _angular2['default'].fromJson(localService.get(tokenName));
	      }
	      // is token an object?
	      if (token === Object(token)) {
	        token = token.token;
	      }
	      if (token) {
	        _request.headers.Authorization = 'Bearer ' + token;
	      }
	      return _request;
	    },
	    responseError: function responseError(response) {
	      if (response.status === 401) {
	        localService.remove(tokenName);
	        _pubsubJs2['default'].publish(topics.auth.unauthenticated, response);
	      }
	      if (response.status === 403) {
	        _pubsubJs2['default'].publish(topics.auth.unauthorized, response);
	      }
	      _pubsubJs2['default'].publish(topics.auth.failed, response);
	      return $q.reject(response);
	    }
	  };
	}]).config(['$httpProvider', function ($httpProvider) {
	  $httpProvider.interceptors.push('authInterceptor');
	}]);
	
	exports['default'] = _module;
	module.exports = exports['default'];

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	// TODO move to common utils
	function parseQuery(qstr) {
	  var query = {};
	  if (qstr.length < 2) {
	    return query;
	  }
	  var params = qstr.substr(1).split('&');
	  for (var i = 0; i < params.length; i++) {
	    var parts = params[i].split('=');
	    var key = parts.shift();
	    query[decodeURIComponent(key)] = decodeURIComponent(parts.join('=') || '');
	  }
	  return query;
	}
	
	// map to hold dependencies and expose them outside of the constructor initialization
	var deps = {};
	
	var AuthService = (function () {
	  /* ----------------------------------- *\
	   * Constructor
	  \* ----------------------------------- */
	
	  function AuthService($http, $q, $window, config, localService, authHelper, storageKeys) {
	    _classCallCheck(this, AuthService);
	
	    deps.$http = $http;
	    deps.$q = $q;
	    deps.$window = $window;
	    deps.config = config;
	    deps.localService = localService;
	    deps.authHelper = authHelper;
	    deps.storageKeys = storageKeys;
	  }
	
	  _createClass(AuthService, [{
	    key: 'getToken',
	    value: function getToken() {
	      var localService = deps.localService;
	      return localService.get('jwt_token');
	    }
	  }, {
	    key: 'isAuthorized',
	    value: function isAuthorized() {
	      var jwt = this.getToken();
	      return !!jwt && !deps.authHelper.isTokenExpired(jwt);
	    }
	  }, {
	    key: 'authorize',
	    value: function authorize() {
	      var config = deps.config;
	      var localService = deps.localService;
	      var $http = deps.$http;
	      var $q = deps.$q;
	      var $window = deps.$window;
	      var params = parseQuery($window.location.search);
	      var authToken = params.auth_token;
	      var mockData = params.mockdata;
	      // fetch authToken from url and store for future use
	      if (authToken) {
	        localService.set(deps.storageKeys.authToken, authToken);
	      } else {
	        authToken = localService.get(deps.storageKeys.authToken);
	      }
	
	      // if there is a mock data flag in the URL we set it in storage to mock user data
	      // after authorizing for testing purposes. This will most of the time contain
	      // an IP address which is used by the server to detect the user profile and authorize the request
	      // for testers outside of a Altice network, we need to use a mock IP to test the geolocation.
	      if (mockData) {
	        localService.set(deps.storageKeys.mockData, mockData);
	      }
	
	      var data = {
	        authToken: authToken
	      };
	
	      if (this.isAuthorized()) {
	        return $q.resolve(this.getToken());
	      }
	      if (!data.authToken) {
	        return $q.reject('Auth token missing');
	      }
	      // return a promise that returns the jwt token
	      return $http({
	        url: config.relBaseUrlAuthAPi + '/authorize',
	        // This will not send the JWT for this call
	        skipAuthorization: true,
	        method: 'POST',
	        data: data
	      }).then(function (response) {
	        localService.set('jwt_token', response.data);
	        return response.data;
	      });
	    }
	  }, {
	    key: 'unauthorize',
	    value: function unauthorize() {
	      // The backend doesn't care about logouts, delete the token and you're good to go.
	      var localService = deps.localService;
	      localService.remove('jwt_token');
	    }
	  }], [{
	    key: 'factory',
	    value: function factory($http, $q, $window, config, localService, authHelper, storageKeys) {
	      return new AuthService($http, $q, $window, config, localService, authHelper, storageKeys);
	    }
	  }]);
	
	  return AuthService;
	})();
	
	AuthService.factory.$inject = ['$http', '$q', '$window', 'config', 'localService', 'authHelper', 'storageKeys'];
	
	var _module = _angular2['default'].module('auth', ['auth.authHelper', 'auth.authInterceptor', 'localService', 'config', 'constants']).factory('authService', AuthService.factory);
	
	exports['default'] = _module;
	module.exports = exports['default'];

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _htmlToPlaintextHtmlToPlaintext = __webpack_require__(273);
	
	var _htmlToPlaintextHtmlToPlaintext2 = _interopRequireDefault(_htmlToPlaintextHtmlToPlaintext);
	
	var filterModule = _angular2['default'].module('app.filters', [_htmlToPlaintextHtmlToPlaintext2['default'].name]);
	
	exports['default'] = filterModule;
	module.exports = exports['default'];

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	/*---------------------------------------------------------*\
	 * Imports
	 \*---------------------------------------------------------*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	/*---------------------------------------------------------*\
	 * livefeedService
	 \*---------------------------------------------------------*/
	/* @ngInject */
	
	var HtmlToPlaintext = (function () {
	  HtmlToPlaintext.$inject = ["text"];
	  function HtmlToPlaintext(text) {
	    _classCallCheck(this, HtmlToPlaintext);
	
	    this.text = text;
	  }
	
	  _createClass(HtmlToPlaintext, [{
	    key: 'stripHtml',
	    value: function stripHtml() {
	      return this.text ? String(this.text).replace(/<[^>]+>/gm, '') : '';
	    }
	  }], [{
	    key: 'HtmlToPlaintextFactory',
	    value: function HtmlToPlaintextFactory(text) {
	      var filter = new HtmlToPlaintext(text);
	      return filter.stripHtml();
	    }
	  }]);
	
	  return HtmlToPlaintext;
	})();
	
	var filter = _angular2['default'].module('htmlToPlaintext', []).filter('htmlToPlaintext', function () {
	  return HtmlToPlaintext.HtmlToPlaintextFactory;
	});
	
	exports['default'] = filter;
	module.exports = exports['default'];

/***/ },
/* 274 */
/***/ function(module, exports) {

	// import appRun from './app.run';
	
	'use strict';
	
	AppConfig.$inject = ["$locationProvider", "$urlRouterProvider", "$stateProvider"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	function AppConfig($locationProvider, $urlRouterProvider, $stateProvider) {
	  'ngInject';
	
	  $locationProvider.html5Mode(true);
	  $urlRouterProvider.otherwise('/');
	
	  $stateProvider.state('app', {
	    abstract: true,
	    views: {
	      '@': {
	        template: '<app></app>'
	      }
	    }
	  });
	}
	
	exports['default'] = AppConfig;
	module.exports = exports['default'];

/***/ },
/* 275 */
/***/ function(module, exports) {

	'use strict';
	
	AppRun.$inject = ["$document", "$rootScope", "$state", "localService", "navigationService", "storageKeys", "states", "appName"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	function AppRun($document, $rootScope, $state, localService, navigationService, storageKeys, states, appName) {
	  'ngInject';
	
	  // NOTE navigationService is purely included for initialization.
	
	  // access to $state from templates
	  $rootScope.$state = $state;
	
	  // record old state and change page title based on state
	  $rootScope.$on('$stateChangeStart', function (event, to, toParams, from, fromParams) {
	    // save the previous state in a rootScope variable so that it's accessible from everywhere
	    $rootScope.previousState = from;
	    $rootScope.previousParams = fromParams;
	    if (from.sticky !== false) {
	      $rootScope.previousActiveElement = $document[0].activeElement;
	    }
	    $rootScope.setPageTitle(to.title);
	    var region = localService.get(storageKeys.selectedRegion);
	    if (!region && to.name && to.name !== states.regionSelectionLanding) {
	      // no default region detected. go to region selection page
	      console.log('## APP ## Redirect to region selection');
	      if (from.name !== states.regionSelectionLanding) {
	        event.preventDefault();
	        $state.go(states.regionSelectionLanding, {}, { location: 'replace' });
	      }
	    }
	  });
	  // Helper method for setting the page's title
	  $rootScope.setPageTitle = function (title) {
	    $rootScope.pageTitle = '';
	    if (title) {
	      $rootScope.pageTitle += title.en;
	      $rootScope.pageTitle += ' — ';
	    }
	    $rootScope.pageTitle += appName;
	  };
	}
	
	exports['default'] = AppRun;
	module.exports = exports['default'];

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	_angular2['default'].module('constants', []).constant('topics', {
	  nav: {
	    allKeys: 'navigation.key',
	    up: 'navigation.key.up',
	    down: 'navigation.key.down',
	    left: 'navigation.key.left',
	    right: 'navigation.key.right',
	    enter: 'navigation.key.enter'
	  },
	  state: {
	    reactivate: 'state.reactivate',
	    inactivate: 'state.inactivate',
	    enter: 'state.enter',
	    exit: 'state.exit'
	  },
	  component: {
	    selectPhotos: 'select.photos',
	    slideshowToggle: 'slideshow.toggle',
	    enlargedSlideshow: 'enlarged.slideshow'
	  },
	  regions: {
	    select: 'regions.select'
	  },
	  headerMain: {
	    selectTab: 'headerMain.selectTab',
	    selectSection: 'headerMain.selectSection',
	    menuReady: 'headerMain.menuReady',
	    resetSubnav: 'headerMain.resetSubnav'
	  },
	  auth: {
	    unauthenticated: 'auth.unauthenticated',
	    unauthorized: 'auth.unauthorized',
	    failed: 'auth.failed'
	  },
	  remoteKeys: {
	    allKeys: 'remote.key',
	    play: 'remote.key.play',
	    pause: 'remote.key.pause',
	    forward: 'remote.key.forward',
	    rewind: 'remote.key.rewind',
	    back: 'remote.key.back'
	  },
	  playerStates: {
	    name: 'playerStates',
	    play: {
	      name: 'play',
	      scrubSpeed: 1
	    },
	    pause: {
	      name: 'pause',
	      scrubSpeed: 0
	    },
	    rewind: {
	      name: 'rewind',
	      scrubSpeed: -2
	    },
	    forward: {
	      name: 'forward',
	      scrubSpeed: 2
	    },
	    stop: {
	      name: 'stop',
	      scrubSpeed: 0
	    }
	  },
	  ads: {
	    refreshAd: 'refreshAd'
	  }
	}).constant('cacheExpiry', {
	  'default': 5 * 60 * 1000
	}).constant('storageKeys', {
	  selectedRegion: 'selected-region',
	  regions: 'regions',
	  profile: 'profile',
	  authToken: 'auth_token',
	  mockData: 'mock-data',
	  jwtToken: 'jwt_token',
	  adPlayCount: 'ad-play-count'
	}).constant('adProps', {
	  home: {
	    sectionName: 'home',
	    rightBannerLocation: 'right',
	    bottomBannerLocation: 'footer_center',
	    previousElement: 'adProps.previousElement'
	  },
	  photos: {
	    sectionName: 'photos',
	    leftBannerLocation: 'left',
	    leftBottomBannerLocation: 'footer_left',
	    rightBottomBannerLocation: 'footer_right'
	  }
	}).constant('states', {
	  home: 'app.home.news',
	  io_extra: 'app.home.extra',
	  in_depth: 'app.home.inDepth',
	  features: 'app.home.features',
	  enlargedLiveFeed: 'app.enlargedLivefeed',
	  gallery: 'app.gallery',
	  photos: 'app.home.photos',
	  weather_center: 'app.home.weatherhome',
	  weather: 'app.home.weather',
	  traffic_center: 'app.home.traffichome',
	  traffic: 'app.home.traffic',
	  videoplayer: 'app.videoplayer',
	  closingsAndDelays: 'app.home.closingsAndDelays',
	  regionSelectionLanding: 'app.regionSelectionLanding'
	}).constant('adRotationFrequency', 3).constant('appName', 'News12');

/***/ },
/* 277 */
/***/ function(module, exports) {

	module.exports = {
		"relBaseUrlAPi": "/api/v1",
		"relBaseUrlAuthAPi": "/v1",
		"absBaseUrlLiveFeed": "http://hls.iptv.optimum.net/news12/nipadlive/index_new.m3u8?callsign={callSign}",
		"absBaseUrlWeatherIcons": "http://images.itv.weather.news12.com/weather/images/612_36H_{regionId}.png?timestamp={timestamp}",
		"sessionStorageCacheExpiryMs": 300000
	};

/***/ }
]);


/** WEBPACK FOOTER **
 ** app.bundle.js
 **/